var co = Object.defineProperty, lo = Object.defineProperties;
var so = Object.getOwnPropertyDescriptors;
var La = Object.getOwnPropertySymbols;
var Jr = Object.prototype.hasOwnProperty, e_ = Object.prototype.propertyIsEnumerable;
var yr = (e, a, r) => a in e ? co(e, a, { enumerable: !0, configurable: !0, writable: !0, value: r }) : e[a] = r, k = (e, a) => {
  for (var r in a || (a = {}))
    Jr.call(a, r) && yr(e, r, a[r]);
  if (La)
    for (var r of La(a))
      e_.call(a, r) && yr(e, r, a[r]);
  return e;
}, E = (e, a) => lo(e, so(a));
var F = (e, a) => {
  var r = {};
  for (var _ in e)
    Jr.call(e, _) && a.indexOf(_) < 0 && (r[_] = e[_]);
  if (e != null && La)
    for (var _ of La(e))
      a.indexOf(_) < 0 && e_.call(e, _) && (r[_] = e[_]);
  return r;
};
var wr = (e, a, r) => yr(e, typeof a != "symbol" ? a + "" : a, r);
import { jsx as t, jsxs as f, Fragment as ne } from "react/jsx-runtime";
import * as g from "react";
import { createContext as uo, useContext as mo, useState as Jt, useEffect as at, useMemo as qt, useRef as Hr, useReducer as po, useCallback as Ga, memo as go } from "react";
import { ChevronDown as Ht, Check as xa, Close as Ue, Info as Na, Warning as T_, CheckCircle as zr, Block as A_, ChevronRight as ir, VisibilityOn as ho, VisibilityOff as fo, ChevronUp as cr, Person as bo, DoubleArrowLeft as vo, ChevronLeft as ko, DoubleArrowRight as yo, People as wo, Bot as Co, Add as $o, ChatBotColored as No, PersonAdd as So, TextLogoFull as xo, LiveChatMono as Bo, ChatBotMono as Eo, HelpDeskMono as Io, KnowledgeBaseMono as To, OpenWidgetMono as Ao, HelloMono as Do, TextLogo as Po, Search as Fo, LockBlack as Ro, Refresh as Mo, Error as Oo } from "@livechat/design-system-icons";
import u from "clsx";
import { useFloatingParentNodeId as lr, useFloatingNodeId as Ba, useFloating as Ea, offset as Ia, flip as sr, size as D_, autoUpdate as Ta, useClick as Aa, useDismiss as Da, useRole as Pa, useInteractions as Fa, useTransitionStyles as Vr, FloatingNode as ta, FloatingTree as dr, shift as Wr, arrow as Lo, hide as Go, useHover as Uo, safePolygon as Ho, useFocus as zo, useTransitionStatus as Vo, FloatingArrow as Wo, FloatingPortal as ea, FloatingFocusManager as Fr, useListNavigation as Ko, FloatingOverlay as Yo } from "@floating-ui/react";
import * as Xo from "react-dom";
import { flushSync as Zo, createPortal as qo } from "react-dom";
import P_ from "lodash.debounce";
import { Virtuoso as jo } from "react-virtuoso";
import { getContrast as Kr } from "polished";
import Qo from "react-day-picker";
import { subMonths as jt, differenceInCalendarMonths as t_, addMonths as a_, isSameMonth as Rr, isSameDay as Mr, isAfter as Or, differenceInCalendarDays as Yr, isPast as Jo } from "date-fns";
import r_ from "lodash.escape";
import { TransitionGroup as F_, CSSTransition as R_ } from "react-transition-group";
const Ql = {
  /** @deprecated */
  Background: "--background",
  Background01: "--background-01",
  Background02: "--background-02",
  Background03: "--background-03",
  /** @deprecated */
  SurfaceBasicDefault: "--surface-basic-default",
  SurfacePrimaryDefault: "--surface-primary-default",
  /** @deprecated */
  SurfaceBasicSubtle: "--surface-basic-subtle",
  SurfaceSecondaryDefault: "--surface-secondary-default",
  SurfaceSecondaryHover: "--surface-secondary-hover",
  SurfaceSecondaryActive: "--surface-secondary-active",
  SurfaceSecondaryDisabled: "--surface-secondary-disabled",
  /** @deprecated */
  SurfacePrimaryHoverOpacity: "--surface-primary-hover-opacity",
  /** @deprecated */
  SurfaceBasicHover: "--surface-basic-hover",
  SurfacePrimaryHover: "--surface-primary-hover",
  /** @deprecated */
  SurfaceBasicActive: "--surface-basic-active",
  SurfacePrimaryActive: "--surface-primary-active",
  SurfacePrimaryActiveColored: "--surface-primary-active-colored",
  /** @deprecated */
  SurfaceBasicDisabled: "--surface-basic-disabled",
  SurfacePrimaryDisabled: "--surface-primary-disabled",
  SurfaceTertiaryDefault: "--surface-tertiary-default",
  /** @deprecated */
  SurfaceSecondarySubtle: "--surface-secondary-subtle",
  SurfaceModerateDefault: "--surface-moderate-default",
  SurfaceModerateHover: "--surface-moderate-hover",
  SurfaceModerateActive: "--surface-moderate-active",
  SurfaceTertiaryHover: "--surface-tertiary-hover",
  SurfaceTertiaryActive: "--surface-tertiary-active",
  SurfaceTertiaryDisabled: "--surface-tertiary-disabled",
  /** @deprecated */
  SurfaceFeedbackInfo: "--surface-feedback-info",
  SurfaceAccentEmphasisLowInfo: "--surface-accent-emphasis-low-info",
  /** @deprecated */
  SurfaceFeedbackNegative: "--surface-feedback-negative",
  SurfaceAccentEmphasisLowNegative: "--surface-accent-emphasis-low-negative",
  /** @deprecated */
  SurfaceFeedbackWarning: "--surface-feedback-warning",
  SurfaceAccentEmphasisLowWarning: "--surface-accent-emphasis-low-warning",
  /** @deprecated */
  SurfaceFeedbackPositive: "--surface-feedback-positive",
  SurfaceAccentEmphasisLowPositive: "--surface-accent-emphasis-low-positive",
  SurfaceAccentEmphasisLowPurple: "--surface-accent-emphasis-low-purple",
  SurfaceAccentEmphasisMinInfo: "--surface-accent-emphasis-min-info",
  SurfaceAccentEmphasisMinNegative: "--surface-accent-emphasis-min-negative",
  SurfaceAccentEmphasisMinWarning: "--surface-accent-emphasis-min-warning",
  SurfaceAccentEmphasisMinPositive: "--surface-accent-emphasis-min-positive",
  SurfaceAccentEmphasisMinPurple: "--surface-accent-emphasis-min-purple",
  SurfaceAccentOndarkNegativeDefault: "--surface-accent-ondark-negative-default",
  SurfaceAccentOndarkNegativeHover: "--surface-accent-ondark-negative-hover",
  SurfaceAccentOndarkWarningDefault: "--surface-accent-ondark-warning-default",
  SurfaceAccentOndarkWarningHover: "--surface-accent-ondark-warning-hover",
  SurfaceAccentOndarkInfoDefault: "--surface-accent-ondark-info-default",
  SurfaceAccentOndarkInfoHover: "--surface-accent-ondark-info-hover",
  SurfaceAccentOndarkPositiveDefault: "--surface-accent-ondark-positive-default",
  SurfaceAccentOndarkPositiveHover: "--surface-accent-ondark-positive-hover",
  SurfaceAccentEmphasisSubtleNegative: "--surface-accent-emphasis-subtle-negative",
  SurfaceAccentEmphasisSubtleWarning: "--surface-accent-emphasis-subtle-warning",
  SurfaceAccentEmphasisSubtleInfo: "--surface-accent-emphasis-subtle-info",
  SurfaceAccentEmphasisSubtlePositive: "--surface-accent-emphasis-subtle-positive",
  /** @deprecated */
  SurfaceInvertDefault: "--surface-invert-default",
  SurfaceInvertPrimary: "--surface-invert-primary",
  /** @deprecated */
  SurfaceInvertSubtle: "--surface-invert-subtle",
  SurfaceInvertSecondary: "--surface-invert-secondary",
  SurfaceInvertDisabled: "--surface-invert-disabled",
  SurfaceLockedDefault: "--surface-locked-default",
  SurfaceLockedHover: "--surface-locked-hover",
  SurfaceLockedActive: "--surface-locked-active",
  SurfaceLockedDisabled: "--surface-locked-disabled",
  SurfaceLockedWhite: "--surface-locked-white",
  SurfaceLockedBlack: "--surface-locked-black",
  SurfaceAccentEmphasisMediumNegative: "--surface-accent-emphasis-medium-negative",
  SurfaceAccentEmphasisMediumPositive: "--surface-accent-emphasis-medium-positive",
  SurfaceAccentEmphasisHighInfo: "--surface-accent-emphasis-high-info",
  SurfaceAccentEmphasisHighNegative: "--surface-accent-emphasis-high-negative",
  SurfaceAccentEmphasisHighWarning: "--surface-accent-emphasis-high-warning",
  SurfaceAccentEmphasisHighPositive: "--surface-accent-emphasis-high-positive",
  SurfaceAccentEmphasisHighPurple: "--surface-accent-emphasis-high-purple",
  SurfaceOpacityBasicHover: "--surface-opacity-basic-hover",
  SurfaceOpacityBasicActive: "--surface-opacity-basic-active",
  SurfaceOpacityInvertHover: "--surface-opacity-invert-hover",
  SurfaceOpacityInvertActive: "--surface-opacity-invert-active",
  /** @deprecated */
  SurfaceOverlay: "--surface-overlay",
  SurfaceGradient01: "--surface-gradient-01",
  SurfaceGradient02: "--surface-gradient-02",
  SurfaceGradient03: "--surface-gradient-03",
  SurfaceGradient04: "--surface-gradient-04",
  SurfaceGradient05: "--surface-gradient-05",
  SurfaceGradient06: "--surface-gradient-06",
  SurfaceGradient07: "--surface-gradient-07",
  SurfaceGradient08: "--surface-gradient-08",
  SurfaceGradient09: "--surface-gradient-09",
  SurfaceGradient10: "--surface-gradient-10",
  SurfaceGradient11: "--surface-gradient-11",
  SurfaceGradient12: "--surface-gradient-12",
  SurfaceGradient13: "--surface-gradient-13",
  SurfaceGradient14: "--surface-gradient-14",
  SurfaceOtherOverlay: "--surface-other-overlay",
  SurfaceOtherAgent: "--surface-other-agent",
  SurfaceOtherAgentHover: "--surface-other-agent-hover",
  SurfaceOtherSkeleton: "--surface-other-skeleton",
  /** @deprecated */
  SurfaceOtherInternalNote: "--surface-other-internal-note",
  SurfaceOtherInternalNoteHover: "--surface-other-internal-note-hover",
  SurfaceOtherVisitor: "--surface-other-visitor",
  SurfaceOtherVisitorHover: "--surface-other-visitor-hover",
  /** @deprecated */
  ContentDefault: "--content-default",
  ContentBasicPrimary: "--content-basic-primary",
  /** @deprecated */
  ContentSubtle: "--content-subtle",
  ContentBasicSecondary: "--content-basic-secondary",
  /** @deprecated */
  ContentDisabled: "--content-disabled",
  ContentBasicDisabled: "--content-basic-disabled",
  ContentBasicNegative: "--content-basic-negative",
  ContentBasicWarning: "--content-basic-warning",
  ContentBasicPositive: "--content-basic-positive",
  ContentBasicInfo: "--content-basic-info",
  ContentBasicPurple: "--content-basic-purple",
  ContentBasicGradient01: "--content-basic-gradient-01",
  /** @deprecated */
  ContentWhiteLocked: "--content-white-locked",
  ContentLockedWhite: "--content-locked-white",
  /** @deprecated */
  ContentBlackLocked: "--content-black-locked",
  ContentLockedBlack: "--content-locked-black",
  ContentLockedDefault: "--content-locked-default",
  ContentLockedHover: "--content-locked-hover",
  ContentLockedActive: "--content-locked-active",
  ContentLockedDisabled: "--content-locked-disabled",
  /** @deprecated */
  ContentInvertDefault: "--content-invert-default",
  ContentInvertPrimary: "--content-invert-primary",
  /** @deprecated */
  ContentInvertSubtle: "--content-invert-subtle",
  ContentInvertSecondary: "--content-invert-secondary",
  ContentInvertDisabled: "--content-invert-disabled",
  ContentInvertGradient01: "--content-invert-gradient-01",
  /** @deprecated */
  BorderDefault: "--border-default",
  BorderBasicPrimary: "--border-basic-primary",
  BorderBasicSecondary: "--border-basic-secondary",
  /** @deprecated */
  BorderSubtle: "--border-subtle",
  BorderBasicTertiary: "--border-basic-tertiary",
  /** @deprecated */
  BorderHover: "--border-hover",
  BorderBasicHover: "--border-basic-hover",
  /** @deprecated */
  BorderDisabled: "--border-disabled",
  BorderBasicDisabled: "--border-basic-disabled",
  BorderBasicNegative: "--border-basic-negative",
  BorderBasicWarning: "--border-basic-warning",
  BorderBasicPositive: "--border-basic-positive",
  BorderBasicInfo: "--border-basic-info",
  BorderBasicPurple: "--border-basic-purple",
  BorderBasicContrast: "--border-basic-contrast",
  /** @deprecated */
  BorderInvertDefault: "--border-invert-default",
  BorderInvertPrimary: "--border-invert-primary",
  /** @deprecated */
  BorderInvertSubtle: "--border-invert-subtle",
  BorderInvertSecondary: "--border-invert-secondary",
  BorderInvertHover: "--border-invert-hover",
  BorderInvertDisabled: "--border-invert-disabled",
  /** @deprecated */
  ColorActionActive: "--color-action-active",
  ActionPrimaryActive: "--action-primary-active",
  /** @deprecated */
  ColorActionHover: "--color-action-hover",
  ActionPrimaryHover: "--action-primary-hover",
  /** @deprecated */
  ColorActionDefault: "--color-action-default",
  ActionPrimaryDefault: "--action-primary-default",
  ColorActionDefaultRgb: "--color-action-default-rgb",
  /** @deprecated */
  ColorActionDisabled: "--color-action-disabled",
  ActionPrimaryDisabled: "--action-primary-disabled",
  /** @deprecated */
  ColorNegativeActive: "--color-negative-active",
  ActionNegativeActive: "--action-negative-active",
  /** @deprecated */
  ColorNegativeHover: "--color-negative-hover",
  ActionNegativeHover: "--action-negative-hover",
  /** @deprecated */
  ColorNegativeDefault: "--color-negative-default",
  ActionNegativeDefault: "--action-negative-default",
  /** @deprecated */
  ColorNegativeDisabled: "--color-negative-disabled",
  ActionNegativeDisabled: "--action-negative-disabled",
  /** @deprecated */
  ColorWarningDefault: "--color-warning-default",
  ActionWarningDefault: "--action-warning-default",
  /** @deprecated */
  ColorWarningHover: "--color-warning-hover",
  ActionWarningHover: "--action-warning-hover",
  ActionWarningDisabled: "--action-warning-disabled",
  /** @deprecated */
  ColorPositiveDefault: "--color-positive-default",
  ActionPositiveDefault: "--action-positive-default",
  /** @deprecated */
  ColorPositiveHover: "--color-positive-hover",
  ActionPositiveHover: "--action-positive-hover",
  /** @deprecated */
  ColorPositiveDisabled: "--color-positive-disabled",
  ActionPositiveDisabled: "--action-positive-disabled",
  ActionNeutralDefault: "--action-neutral-default",
  ActionNeutralHover: "--action-neutral-hover",
  ActionNeutralDisabled: "--action-neutral-disabled",
  ActionHighContrastDefault: "--action-high-contrast-default",
  ActionHighContrastHover: "--action-high-contrast-hover",
  ActionHighContrastActive: "--action-high-contrast-active",
  ActionHighContrastDisabled: "--action-high-contrast-disabled",
  /** @deprecated */
  ColorBot: "--color-bot",
  SurfaceOtherBot: "--surface-other-bot",
  SurfaceOtherBotHover: "--surface-other-bot-hover",
  ColorBlack: "--color-black",
  ColorWhite: "--color-white",
  DecorBlue900: "--decor-blue900",
  DecorBlue800: "--decor-blue800",
  DecorBlue700: "--decor-blue700",
  DecorBlue600: "--decor-blue600",
  DecorBlue500: "--decor-blue500",
  DecorBlue400: "--decor-blue400",
  DecorBlue300: "--decor-blue300",
  DecorBlue200: "--decor-blue200",
  DecorBlue100: "--decor-blue100",
  DecorBlue50: "--decor-blue50",
  DecorOrange900: "--decor-orange900",
  DecorOrange800: "--decor-orange800",
  DecorOrange700: "--decor-orange700",
  DecorOrange600: "--decor-orange600",
  DecorOrange500: "--decor-orange500",
  DecorOrange400: "--decor-orange400",
  DecorOrange300: "--decor-orange300",
  DecorOrange200: "--decor-orange200",
  DecorOrange100: "--decor-orange100",
  DecorOrange50: "--decor-orange50",
  DecorYellow900: "--decor-yellow900",
  DecorYellow800: "--decor-yellow800",
  DecorYellow700: "--decor-yellow700",
  DecorYellow600: "--decor-yellow600",
  DecorYellow500: "--decor-yellow500",
  DecorYellow400: "--decor-yellow400",
  DecorYellow300: "--decor-yellow300",
  DecorYellow200: "--decor-yellow200",
  DecorYellow100: "--decor-yellow100",
  DecorYellow50: "--decor-yellow50",
  DecorGray950: "--decor-gray950",
  DecorGray900: "--decor-gray900",
  DecorGray800: "--decor-gray800",
  DecorGray700: "--decor-gray700",
  DecorGray600: "--decor-gray600",
  DecorGray500: "--decor-gray500",
  DecorGray400: "--decor-gray400",
  DecorGray300: "--decor-gray300",
  DecorGray200: "--decor-gray200",
  DecorGray150: "--decor-gray150",
  DecorGray100: "--decor-gray100",
  DecorGray75: "--decor-gray75",
  DecorGray50: "--decor-gray50",
  DecorGray40: "--decor-gray40",
  DecorGray20: "--decor-gray20",
  DecorGreen900: "--decor-green900",
  DecorGreen800: "--decor-green800",
  DecorGreen700: "--decor-green700",
  DecorGreen600: "--decor-green600",
  DecorGreen500: "--decor-green500",
  DecorGreen400: "--decor-green400",
  DecorGreen300: "--decor-green300",
  DecorGreen200: "--decor-green200",
  DecorGreen100: "--decor-green100",
  DecorGreen50: "--decor-green50",
  DecorRed900: "--decor-red900",
  DecorRed800: "--decor-red800",
  DecorRed700: "--decor-red700",
  DecorRed600: "--decor-red600",
  DecorRed500: "--decor-red500",
  DecorRed400: "--decor-red400",
  DecorRed300: "--decor-red300",
  DecorRed200: "--decor-red200",
  DecorRed100: "--decor-red100",
  DecorRed50: "--decor-red50",
  DecorPurple900: "--decor-purple900",
  DecorPurple800: "--decor-purple800",
  DecorPurple700: "--decor-purple700",
  DecorPurple600: "--decor-purple600",
  DecorPurple500: "--decor-purple500",
  DecorPurple400: "--decor-purple400",
  DecorPurple300: "--decor-purple300",
  DecorPurple200: "--decor-purple200",
  DecorPurple100: "--decor-purple100",
  DecorPurple50: "--decor-purple50",
  DecorBrown50: "--decor-brown50",
  DecorBrown300: "--decor-brown300",
  ProductsLivechat: "--products-livechat",
  ProductsHelpdesk: "--products-helpdesk",
  ProductsChatbot: "--products-chatbot",
  ProductsKnowledgebase: "--products-knowledgebase",
  IllustrationsPrimary: "--illustrations-primary",
  IllustrationsSecondary: "--illustrations-secondary",
  IllustrationsStroke: "--illustrations-stroke",
  TagSurface01: "--tag-surface-01",
  TagContent01: "--tag-content-01",
  BtnBasicBackgroundEnabled: "--btn-basic-background-enabled",
  BtnBasicBackgroundHover: "--btn-basic-background-hover",
  BtnBasicBackgroundDisabled: "--btn-basic-background-disabled",
  BtnBasicBackgroundActive: "--btn-basic-background-active",
  BtnBasicBackgroundLoading: "--btn-basic-background-loading",
  BtnSecondaryBackgroundEnabled: "--btn-secondary-background-enabled",
  BtnSecondaryBackgroundHover: "--btn-secondary-background-hover",
  BtnSecondaryBackgroundDisabled: "--btn-secondary-background-disabled",
  BtnSecondaryBackgroundActive: "--btn-secondary-background-active",
  BtnSecondaryBackgroundLoading: "--btn-secondary-background-loading",
  BtnPlainIconBackgroundHover: "--btn-plain-icon-background-hover",
  BtnPlainIconBackgroundActive: "--btn-plain-icon-background-active",
  PickerListBackground: "--picker-list-background",
  PickerListGroupBackground: "--picker-list-group-background",
  PickerListOptionBackgroundHover: "--picker-list-option-background-hover",
  PickerListOptionBackgroundActiveHover: "--picker-list-option-background-active-hover",
  PickerListOptionBackgroundFocus: "--picker-list-option-background-focus",
  PickerListOptionBackgroundActive: "--picker-list-option-background-active",
  PopoverBackground: "--popover-background",
  SurfaceAvatar1: "--surface-avatar-1",
  SurfaceAvatar2: "--surface-avatar-2",
  SurfaceAvatar3: "--surface-avatar-3",
  SurfaceAvatar4: "--surface-avatar-4",
  SurfaceAvatar5: "--surface-avatar-5",
  SurfaceAvatar6: "--surface-avatar-6",
  SurfaceAvatar7: "--surface-avatar-7",
  SurfaceAvatar8: "--surface-avatar-8",
  SurfaceAvatar9: "--surface-avatar-9",
  SurfaceAvatar10: "--surface-avatar-10",
  NavbarBackground: "--navbar-background",
  TooltipBackgroundBasic: "--tooltip-background-basic",
  TooltipBackgroundInvert: "--tooltip-background-invert",
  TooltipBorder: "--tooltip-border",
  TooltipBorderForSvg: "--tooltip-border-for-svg",
  AnimatedGradientValue1: "--animated-gradient-value-1",
  AnimatedGradientValue2: "--animated-gradient-value-2",
  AnimatedGradientValue3: "--animated-gradient-value-3",
  ContentBasicInternalNote: "--content-basic-internal-note",
  ContentBasicBot: "--content-basic-bot",
  ActionLockDefault: "--action-lock-default",
  ActionLockHover: "--action-lock-hover",
  ActionLockActive: "--action-lock-active",
  ActionLockDisabled: "--action-lock-disabled",
  SurfaceOtherInternalNoteMessageArea: "--surface-other-internal-note-message-area",
  SurfaceOtherInternalNoteDefault: "--surface-other-internal-note-default",
  ContentBasicInternalNoteMessagePlaceholder: "--content-basic-internal-note-message-placeholder",
  ContentBasicInternalNoteMessageActive: "--content-basic-internal-note-message-active",
  OnePopoverMessageBackgroundDefault: "--one-popover-message-background-default",
  OnePopoverBorderDefault: "--one-popover-border-default",
  OnePopoverBorderActive: "--one-popover-border-active",
  OneTooltipBackground: "--one-tooltip-background",
  ContentBasicAutofill: "--content-basic-autofill",
  ProductsHello: "--products-hello",
  ProductsPlatform: "--products-platform",
  SurfaceCheckListItemOpenBackground: "--surface-check-list-item-open-background",
  SurfaceCheckListBackground: "--surface-check-list-background",
  ContentBasicPlaceholder: "--content-basic-placeholder"
}, Jl = {
  Spacing0: "--spacing-0",
  Spacing05: "--spacing-05",
  Spacing1: "--spacing-1",
  Spacing2: "--spacing-2",
  Spacing3: "--spacing-3",
  Spacing4: "--spacing-4",
  Spacing5: "--spacing-5",
  Spacing6: "--spacing-6",
  Spacing7: "--spacing-7",
  Spacing8: "--spacing-8",
  Spacing9: "--spacing-9",
  Spacing10: "--spacing-10",
  Spacing11: "--spacing-11",
  Spacing12: "--spacing-12",
  Spacing14: "--spacing-14",
  Spacing16: "--spacing-16",
  Spacing18: "--spacing-18",
  Spacing20: "--spacing-20",
  Spacing24: "--spacing-24"
}, es = {
  Float: "--shadow-float",
  PopOver: "--shadow-pop-over",
  Modal: "--shadow-modal",
  Tooltip: "--shadow-tooltip",
  TooltipArrowBottom: "--shadow-tooltip-arrow-bottom",
  TooltipArrowTop: "--shadow-tooltip-arrow-top",
  TooltipArrowRight: "--shadow-tooltip-arrow-right",
  TooltipArrowLeft: "--shadow-tooltip-arrow-left",
  TooltipArrow: "--shadow-tooltip-arrow",
  Focus: "--shadow-focus",
  DividerBottom: "--shadow-divider-bottom",
  DividerTop: "--shadow-divider-top",
  DividerRight: "--shadow-divider-right",
  DividerLeft: "--shadow-divider-left",
  DividerBottomLeft: "--shadow-divider-bottom-left",
  DividerTopLeft: "--shadow-divider-top-left",
  DividerTopRight: "--shadow-divider-top-right",
  DividerBottomRight: "--shadow-divider-bottom-right",
  MessageBox: "--shadow-message-box",
  FixedRight: "--shadow-fixed-right",
  FixedLeft: "--shadow-fixed-left",
  FixedTop: "--shadow-fixed-top",
  FixedBottom: "--shadow-fixed-bottom"
}, ts = {
  Radius0: "--radius-0",
  Radius1: "--radius-1",
  Radius2: "--radius-2",
  Radius3: "--radius-3",
  Radius4: "--radius-4",
  0: "--radius-0",
  // deprecated
  1: "--radius-1",
  // deprecated
  2: "--radius-2",
  // deprecated
  3: "--radius-3",
  // deprecated
  4: "--radius-4"
  // deprecated
}, as = {
  Fast1: "--transition-duration-fast-1",
  Fast2: "--transition-duration-fast-2",
  Moderate1: "--transition-duration-moderate-1"
}, rs = {
  EaseIn: "--transition-timing-ease-in",
  EaseOut: "--transition-timing-ease-out"
}, _s = {
  Instant: "--delay-instant",
  Moderate: "--delay-moderate",
  Slow: "--delay-slow"
};
var Dt = /* @__PURE__ */ ((e) => (e.Dark = "lc-dark-theme", e.Light = "lc-light-theme", e))(Dt || {});
const os = (e) => e === "dark" ? Dt.Dark : Dt.Light, M_ = uo(void 0), ns = () => {
  const e = mo(M_);
  if (!e)
    throw new Error("useTheme must be used within a ThemeProvider");
  return e;
}, is = ({
  children: e,
  initialTheme: a = "light",
  customVariables: r = {}
}) => {
  const [_, o] = Jt(a), [n, i] = Jt(r);
  at(() => {
    document.body.classList.remove(Dt.Light, Dt.Dark), document.body.classList.add(`lc-${_}-theme`);
    for (const [d, l] of Object.entries(n))
      document.body.style.setProperty(d, l);
  }, [_, n]);
  const c = qt(
    () => ({
      theme: _,
      toggleTheme: () => o((d) => d === "light" ? "dark" : "light"),
      setTheme: o,
      setCustomVariables: (d) => {
        i(d);
      }
    }),
    [_, o, i]
  );
  return /* @__PURE__ */ t(M_.Provider, { value: c, children: e });
}, O_ = g.createContext(
  void 0
), Xr = () => {
  const e = g.useContext(O_);
  if (!e)
    throw new Error("useAppFrame must be used within a AppFrameProvider");
  return e;
}, en = ({
  children: e,
  isSideNavigationVisible: a = !0,
  isMobileViewVisible: r = !1
}) => {
  const [_, o] = g.useState(a), [n, i] = g.useState(r), c = g.useMemo(
    () => ({
      isSideNavigationVisible: _,
      toggleSideNavigationVisibility: () => o(!_),
      isMobileViewEnabled: n,
      setIsMobileViewEnabled: (d) => i(d)
    }),
    [
      _,
      o,
      n,
      i
    ]
  );
  return /* @__PURE__ */ t(O_.Provider, { value: c, children: e });
}, cs = (e, a) => `color-mix(in srgb, var(${e}) ${a}, transparent)`, Gt = ({
  isVisible: e,
  elementRef: a
}) => {
  const [r, _] = g.useState(e), [o, n] = g.useState(e), [i, c] = g.useState(e), d = g.useRef(null), l = () => {
    _(!1), d.current && clearTimeout(d.current);
  };
  return g.useEffect(() => {
    const s = a.current;
    if (!i && s)
      return s.addEventListener("transitionend", l), n(!1), d.current = window.setTimeout(l, 300), () => {
        clearTimeout(d.current), s.removeEventListener(
          "transitionend",
          l
        );
      };
    i && (_(!0), requestAnimationFrame(() => n(!0)));
  }, [i]), g.useEffect(() => {
    const s = () => {
      document.visibilityState === "visible" && c(e);
    };
    return document.addEventListener("visibilitychange", s), () => {
      document.removeEventListener("visibilitychange", s);
    };
  }, [e]), g.useEffect(() => {
    c(e);
  }, [e]), {
    isOpen: o,
    isMounted: r,
    setShouldBeVisible: c
  };
}, __ = /* @__PURE__ */ (() => {
  let e = null;
  const a = /* @__PURE__ */ new Map();
  return {
    observe: (o, n) => {
      e || (e = new ResizeObserver((i) => {
        i.forEach((c) => {
          const d = c.target, l = a.get(d);
          l && l(c.contentRect);
        });
      })), o && (a.set(o, n), e.observe(o));
    },
    unobserve: (o) => {
      e && o && (e.unobserve(o), a.delete(o), a.size === 0 && (e.disconnect(), e = null));
    }
  };
})(), Zr = (e, a) => {
  window.ResizeObserver && (e !== null ? __.observe(e, (_) => {
    a(_);
  }) : __.unobserve(e));
}, L_ = () => {
  const [e, a] = g.useState(0), r = g.useCallback(
    (_) => Zr(
      _,
      (o) => a(o.height)
    ),
    []
  );
  return {
    size: e,
    handleResizeRef: r
  };
}, tn = ({
  mobileBreakpoint: e
}) => {
  const [a, r] = g.useState(!1), _ = g.useCallback(
    (o) => Zr(
      o,
      (n) => r(n.width <= e)
    ),
    []
  );
  return {
    isMobile: a,
    handleResizeRef: _
  };
}, an = "lc-Icon-module__icon___J5RH5", o_ = {
  icon: an,
  "icon--primary": "lc-Icon-module__icon--primary___lclud",
  "icon--subtle": "lc-Icon-module__icon--subtle___d17Qj",
  "icon--inverted": "lc-Icon-module__icon--inverted___Cb4ml",
  "icon--inverted-subtle": "lc-Icon-module__icon--inverted-subtle___kw-gq",
  "icon--link": "lc-Icon-module__icon--link___TM17Q",
  "icon--success": "lc-Icon-module__icon--success___Jbdc3",
  "icon--warning": "lc-Icon-module__icon--warning___2xp2W",
  "icon--error": "lc-Icon-module__icon--error___95ah2",
  "icon--negative": "lc-Icon-module__icon--negative___Ds5e2",
  "icon--positive": "lc-Icon-module__icon--positive___Uy-GO",
  "icon--info": "lc-Icon-module__icon--info___sIO63",
  "icon--action-primary": "lc-Icon-module__icon--action-primary___iKKt4",
  "icon--action-negative": "lc-Icon-module__icon--action-negative___n9ONx",
  "icon--action-positive": "lc-Icon-module__icon--action-positive___Xq7UP",
  "icon--action-warning": "lc-Icon-module__icon--action-warning___UsFlk",
  "icon--action-neutral": "lc-Icon-module__icon--action-neutral___Hhno9",
  "icon--disabled--primary": "lc-Icon-module__icon--disabled--primary___M6mL2",
  "icon--disabled--subtle": "lc-Icon-module__icon--disabled--subtle___gs7xm",
  "icon--disabled--inverted": "lc-Icon-module__icon--disabled--inverted___SJMuj",
  "icon--disabled--inverted-subtle": "lc-Icon-module__icon--disabled--inverted-subtle___4YUA4",
  "icon--disabled--link": "lc-Icon-module__icon--disabled--link___sLus3",
  "icon--disabled--success": "lc-Icon-module__icon--disabled--success___XqRSR",
  "icon--disabled--warning": "lc-Icon-module__icon--disabled--warning___72dUP",
  "icon--disabled--error": "lc-Icon-module__icon--disabled--error___-0U0g",
  "icon--disabled--negative": "lc-Icon-module__icon--disabled--negative___V7paN",
  "icon--disabled--positive": "lc-Icon-module__icon--disabled--positive___X0-e0",
  "icon--disabled--info": "lc-Icon-module__icon--disabled--info___IlUe5",
  "icon--disabled--action-primary": "lc-Icon-module__icon--disabled--action-primary___4GYxP",
  "icon--disabled--action-negative": "lc-Icon-module__icon--disabled--action-negative___WP3Hi",
  "icon--disabled--action-positive": "lc-Icon-module__icon--disabled--action-positive___3Gz5e",
  "icon--disabled--action-warning": "lc-Icon-module__icon--disabled--action-warning___GHGY2",
  "icon--disabled--action-neutral": "lc-Icon-module__icon--disabled--action-neutral___a53XD",
  "icon--disabled--lock-black": "lc-Icon-module__icon--disabled--lock-black___JaNzw"
}, rn = {
  xsmall: {
    width: 12,
    height: 12
  },
  small: {
    width: 16,
    height: 16
  },
  medium: {
    width: 20,
    height: 20
  },
  large: {
    width: 24,
    height: 24
  },
  xlarge: {
    width: 32,
    height: 32
  },
  xxlarge: {
    width: 48,
    height: 48
  },
  xxxlarge: {
    width: 64,
    height: 64
  }
}, n_ = "icon", P = (e) => {
  const s = e, {
    source: a,
    size: r = "medium",
    kind: _,
    disabled: o,
    className: n,
    customColor: i
  } = s, c = F(s, [
    "source",
    "size",
    "kind",
    "disabled",
    "className",
    "customColor"
  ]), d = g.createElement(a, k(k({}, rn[r]), i ? { color: i } : {})), l = u(
    n,
    o_[n_],
    _ && o_[`${n_}--${o ? "disabled--" : ""}${_}`]
  );
  return /* @__PURE__ */ t("span", E(k({}, c), { className: l, children: d }));
}, tt = {
  "heading-xl": "lc-Typography-module__heading-xl___jTpRq",
  "heading-lg": "lc-Typography-module__heading-lg___VGjgP",
  "heading-md": "lc-Typography-module__heading-md___U-DUC",
  "heading-sm": "lc-Typography-module__heading-sm___SgG32",
  "heading-xs": "lc-Typography-module__heading-xs___cKzMb",
  "heading-2xs": "lc-Typography-module__heading-2xs___K6Lmw",
  "heading-uppercase": "lc-Typography-module__heading-uppercase___DC8Ro",
  "heading-bold": "lc-Typography-module__heading-bold___5Ez7T",
  "paragraph-lg": "lc-Typography-module__paragraph-lg___KmMBe",
  "paragraph-md": "lc-Typography-module__paragraph-md___Ogs8k",
  "paragraph-sm": "lc-Typography-module__paragraph-sm___5KRhm",
  "paragraph-xs": "lc-Typography-module__paragraph-xs___TlVSn",
  "paragraph--bold": "lc-Typography-module__paragraph--bold___HVepi",
  "paragraph--underline": "lc-Typography-module__paragraph--underline___M3l4C",
  "paragraph--strike": "lc-Typography-module__paragraph--strike___gmYoG",
  "paragraph--uppercase": "lc-Typography-module__paragraph--uppercase___8bXNL",
  "paragraph--no-margin": "lc-Typography-module__paragraph--no-margin___7wc0Y",
  "display-md": "lc-Typography-module__display-md___i1Zgu",
  "display-sm": "lc-Typography-module__display-sm___f46hM",
  "display-lg": "lc-Typography-module__display-lg___wAcSa",
  "display-max": "lc-Typography-module__display-max___W4YZ0",
  "display--bold": "lc-Typography-module__display--bold___tIiWp"
}, _n = {
  xl: "h1",
  lg: "h2",
  md: "h3",
  sm: "h4",
  xs: "h5",
  "2xs": "h6"
}, he = (l) => {
  var s = l, {
    as: e,
    size: a = "md",
    children: r,
    className: _,
    uppercase: o,
    bold: n,
    customColor: i,
    textAlign: c
  } = s, d = F(s, [
    "as",
    "size",
    "children",
    "className",
    "uppercase",
    "bold",
    "customColor",
    "textAlign"
  ]);
  return g.createElement(
    e || _n[a],
    k({
      className: u(
        {
          [tt[`heading-${a}`]]: !0,
          [tt["heading-uppercase"]]: o,
          [tt["heading-bold"]]: n
        },
        _
      ),
      style: k(k({}, i && { color: i }), c && { textAlign: c })
    }, d),
    r
  );
}, A = (v) => {
  var h = v, {
    as: e = "p",
    size: a = "md",
    caps: r = !1,
    uppercase: _ = !1,
    bold: o = !1,
    underline: n = !1,
    strike: i = !1,
    children: c,
    className: d,
    customColor: l,
    textAlign: s,
    noMargin: m
  } = h, p = F(h, [
    "as",
    "size",
    "caps",
    "uppercase",
    "bold",
    "underline",
    "strike",
    "children",
    "className",
    "customColor",
    "textAlign",
    "noMargin"
  ]);
  const b = "paragraph";
  return g.createElement(
    e,
    k({
      className: u(
        {
          [tt[`${b}-${a}`]]: !0,
          [tt[`${b}--bold`]]: o,
          [tt[`${b}--strike`]]: i,
          [tt[`${b}--underline`]]: n,
          [tt[`${b}--uppercase`]]: _ || r,
          [tt[`${b}--no-margin`]]: m
        },
        d
      ),
      style: k(k({}, l && { color: l }), s && { textAlign: s })
    }, p),
    c
  );
}, ls = (d) => {
  var l = d, {
    as: e = "div",
    size: a = "md",
    children: r,
    className: _,
    customColor: o,
    textAlign: n,
    bold: i = !0
  } = l, c = F(l, [
    "as",
    "size",
    "children",
    "className",
    "customColor",
    "textAlign",
    "bold"
  ]);
  return g.createElement(
    e,
    k({
      className: u(
        tt[`display-${a}`],
        {
          [tt["display--bold"]]: i
        },
        _
      ),
      style: k(k({}, o && { color: o }), n && { textAlign: n })
    }, c),
    r
  );
}, i_ = {
  "accordion-multiline": "lc-AccordionMultilineElement-module__accordion-multiline___oI-PH",
  "accordion-multiline__inner": "lc-AccordionMultilineElement-module__accordion-multiline__inner___bBTnC"
}, c_ = "accordion-multiline", on = ({ children: e, isExpanded: a }) => {
  const r = g.useRef(null), { isOpen: _, isMounted: o } = Gt({
    isVisible: !a,
    elementRef: r
  }), { size: n, handleResizeRef: i } = L_();
  return /* @__PURE__ */ t(
    "div",
    {
      className: i_[`${c_}`],
      style: { maxHeight: _ ? n : 0 },
      ref: r,
      children: /* @__PURE__ */ t("div", { ref: i, children: o && /* @__PURE__ */ t("div", { className: i_[`${c_}__inner`], children: e }) })
    }
  );
}, aa = {
  "accordion-animated-label": "lc-AccordionAnimatedLabel-module__accordion-animated-label___HnrCL",
  "accordion-animated-label__open": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open___i2uH-",
  "accordion-animated-label__close": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close___OAiew",
  "accordion-animated-label__open--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__open--visible___eCkrm",
  "accordion-animated-label__close--visible": "lc-AccordionAnimatedLabel-module__accordion-animated-label__close--visible___aMI8K"
}, ra = "accordion-animated-label", nn = ({
  open: e,
  closed: a,
  isOpen: r
}) => {
  const _ = g.useRef(null), o = g.useRef(null), [n, i] = g.useState(void 0), { isOpen: c, isMounted: d } = Gt({
    isVisible: r,
    elementRef: _
  }), { isOpen: l, isMounted: s } = Gt(
    {
      isVisible: !r,
      elementRef: o
    }
  );
  return g.useEffect(() => {
    const m = r ? _.current : o.current;
    if (m) {
      const p = m.getBoundingClientRect().height;
      i(p);
    }
  }, [r, d, s]), /* @__PURE__ */ f(
    "div",
    {
      className: aa[ra],
      style: { height: n ? `${n}px` : "auto" },
      children: [
        d && /* @__PURE__ */ t(
          "div",
          {
            ref: _,
            className: u(aa[`${ra}__open`], {
              [aa[`${ra}__open--visible`]]: c
            }),
            children: e
          }
        ),
        s && /* @__PURE__ */ t(
          "div",
          {
            ref: o,
            className: u(aa[`${ra}__close`], {
              [aa[`${ra}__close--visible`]]: l
            }),
            children: a
          }
        )
      ]
    }
  );
}, cn = (e) => e.open !== void 0 && e.closed !== void 0, ln = (e, a) => {
  if (cn(e)) {
    const r = {
      open: e.open,
      closed: e.closed,
      isOpen: a
    };
    return /* @__PURE__ */ t(nn, k({}, r));
  }
  return e;
}, sn = "lc-Accordion-module__accordion___wD27Q", dn = "lc-Accordion-module__accordion__chevron___3-rGN", un = "lc-Accordion-module__accordion__label___1MyYP", mn = "lc-Accordion-module__accordion__content___vfjP2", pn = "lc-Accordion-module__accordion__content__inner___Z-9cB", ut = {
  accordion: sn,
  "accordion--warning": "lc-Accordion-module__accordion--warning___PJg4j",
  "accordion--error": "lc-Accordion-module__accordion--error___rage8",
  "accordion--open": "lc-Accordion-module__accordion--open___q9p79",
  accordion__chevron: dn,
  "accordion__chevron--open": "lc-Accordion-module__accordion__chevron--open___Yax5V",
  accordion__label: un,
  accordion__content: mn,
  accordion__content__inner: pn,
  "accordion__content__inner--open": "lc-Accordion-module__accordion__content__inner--open___BhKjm"
}, mt = "accordion", ss = (s) => {
  var m = s, {
    className: e,
    children: a,
    label: r,
    multilineElement: _,
    kind: o = "default",
    openOnInit: n = !1,
    isOpen: i,
    onClose: c,
    onOpen: d
  } = m, l = F(m, [
    "className",
    "children",
    "label",
    "multilineElement",
    "kind",
    "openOnInit",
    "isOpen",
    "onClose",
    "onOpen"
  ]);
  const p = i !== void 0, v = p ? i : n, h = g.useRef(null), {
    isOpen: b,
    isMounted: y,
    setShouldBeVisible: C
  } = Gt({
    isVisible: v,
    elementRef: h
  }), N = u(
    ut[mt],
    ut[`${mt}--${o}`],
    {
      [ut[`${mt}--open`]]: b
    },
    e
  ), { size: B, handleResizeRef: $ } = L_(), x = (S) => {
    S ? (c == null || c(), !p && C(!1)) : (d == null || d(), !p && C(!0));
  };
  return /* @__PURE__ */ f(
    "div",
    E(k({
      tabIndex: 0,
      "aria-expanded": b,
      className: N,
      onKeyDown: (S) => {
        !b && (S.key === "Enter" || S.key === " ") && x(b), b && S.key === "Escape" && x(b);
      }
    }, l), {
      children: [
        /* @__PURE__ */ t(
          P,
          {
            source: Ht,
            className: u(ut[`${mt}__chevron`], {
              [ut[`${mt}__chevron--open`]]: b
            })
          }
        ),
        /* @__PURE__ */ t(
          A,
          {
            "aria-expanded": b,
            role: "button",
            as: "div",
            bold: !0,
            className: ut[`${mt}__label`],
            onClick: () => x(b),
            children: ln(r, b)
          }
        ),
        _ && /* @__PURE__ */ t(on, { isExpanded: b, children: _ }),
        /* @__PURE__ */ t(
          "div",
          {
            className: ut[`${mt}__content`],
            style: { maxHeight: b ? B : 0 },
            ref: h,
            children: /* @__PURE__ */ t("div", { ref: $, children: y && /* @__PURE__ */ t(
              A,
              {
                as: "div",
                className: u(ut[`${mt}__content__inner`], {
                  [ut[`${mt}__content__inner--open`]]: b
                }),
                children: a
              }
            ) })
          }
        )
      ]
    })
  );
}, ke = {
  esc: "Escape",
  enter: "Enter",
  backspace: "Backspace",
  delete: "Delete",
  spacebar: " ",
  tab: "Tab",
  semicolon: ";",
  comma: ",",
  arrowUp: "ArrowUp",
  arrowDown: "ArrowDown"
}, ot = {
  "action-menu": "lc-ActionMenu-module__action-menu___tmkcK",
  "action-menu__trigger-button": "lc-ActionMenu-module__action-menu__trigger-button___fTjxP",
  "action-menu__list": "lc-ActionMenu-module__action-menu__list___sEn6L",
  "action-menu__list__group-header": "lc-ActionMenu-module__action-menu__list__group-header___TWiz0",
  "action-menu__list__item": "lc-ActionMenu-module__action-menu__list__item___PhQbO",
  "action-menu__list__item--with-divider": "lc-ActionMenu-module__action-menu__list__item--with-divider___KF1dE",
  "action-menu__list__item--disabled": "lc-ActionMenu-module__action-menu__list__item--disabled___VfZx3",
  "action-menu__list__item--selected": "lc-ActionMenu-module__action-menu__list__item--selected___aT2Ab",
  "action-menu__list__item__icon": "lc-ActionMenu-module__action-menu__list__item__icon___f3k8k",
  "action-menu__list--with-footer": "lc-ActionMenu-module__action-menu__list--with-footer___21-ar",
  "action-menu__footer": "lc-ActionMenu-module__action-menu__footer___pb-RE"
}, nt = "action-menu", G_ = (b) => {
  var y = b, {
    className: e,
    triggerClassName: a,
    options: r,
    triggerRenderer: _,
    placement: o = "bottom-end",
    openedOnInit: n = !1,
    keepOpenOnClick: i,
    flipOptions: c,
    visible: d,
    onClose: l,
    onOpen: s,
    floatingStrategy: m,
    selectedOptions: p,
    footer: v
  } = y, h = F(y, [
    "className",
    "triggerClassName",
    "options",
    "triggerRenderer",
    "placement",
    "openedOnInit",
    "keepOpenOnClick",
    "flipOptions",
    "visible",
    "onClose",
    "onOpen",
    "floatingStrategy",
    "selectedOptions",
    "footer"
  ]);
  const C = d !== void 0, [N, B] = g.useState(n), [$, x] = g.useState(null), w = g.useRef(-1), S = lr(), I = Ba(), R = g.useRef(null), G = C ? d : N, T = () => {
    G ? (l == null || l(), !C && B(!1)) : (s == null || s(), !C && B(!0));
  }, { x: D, y: z, strategy: ie, refs: V, context: H } = Ea({
    nodeId: I,
    middleware: [
      Ia(4),
      sr(c),
      D_({
        apply({ availableHeight: M }) {
          Zo(() => x(M));
        }
      })
    ],
    placement: o,
    open: G,
    strategy: m,
    onOpenChange: T,
    whileElementsMounted: Ta
  }), K = Aa(H), He = Da(H, {
    enabled: G
  }), rt = Pa(H), { getReferenceProps: Ct, getFloatingProps: xe } = Fa([
    K,
    He,
    rt
  ]), { styles: ct } = Vr(H, {
    initial: ({ side: M }) => k({
      opacity: 0
    }, M === "bottom" && {
      marginTop: -10
    } || M === "top" && {
      marginTop: 10
    } || M === "left" && {
      marginLeft: 10
    } || M === "right" && {
      marginLeft: -10
    })
  }), _t = (M) => {
    var W, Y;
    const J = w.current;
    let se = J + M;
    for (; (W = r[se]) != null && W.disabled || (Y = r[se]) != null && Y.groupHeader; )
      if (se += M, se === -1) {
        se = J;
        break;
      }
    return se;
  }, lt = (M) => {
    var W, Y;
    w.current = _t(M);
    const J = (W = R.current) == null ? void 0 : W.children, se = J && ((Y = J[w.current]) == null ? void 0 : Y.children[0]);
    return se == null ? void 0 : se.focus();
  }, ze = (M) => {
    M.key === ke.arrowUp && w.current > 0 && (M.preventDefault(), lt(-1)), M.key === ke.arrowDown && w.current + 1 < r.length && (M.preventDefault(), lt(1));
  };
  g.useEffect(() => {
    if (G)
      return document.addEventListener("keydown", ze), () => document.removeEventListener("keydown", ze);
    w.current = -1;
  }, [G, ze]);
  const $t = (M, J) => {
    w.current = M, J == null || J(), !C && !i && (B(!1), l == null || l());
  }, Nt = (M, J) => M.groupHeader ? /* @__PURE__ */ t(
    "li",
    {
      role: "none",
      className: ot[`${nt}__list__group-header`],
      children: M.element
    },
    M.key
  ) : /* @__PURE__ */ t("li", { role: "none", children: /* @__PURE__ */ f(
    "button",
    {
      "data-testid": M.key,
      tabIndex: -1,
      disabled: M.disabled,
      onClick: () => $t(J, M.onClick),
      role: "menuitem",
      className: u(ot[`${nt}__list__item`], {
        [ot[`${nt}__list__item--disabled`]]: M.disabled,
        [ot[`${nt}__list__item--with-divider`]]: M.withDivider,
        [ot[`${nt}__list__item--selected`]]: p == null ? void 0 : p.includes(M.key)
      }),
      children: [
        M.element,
        (p == null ? void 0 : p.includes(M.key)) && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${M.key}-selected-icon`,
            className: ot[`${nt}__list__item__icon`],
            children: /* @__PURE__ */ t(P, { source: xa, kind: "action-primary" })
          }
        )
      ]
    },
    M.key
  ) }, M.key), st = /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ t(
      "div",
      E(k({
        "aria-label": "Toggle menu",
        "data-testid": "action-menu-trigger-button",
        ref: V.setReference
      }, Ct()), {
        className: a,
        children: _
      })
    ),
    /* @__PURE__ */ t(ta, { id: I, children: G && /* @__PURE__ */ f(
      "div",
      E(k({
        ref: V.setFloating,
        className: ot[nt],
        style: k(k({
          position: ie,
          top: z != null ? z : "",
          left: D != null ? D : ""
        }, !!$ && { maxHeight: $ }), ct)
      }, xe()), {
        children: [
          r.length > 0 && /* @__PURE__ */ t(
            "ul",
            E(k({}, h), {
              className: u(
                ot[`${nt}__list`],
                {
                  [ot[`${nt}__list--with-footer`]]: v
                },
                e
              ),
              role: "menu",
              ref: R,
              children: r.map(Nt)
            })
          ),
          v && /* @__PURE__ */ t(
            A,
            {
              size: "sm",
              as: "div",
              className: ot[`${nt}__footer`],
              children: v
            }
          )
        ]
      })
    ) })
  ] });
  return S === null ? /* @__PURE__ */ t(dr, { children: st }) : st;
}, _a = {
  "action-menu-item": "lc-ActionMenuItem-module__action-menu-item___tGD5A",
  "action-menu-item__left-node": "lc-ActionMenuItem-module__action-menu-item__left-node___USShV",
  "action-menu-item__right-node": "lc-ActionMenuItem-module__action-menu-item__right-node___mm7tl",
  "action-menu-item__label": "lc-ActionMenuItem-module__action-menu-item__label___gLDgg",
  "action-menu-item--warning": "lc-ActionMenuItem-module__action-menu-item--warning___ft0jM"
}, oa = "action-menu-item", Lr = ({ leftNode: e, rightNode: a, children: r, kind: _ }) => /* @__PURE__ */ f(
  "div",
  {
    className: u(_a[oa], {
      [_a[`${oa}--warning`]]: _ === "warning"
    }),
    children: [
      e && /* @__PURE__ */ t("div", { className: _a[`${oa}__left-node`], children: e }),
      /* @__PURE__ */ t(A, { as: "div", className: _a[`${oa}__label`], children: r }),
      a && /* @__PURE__ */ t("div", { className: _a[`${oa}__right-node`], children: a })
    ]
  }
), gn = "lc-Loader-module__loader___Ukoov", hn = "lc-Loader-module__loader__spinner___cp5N7", fn = "lc-Loader-module__rotate___p-j1x", bn = "lc-Loader-module__loader__label___CF5-C", na = {
  loader: gn,
  loader__spinner: hn,
  "loader__spinner--small": "lc-Loader-module__loader__spinner--small___9XXkz",
  "loader__spinner--medium": "lc-Loader-module__loader__spinner--medium___oTzt2",
  "loader__spinner--large": "lc-Loader-module__loader__spinner--large___vDCTc",
  "loader__spinner-circle": "lc-Loader-module__loader__spinner-circle___LyuTm",
  rotate: fn,
  loader__label: bn
}, U_ = "loader", l_ = `${U_}__spinner`, qr = (i) => {
  var c = i, {
    primaryColor: e,
    secondaryColor: a,
    label: r,
    className: _,
    size: o = "medium"
  } = c, n = F(c, [
    "primaryColor",
    "secondaryColor",
    "label",
    "className",
    "size"
  ]);
  return /* @__PURE__ */ f("div", E(k({ className: u(na[U_], _) }, n), { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(na[l_], na[`${l_}--${o}`]),
        children: /* @__PURE__ */ t(
          "div",
          {
            role: "status",
            className: na["loader__spinner-circle"],
            style: {
              /* stylelint-disable */
              borderColor: a,
              borderTopColor: e
            }
          }
        )
      }
    ),
    r && /* @__PURE__ */ t(A, { as: "div", size: "md", className: na.loader__label, children: r })
  ] }));
}, vn = (e) => {
  if (e === "primary" || e === "destructive")
    return {
      primaryColor: "var(--action-primary-default)",
      secondaryColor: "var(--border-invert-primary)"
    };
  if (e === "link-inverted")
    return {
      primaryColor: "var(--content-invert-primary)",
      secondaryColor: "var(--surface-invert-secondary)"
    };
}, s_ = (e, a, r) => {
  a(), r == null || r(e);
}, kn = (e, a, r) => {
  a(), r == null || r(e);
}, yn = (e, a) => {
  const r = e == null ? void 0 : e.offsetWidth;
  r && a(r);
}, wn = "lc-Button-module__btn___daEdK", Cn = "lc-Button-module__btn__loader___L9GCi", $n = "lc-Button-module__btn__icon___-CG5y", Nn = "lc-Button-module__btn__content___rMx0W", de = {
  btn: wn,
  "btn--disabled": "lc-Button-module__btn--disabled___ATZwt",
  "btn--full-width": "lc-Button-module__btn--full-width___ViUNm",
  "btn--xcompact": "lc-Button-module__btn--xcompact___0AZjf",
  "btn--with-left-icon": "lc-Button-module__btn--with-left-icon___32jlN",
  "btn--with-right-icon": "lc-Button-module__btn--with-right-icon___MnSZq",
  "btn--compact": "lc-Button-module__btn--compact___230yl",
  "btn--medium": "lc-Button-module__btn--medium___7lzYn",
  "btn--large": "lc-Button-module__btn--large___D38zo",
  "btn--basic": "lc-Button-module__btn--basic___r7FM2",
  "btn--primary": "lc-Button-module__btn--primary___RKxUy",
  "btn--secondary": "lc-Button-module__btn--secondary___-lgbN",
  "btn--destructive": "lc-Button-module__btn--destructive___frCNL",
  "btn--destructive-outline": "lc-Button-module__btn--destructive-outline___3Q-D2",
  "btn--text": "lc-Button-module__btn--text___lb44N",
  "btn--link": "lc-Button-module__btn--link___Q-xHu",
  "btn--link-light": "lc-Button-module__btn--link-light___s-d01",
  "btn--link-inverted": "lc-Button-module__btn--link-inverted___xOUjH",
  "btn--plain": "lc-Button-module__btn--plain___BOFMA",
  "btn--float": "lc-Button-module__btn--float___3O7kc",
  "btn--dotted": "lc-Button-module__btn--dotted___kFW2N",
  "btn--high-contrast": "lc-Button-module__btn--high-contrast___IZkuG",
  "btn--loading": "lc-Button-module__btn--loading___kGPe4",
  btn__loader: Cn,
  btn__icon: $n,
  "btn__icon--left": "lc-Button-module__btn__icon--left___Xke3Q",
  "btn__icon--right": "lc-Button-module__btn__icon--right___c-N-B",
  "btn__icon--small": "lc-Button-module__btn__icon--small___2gmZG",
  "btn--icon-only": "lc-Button-module__btn--icon-only___7J-XP",
  "btn--icon-only--bg": "lc-Button-module__btn--icon-only--bg___Kn-y-",
  "btn--plain-lock-black": "lc-Button-module__btn--plain-lock-black___EsXu7",
  "btn--text-lock-black": "lc-Button-module__btn--text-lock-black___r4V6e",
  "btn--animated-label": "lc-Button-module__btn--animated-label___8uZTa",
  btn__content: Nn,
  "btn--animated-label--expanded": "lc-Button-module__btn--animated-label--expanded___dTfmD"
}, ue = "btn", j = g.forwardRef(
  (y, b) => {
    var C = y, {
      loading: e = !1,
      disabled: a = !1,
      type: r = "button",
      fullWidth: _ = !1,
      kind: o = "basic",
      size: n = "medium",
      icon: i = null,
      iconPosition: c = "left",
      loaderLabel: d,
      className: l,
      children: s,
      href: m,
      onClick: p,
      animatedLabel: v
    } = C, h = F(C, [
      "loading",
      "disabled",
      "type",
      "fullWidth",
      "kind",
      "size",
      "icon",
      "iconPosition",
      "loaderLabel",
      "className",
      "children",
      "href",
      "onClick",
      "animatedLabel"
    ]);
    const [N, B] = g.useState(0), [$, x] = g.useState(!1), w = e || a, S = !s && i, I = v && s && i, R = ["text", "link", "link-light"].includes(o), G = m ? "a" : "button", T = u(
      de[ue],
      de[`${ue}--${o}`],
      de[`${ue}--${n}`],
      {
        [de[`${ue}--loading`]]: e,
        [de[`${ue}--full-width`]]: _,
        [de[`${ue}--with-${c}-icon`]]: i && !S && !R,
        [de[`${ue}--icon-only`]]: S,
        [de[`${ue}--icon-only--bg`]]: S && R,
        [de[`${ue}--disabled`]]: w,
        [de[`${ue}--animated-label`]]: I,
        [de[`${ue}--animated-label--expanded`]]: I && $
      },
      l
    );
    return /* @__PURE__ */ f(
      G,
      E(k(k(k({
        ref: b,
        className: T,
        "aria-disabled": w,
        type: r,
        disabled: w
      }, !w && { href: m, onClick: p }), h), I && {
        onMouseEnter: (D) => s_(
          D,
          () => x(!0),
          h == null ? void 0 : h.onMouseEnter
        ),
        onMouseLeave: (D) => s_(
          D,
          () => x(!1),
          h == null ? void 0 : h.onMouseLeave
        ),
        onBlur: (D) => kn(
          D,
          () => x(!1),
          h == null ? void 0 : h.onBlur
        ),
        onKeyUp: (D) => {
          var z;
          (D.key === "Enter" || D.key === " ") && x(!0), D.key === "Escape" && x(!1), (z = h == null ? void 0 : h.onKeyUp) == null || z.call(h, D);
        }
      }), {
        children: [
          e && /* @__PURE__ */ t(
            qr,
            k({
              "data-testid": "button-loader",
              size: "small",
              label: d,
              className: de[`${ue}__loader`]
            }, vn(o))
          ),
          i && g.cloneElement(i, {
            className: u(
              // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
              i.props.className,
              de[`${ue}__icon`],
              de[`${ue}__icon--${c}`],
              {
                [de[`${ue}__icon--small`]]: n === "xcompact"
              }
            ),
            disabled: a,
            size: n === "xcompact" ? "small" : "medium"
          }),
          /* @__PURE__ */ t(
            "div",
            {
              className: de[`${ue}__content`],
              style: I ? { maxWidth: $ ? N : 0 } : void 0,
              children: I ? /* @__PURE__ */ t("span", { ref: (D) => yn(D, B), children: s }) : s
            }
          )
        ]
      })
    );
  }
);
function H_(e) {
  switch (e) {
    case "invert":
      return "inverted";
    case "important":
      return "lock-black";
    default:
      return "primary";
  }
}
function Sn(e, a, r, _) {
  if (r)
    return {
      top: e ? r + e : r
    };
  if (_)
    return {
      left: a ? _ + a : _
    };
}
const xn = (e) => {
  switch (e) {
    case "invert":
      return {
        stroke: "var(--tooltip-background-invert)",
        fill: "var(--tooltip-background-invert)"
      };
    case "important":
      return {
        stroke: "var(--surface-accent-emphasis-high-warning)",
        fill: "var(--surface-accent-emphasis-high-warning)"
      };
    default:
      return {
        stroke: "var(--tooltip-border-for-svg)",
        fill: "var(--tooltip-background-basic)"
      };
  }
}, Bn = "lc-Tooltip-module__tooltip___LjRUX", En = "lc-Tooltip-module__tooltip__content___cxaIe", In = "lc-Tooltip-module__tooltip__arrow___vLFFP", Tn = "lc-Tooltip-module__tooltip__interactive___WTll9", L = {
  tooltip: Bn,
  tooltip__content: En,
  "tooltip--invert": "lc-Tooltip-module__tooltip--invert___J4i3t",
  tooltip__arrow: In,
  "tooltip--important": "lc-Tooltip-module__tooltip--important___7KDXC",
  tooltip__interactive: Tn,
  "tooltip__user-guide-step": "lc-Tooltip-module__tooltip__user-guide-step___zwAvq",
  "tooltip--full-space": "lc-Tooltip-module__tooltip--full-space___YXy-C",
  "tooltip-header": "lc-Tooltip-module__tooltip-header___gnWkw",
  "tooltip-header--info": "lc-Tooltip-module__tooltip-header--info___VLXJo",
  "tooltip-image-container": "lc-Tooltip-module__tooltip-image-container___Tca9c",
  "tooltip-image": "lc-Tooltip-module__tooltip-image___X5TXi",
  "tooltip-text--info": "lc-Tooltip-module__tooltip-text--info___eFPj0",
  "tooltip-close": "lc-Tooltip-module__tooltip-close___3t8it",
  "tooltip-step": "lc-Tooltip-module__tooltip-step___WnQFV",
  "tooltip-footer": "lc-Tooltip-module__tooltip-footer___Ila6T",
  "tooltip-footer--interactive": "lc-Tooltip-module__tooltip-footer--interactive___8WwVX",
  "tooltip-footer--user-guide-step": "lc-Tooltip-module__tooltip-footer--user-guide-step___hIsO4",
  "guide-tooltip": "lc-Tooltip-module__guide-tooltip___lBG0P",
  "guide-tooltip--slide": "lc-Tooltip-module__guide-tooltip--slide___XuCdK",
  "guide-tooltip__overlay": "lc-Tooltip-module__guide-tooltip__overlay___BAueg",
  "guide-tooltip__overlay--slide": "lc-Tooltip-module__guide-tooltip__overlay--slide___uYqoN",
  "guide-tooltip__overlay--visible": "lc-Tooltip-module__guide-tooltip__overlay--visible___Tk1Yr",
  "reports-tooltip": "lc-Tooltip-module__reports-tooltip___g6vxb",
  "reports-tooltip__heading": "lc-Tooltip-module__reports-tooltip__heading___TxORk",
  "reports-tooltip__heading__title": "lc-Tooltip-module__reports-tooltip__heading__title___0foO-",
  "reports-tooltip__heading__description": "lc-Tooltip-module__reports-tooltip__heading__description___E6Gb3",
  "reports-tooltip__content": "lc-Tooltip-module__reports-tooltip__content___yfOcf"
}, Ua = "tooltip", Ut = ({
  children: e,
  className: a,
  triggerClassName: r,
  triggerRenderer: _,
  theme: o,
  kind: n,
  placement: i = "bottom",
  isVisible: c,
  fullSpaceContent: d,
  onClose: l,
  onOpen: s,
  withFadeAnimation: m = !0,
  transitionDuration: p = 200,
  hoverOnDuration: v,
  hoverOffDuration: h,
  transitionDelay: b = 0,
  hoverOnDelay: y,
  hoverOffDelay: C,
  triggerOnClick: N = !1,
  triggerOnHover: B = !0,
  offsetMainAxis: $ = 8,
  offsetCrossAxis: x = 0,
  referenceElement: w,
  activationThreshold: S = 0,
  useDismissHookProps: I,
  useClickHookProps: R,
  hoverOutDelayTimeout: G = 100,
  arrowOffsetY: T,
  arrowOffsetX: D,
  closeOnTriggerBlur: z = !1,
  floatingStrategy: ie,
  portal: V,
  portalProps: H,
  hideWhenReferenceHidden: K = !1
}) => {
  const He = c !== void 0, [rt, Ct] = g.useState(!1), xe = g.useRef(null), ct = He ? c : rt, _t = n || o, lt = lr(), ze = Ba(), $t = u(
    L[Ua],
    a,
    _t && L[`${Ua}--${_t}`],
    d && L[`${Ua}--full-space`]
  ), Nt = typeof _ == "function", st = (Ve) => {
    Ve !== ct && (Ve ? s == null || s() : l == null || l(), !He && Ct(Ve));
  }, M = (Ve) => m ? Ve != null ? Ve : p : 0, J = (Ve) => Ve != null ? Ve : b, {
    floatingStyles: se,
    refs: W,
    context: Y,
    middlewareData: { arrow: { x: dt, y: zt } = {}, hide: St }
  } = Ea({
    nodeId: ze,
    middleware: [
      Ia({ mainAxis: $, crossAxis: x }),
      Wr(),
      sr(),
      Lo({ element: xe, padding: 8 }),
      K ? Go() : void 0
    ],
    placement: i,
    open: ct,
    strategy: ie,
    onOpenChange: st,
    whileElementsMounted: Ta
  }), mr = Uo(Y, {
    move: !1,
    restMs: S,
    delay: {
      open: J(y),
      close: J(C || G)
    },
    enabled: B,
    handleClose: z ? null : Ho()
  }), pr = zo(Y), gr = Da(Y, I), hr = Pa(Y, { role: "tooltip" }), fr = Aa(Y, k({
    enabled: N
  }, R)), { isMounted: br, styles: vr } = Vr(Y, {
    duration: {
      open: M(v),
      close: M(h)
    }
  }), { status: kr } = Vo(Y), { getReferenceProps: Ra, getFloatingProps: Ma } = Fa([
    mr,
    pr,
    gr,
    hr,
    fr
  ]);
  g.useEffect(() => {
    w && W.setReference(w);
  }, [W.setReference, w]);
  const Oa = /* @__PURE__ */ t(ta, { id: ze, children: br && /* @__PURE__ */ f(
    "div",
    E(k({
      ref: W.setFloating,
      style: E(k(k({}, se), vr), {
        visibility: St != null && St.referenceHidden ? "hidden" : "visible"
      }),
      className: $t
    }, Ma()), {
      "data-status": kr,
      children: [
        /* @__PURE__ */ t(A, { as: "div", className: L[`${Ua}__content`], children: e }),
        /* @__PURE__ */ t(
          Wo,
          k({
            ref: xe,
            context: Y,
            strokeWidth: 1,
            width: 10,
            height: 5,
            style: k({}, Sn(
              T,
              D,
              zt,
              dt
            ))
          }, xn(_t))
        )
      ]
    })
  ) }), io = () => lt === null ? /* @__PURE__ */ t(dr, { children: V ? /* @__PURE__ */ t(ea, E(k({}, H), { children: Oa })) : Oa }) : V ? /* @__PURE__ */ t(ea, E(k({}, H), { children: Oa })) : Oa;
  return /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ t(
      "div",
      E(k({
        "data-testid": "tooltip-trigger",
        ref: W.setReference
      }, Ra()), {
        className: r,
        children: Nt ? _() : _
      })
    ),
    io()
  ] });
}, ds = ({ text: e }) => /* @__PURE__ */ t("div", { children: e }), ia = "tooltip", us = ({
  className: e,
  header: a,
  text: r,
  closeWithX: _,
  theme: o,
  handleCloseAction: n
}) => /* @__PURE__ */ f("div", { className: e, children: [
  (_ || n) && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      "aria-label": "Close tooltip",
      className: L[`${ia}-close`],
      onClick: n,
      children: /* @__PURE__ */ t(P, { source: Ue, kind: o ? H_(o) : "primary" })
    }
  ),
  a && /* @__PURE__ */ t(
    he,
    {
      as: "div",
      size: "xs",
      className: u(L[`${ia}-header`], {
        [L[`${ia}-header--info`]]: _
      }),
      children: a
    }
  ),
  /* @__PURE__ */ t(
    A,
    {
      as: "div",
      className: u({
        [L[`${ia}-text`]]: _,
        [L[`${ia}-text--info`]]: _
      }),
      children: r
    }
  )
] }), xt = "tooltip", An = ({
  header: e,
  text: a,
  image: r,
  closeWithX: _,
  theme: o,
  handleCloseAction: n,
  primaryButton: i,
  secondaryButton: c
}) => {
  const d = (m) => m === "invert" ? "secondary" : m === "important" ? "plain-lock-black" : "high-contrast", l = (m) => m === "invert" ? "link-inverted" : m === "important" ? "text-lock-black" : "text", s = (m, p = !0) => {
    if (!m) return null;
    if (g.isValidElement(m))
      return m;
    const v = m, h = p ? v.kind || d(o) : v.kind || l(o);
    return /* @__PURE__ */ t(
      j,
      E(k({}, v), {
        kind: h,
        onClick: v.handleClick,
        children: v.label
      })
    );
  };
  return /* @__PURE__ */ f("div", { className: L[`${xt}__interactive`], children: [
    (_ || n) && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        "aria-label": "Close tooltip",
        className: L[`${xt}-close`],
        onClick: n,
        children: /* @__PURE__ */ t(P, { source: Ue, kind: o ? H_(o) : "primary" })
      }
    ),
    r && /* @__PURE__ */ t("div", { className: L[`${xt}-image-container`], children: /* @__PURE__ */ t(
      "img",
      {
        className: L[`${xt}-image`],
        src: r.src,
        alt: r.alt
      }
    ) }),
    e && /* @__PURE__ */ t(he, { as: "div", size: "xs", className: L[`${xt}-header`], children: e }),
    /* @__PURE__ */ t("div", { className: L[`${xt}-text`], children: a }),
    /* @__PURE__ */ f(
      "div",
      {
        className: u(
          L[`${xt}-footer`],
          L[`${xt}-footer--interactive`]
        ),
        children: [
          s(i, !0),
          s(c, !1)
        ]
      }
    )
  ] });
}, fe = "guide-tooltip", Dn = ({
  gap: e,
  isVisible: a,
  slide: r,
  disablePointerEvents: _
}) => {
  if (!e) return null;
  const o = {
    top: `${e.top}px`,
    left: "0",
    width: `${e.left}px`,
    height: `${e.height}px`
  }, n = {
    top: `${e.top}px`,
    left: `${e.right}px`,
    width: `calc(100% - ${e.right}px)`,
    height: `${e.height}px`
  }, i = {
    top: "0",
    left: "0",
    width: "100%",
    height: `${e.top}px`
  }, c = {
    top: `${e.bottom}px`,
    left: "0",
    width: "100%",
    height: `calc(100% - ${e.bottom}px)`
  }, d = {
    top: `${e.top}px`,
    left: `${e.left}px`,
    width: `${e.width}px`,
    height: `${e.height}px`,
    backgroundColor: "transparent"
  };
  return /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u({
          [L[`${fe}__overlay`]]: !0,
          [L[`${fe}__overlay--visible`]]: a,
          [L[`${fe}__overlay--slide`]]: r
        }),
        style: o
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: u({
          [L[`${fe}__overlay`]]: !0,
          [L[`${fe}__overlay--visible`]]: a,
          [L[`${fe}__overlay--slide`]]: r
        }),
        style: i
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: u({
          [L[`${fe}__overlay`]]: !0,
          [L[`${fe}__overlay--visible`]]: a,
          [L[`${fe}__overlay--slide`]]: r
        }),
        style: n
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        className: u({
          [L[`${fe}__overlay`]]: !0,
          [L[`${fe}__overlay--visible`]]: a,
          [L[`${fe}__overlay--slide`]]: r
        }),
        style: c
      }
    ),
    _ && /* @__PURE__ */ t(
      "div",
      {
        className: u({
          [L[`${fe}__overlay`]]: !0,
          [L[`${fe}__overlay--visible`]]: a,
          [L[`${fe}__overlay--slide`]]: r
        }),
        style: d
      }
    )
  ] });
};
class Pn {
  constructor(a, r) {
    wr(this, "element");
    wr(this, "padding");
    this.element = a, this.padding = r;
  }
  addPadding(a) {
    const r = Math.round(a.left) - this.padding, _ = Math.round(a.top) - this.padding, o = Math.round(a.width) + 2 * this.padding, n = Math.round(a.height) + 2 * this.padding, i = _, c = r, d = i + n, l = c + o;
    return {
      x: r,
      y: _,
      width: o,
      height: n,
      top: i,
      left: c,
      bottom: d,
      right: l
    };
  }
  getBoundingClientRect() {
    return this.addPadding(this.element.getBoundingClientRect());
  }
  get clientWidth() {
    return this.getBoundingClientRect().width;
  }
  get clientHeight() {
    return this.getBoundingClientRect().height;
  }
}
const d_ = 8, u_ = "guide-tooltip", m_ = (e, a) => new Pn(e, a), ms = (e) => {
  const {
    className: a,
    parentElementName: r,
    isVisible: _ = !1,
    shouldSlide: o = !0
  } = e, [n, i] = g.useState(
    null
  ), [c, d] = g.useState(null), [l, s] = g.useState(o), m = () => {
    n && (d(
      m_(
        n,
        d_
      ).getBoundingClientRect()
    ), s(!1));
  };
  return g.useEffect(() => {
    if (n !== null)
      return window.addEventListener("resize", m), window.addEventListener("scroll", m), () => {
        window.removeEventListener("resize", m), window.removeEventListener("scroll", m);
      };
  }, [n]), g.useEffect(() => {
    if (r) {
      const p = document.querySelector(r);
      i(p);
    }
  }, [r]), g.useEffect(() => {
    n && d(
      m_(
        n,
        d_
      ).getBoundingClientRect()
    ), s(!0);
  }, [n]), n && _ && c ? /* @__PURE__ */ f(ea, { children: [
    /* @__PURE__ */ t(
      Dn,
      {
        gap: c,
        isVisible: _,
        slide: l,
        disablePointerEvents: !0
      }
    ),
    /* @__PURE__ */ t(
      Ut,
      E(k({}, e), {
        triggerRenderer: /* @__PURE__ */ t(ne, {}),
        referenceElement: {
          getBoundingClientRect: () => c,
          contextElement: n
        },
        className: u({
          [L[u_]]: !0,
          [L[`${u_}--slide`]]: l,
          className: a
        }),
        children: e.children
      })
    )
  ] }) : null;
}, ca = "reports-tooltip", ps = ({
  title: e,
  description: a,
  children: r
}) => /* @__PURE__ */ f("div", { className: L[ca], children: [
  /* @__PURE__ */ f("div", { className: L[`${ca}__heading`], children: [
    /* @__PURE__ */ t(A, { as: "div", className: L[`${ca}__heading__title`], children: e }),
    /* @__PURE__ */ t(
      A,
      {
        as: "div",
        size: "xs",
        className: L[`${ca}__heading__description`],
        children: a
      }
    )
  ] }),
  /* @__PURE__ */ t("div", { className: L[`${ca}__content`], children: /* @__PURE__ */ t(A, { as: "div", children: r }) })
] }), Q = {
  "action-bar": "lc-ActionBar-module__action-bar___yfLdO",
  "action-bar__items": "lc-ActionBar-module__action-bar__items___E8fX6",
  "action-bar__items--scroll": "lc-ActionBar-module__action-bar__items--scroll___izP27",
  "action-bar__items__button-wrapper": "lc-ActionBar-module__action-bar__items__button-wrapper___sgdUc",
  "action-bar__items__button-wrapper--active": "lc-ActionBar-module__action-bar__items__button-wrapper--active___TZteM",
  "action-bar__items__button-wrapper--hidden": "lc-ActionBar-module__action-bar__items__button-wrapper--hidden___43H6t",
  "action-bar__items__button-wrapper--vertical": "lc-ActionBar-module__action-bar__items__button-wrapper--vertical___8Aq0c",
  "action-bar__items__button-wrapper__button": "lc-ActionBar-module__action-bar__items__button-wrapper__button___r5jpx",
  "action-bar__items__button-wrapper__button--with-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-divider___bTyao",
  "action-bar__items__button-wrapper__button--with-vertical-divider": "lc-ActionBar-module__action-bar__items__button-wrapper__button--with-vertical-divider___DkEFm",
  "action-bar__items__tooltip": "lc-ActionBar-module__action-bar__items__tooltip___BxN2p",
  "action-bar__menu-wrapper": "lc-ActionBar-module__action-bar__menu-wrapper___y26Bl",
  "action-bar__menu-wrapper--active": "lc-ActionBar-module__action-bar__menu-wrapper--active___E4iCs",
  "action-bar__menu-wrapper--vertical": "lc-ActionBar-module__action-bar__menu-wrapper--vertical___wU4tc",
  "action-bar__menu-wrapper__button": "lc-ActionBar-module__action-bar__menu-wrapper__button___0Nluq",
  "action-bar__menu-wrapper__button--active": "lc-ActionBar-module__action-bar__menu-wrapper__button--active___-NlsX",
  "action-bar__menu-wrapper__button__with-item": "lc-ActionBar-module__action-bar__menu-wrapper__button__with-item___Nvb-H",
  "fade-in": "lc-ActionBar-module__fade-in___NlmMy",
  "action-bar__menu-wrapper__button__icon": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon___dFIfe",
  "action-bar__menu-wrapper__button__icon--open": "lc-ActionBar-module__action-bar__menu-wrapper__button__icon--open___shQMz",
  "action-bar__menu-wrapper__trigger-vertical": "lc-ActionBar-module__action-bar__menu-wrapper__trigger-vertical___yaJyY",
  "action-bar--vertical": "lc-ActionBar-module__action-bar--vertical___9uO-q",
  "action-bar__items--with-menu": "lc-ActionBar-module__action-bar__items--with-menu___OfqL0",
  "action-bar__items__button": "lc-ActionBar-module__action-bar__items__button___N1Qtp",
  "action-bar__items__button--active": "lc-ActionBar-module__action-bar__items__button--active___adIVs"
}, z_ = "action-bar__items", Vt = `${z_}__button-wrapper`, Fn = ({
  option: e,
  isActive: a,
  vertical: r
}) => {
  const _ = u(Q[Vt], {
    [Q[`${Vt}--active`]]: a,
    [Q[`${Vt}--vertical`]]: r
  }), o = /* @__PURE__ */ t(
    j,
    {
      id: e.key,
      title: e != null && e.showTooltip ? void 0 : e.label,
      kind: "plain",
      onClick: e.onClick,
      icon: e.element,
      className: u(Q[`${Vt}__button`], {
        [Q[`${Vt}__button--with-vertical-divider`]]: r && e.withDivider,
        [Q[`${Vt}__button--with-divider`]]: !r && e.withDivider
      })
    },
    e.key
  );
  return e.showTooltip ? /* @__PURE__ */ t(
    "div",
    {
      "data-testid": e.key,
      className: _,
      children: /* @__PURE__ */ t(
        Ut,
        {
          kind: "invert",
          placement: r ? "left" : "bottom",
          triggerClassName: Q[`${z_}__tooltip`],
          triggerRenderer: () => o,
          floatingStrategy: "fixed",
          useClickHookProps: {
            ignoreMouse: !0
          },
          hoverOnDelay: 800,
          hoverOffDelay: 0,
          children: /* @__PURE__ */ t("div", { children: e.label })
        }
      )
    },
    e.key
  ) : /* @__PURE__ */ t("div", { "data-testid": e.key, className: _, children: o });
}, Ha = "action-bar", pt = "action-bar__menu-wrapper", Rn = 44, gs = ({
  className: e,
  id: a = "action-bar-area",
  type: r = "menu",
  options: _,
  activeOptionKey: o,
  vertical: n,
  menuFooter: i
}) => {
  const [c, d] = g.useState(
    _.length
  ), [l, s] = g.useState([]), [m, p] = g.useState(!1), v = r === "scroll", h = u(
    Q[Ha],
    e,
    n && Q[`${Ha}--vertical`]
  ), b = !v && l.length !== 0;
  g.useEffect(() => {
    v || (_.length > c ? s(_.slice(c, _.length)) : s([]));
  }, [_, c]), g.useEffect(() => {
    const N = !!window.ResizeObserver;
    if (!v && N) {
      const B = new ResizeObserver(($) => {
        const { width: x, height: w } = $[0].contentRect, S = n ? w : x, I = l.length > 0 ? 60 : 0, R = Math.floor(
          (S - I) / Rn
        );
        R >= 0 && R !== c && d(R);
      });
      return B.observe(document.querySelector(`#${a}`)), () => B.disconnect();
    }
  }, [l, v, c]);
  const y = g.useCallback(() => l.reduce(
    (N, B) => {
      if (!B.hideInMenu) {
        const $ = {
          key: B.key,
          element: /* @__PURE__ */ t(Lr, { leftNode: B.element, children: B.label }),
          withDivider: B.withDivider,
          onClick: B.onClick
        };
        N.push($);
      }
      return N;
    },
    []
  ), [l]), C = l.find((N) => N.key === o);
  return /* @__PURE__ */ f("div", { id: a, className: h, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(Q[`${Ha}__items`], {
          [Q[`${Ha}__items--scroll`]]: v
        }),
        children: _.slice(0, c).map((N) => /* @__PURE__ */ t(
          Fn,
          {
            option: N,
            isActive: N.key === o,
            vertical: n
          }
        ))
      }
    ),
    b && /* @__PURE__ */ t(
      "div",
      {
        className: u(
          Q[pt],
          C && Q[`${pt}--active`],
          n && Q[`${pt}--vertical`]
        ),
        children: /* @__PURE__ */ t(
          G_,
          {
            selectedOptions: o ? [o] : [],
            onOpen: () => p(!0),
            onClose: () => p(!1),
            floatingStrategy: "fixed",
            placement: n ? "left-start" : "bottom-end",
            options: y(),
            triggerClassName: u(
              n && Q[`${pt}__trigger-vertical`]
            ),
            triggerRenderer: /* @__PURE__ */ t(
              j,
              {
                className: u(
                  Q[`${pt}__button`],
                  C && Q[`${pt}__button--active`]
                ),
                kind: "plain",
                icon: /* @__PURE__ */ t(
                  P,
                  {
                    source: Ht,
                    kind: "primary",
                    className: u(
                      Q[`${pt}__button__icon`],
                      m && Q[`${pt}__button__icon--open`]
                    )
                  }
                ),
                iconPosition: "right",
                children: C && /* @__PURE__ */ t(
                  "div",
                  {
                    className: u(
                      Q[`${pt}__button__with-item`]
                    ),
                    children: C.element
                  }
                )
              }
            ),
            footer: i
          }
        )
      }
    )
  ] });
}, Wt = {
  "main-wrapper": "lc-ActionCard-module__main-wrapper___-LUjH",
  "action-card": "lc-ActionCard-module__action-card___gPaoW",
  "action-card__column": "lc-ActionCard-module__action-card__column___KgMRx",
  "action-card__column--first": "lc-ActionCard-module__action-card__column--first___BWQwi",
  "action-card__column--second": "lc-ActionCard-module__action-card__column--second___-X-gO"
}, Pt = "action-card", hs = ({
  className: e,
  children: a,
  secondColumn: r,
  firstColumnClassName: _,
  secondColumnClassName: o,
  onClick: n
}) => {
  const i = u(Wt[Pt], e), c = (l) => {
    l.currentTarget === document.activeElement && (n == null || n());
  }, d = (l) => {
    l.currentTarget === document.activeElement && (l.key === "Enter" || l.key === " " || l.key === "Spacebar" || l.key === "Space") && (l.preventDefault(), n == null || n());
  };
  return /* @__PURE__ */ t("div", { className: Wt["main-wrapper"], children: /* @__PURE__ */ f(
    "div",
    {
      role: "button",
      "aria-label": "Action Card",
      tabIndex: 0,
      className: i,
      onClick: c,
      onKeyDown: d,
      children: [
        /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${Pt}-first-column`,
            className: u(
              Wt[`${Pt}__column`],
              Wt[`${Pt}__column--first`],
              _
            ),
            children: a
          }
        ),
        r && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${Pt}-second-column`,
            className: u(
              Wt[`${Pt}__column`],
              Wt[`${Pt}__column--second`],
              o
            ),
            children: r
          }
        )
      ]
    }
  ) });
}, Mn = "lc-Alert-module__alert___zP4AL", On = "lc-Alert-module__alert__icon___1SDHT", Ln = "lc-Alert-module__alert__content___wwP8E", Gn = "lc-Alert-module__alert__content__wrapper___gw9Mg", Un = "lc-Alert-module__alert__content__wrapper__text___2x5d-", Hn = "lc-Alert-module__alert__content__wrapper__cta___ocxGq", zn = "lc-Alert-module__alert__content__wrapper__cta__link___ZqOjp", Pe = {
  alert: Mn,
  alert__icon: On,
  alert__content: Ln,
  alert__content__wrapper: Gn,
  alert__content__wrapper__text: Un,
  alert__content__wrapper__cta: Hn,
  alert__content__wrapper__cta__link: zn,
  "alert__close-icon": "lc-Alert-module__alert__close-icon___jbDQJ",
  "alert--small": "lc-Alert-module__alert--small___GsHEV",
  "alert--medium": "lc-Alert-module__alert--medium___5PGR3",
  "alert--large": "lc-Alert-module__alert--large___068A5",
  "alert--info": "lc-Alert-module__alert--info___GLCTZ",
  "alert--warning": "lc-Alert-module__alert--warning___y0-zK",
  "alert--success": "lc-Alert-module__alert--success___RXWVi",
  "alert--error": "lc-Alert-module__alert--error___EK-vJ"
}, Vn = {
  info: {
    source: Na,
    kind: "link"
  },
  warning: {
    source: T_,
    kind: "warning"
  },
  success: {
    source: zr,
    kind: "success"
  },
  error: {
    source: A_,
    kind: "error"
  }
}, Fe = "alert", fs = (c) => {
  var d = c, {
    children: e,
    className: a,
    primaryButton: r,
    secondaryButton: _,
    kind: o = "info",
    onClose: n
  } = d, i = F(d, [
    "children",
    "className",
    "primaryButton",
    "secondaryButton",
    "kind",
    "onClose"
  ]);
  const l = g.useRef(null), [s, m] = g.useState(null), p = u(
    Pe[Fe],
    Pe[`${Fe}--${o}`],
    s === "large" && Pe[`${Fe}--large`],
    s === "medium" && Pe[`${Fe}--medium`],
    s === "small" && Pe[`${Fe}--small`],
    a
  );
  return g.useEffect(() => {
    const v = () => l.current && l.current.offsetWidth <= 400 ? m("small") : l.current && l.current.offsetWidth > 400 && l.current.offsetWidth <= 800 ? m("medium") : m("large"), h = P_(() => {
      v();
    }, 500);
    return window.addEventListener("resize", h), v(), () => window.removeEventListener("resize", h);
  }), /* @__PURE__ */ f("div", E(k({ ref: l, className: p }, i), { children: [
    /* @__PURE__ */ f("div", { className: Pe[`${Fe}__content`], children: [
      /* @__PURE__ */ f("div", { className: Pe[`${Fe}__content__wrapper`], children: [
        /* @__PURE__ */ t(
          P,
          E(k({}, Vn[o]), {
            size: "large",
            className: Pe[`${Fe}__icon`]
          })
        ),
        /* @__PURE__ */ t(
          A,
          {
            as: "div",
            className: Pe[`${Fe}__content__wrapper__text`],
            children: e
          }
        )
      ] }),
      (r || _) && /* @__PURE__ */ f("div", { className: Pe[`${Fe}__content__wrapper__cta`], children: [
        r && /* @__PURE__ */ t(
          j,
          E(k({
            kind: "high-contrast",
            onClick: r.handleClick
          }, r), {
            children: r.label
          })
        ),
        _ && /* @__PURE__ */ t(
          j,
          E(k({
            className: u(
              Pe[`${Fe}__content__wrapper__cta__link`],
              _.className
            ),
            kind: "text",
            onClick: _.handleClick
          }, _), {
            children: _.label
          })
        )
      ] })
    ] }),
    n && /* @__PURE__ */ t(
      j,
      {
        "aria-label": "Close alert",
        className: Pe[`${Fe}__close-icon`],
        size: "compact",
        kind: "plain",
        icon: /* @__PURE__ */ t(P, { source: Ue }),
        onClick: n
      }
    )
  ] }));
}, Wn = 705, Kn = 751, Re = {
  "app-frame": "lc-AppFrame-module__app-frame___LeOAC",
  "app-frame__page-content-container": "lc-AppFrame-module__app-frame__page-content-container___XhCPO",
  "app-frame__page-content-container--mobile": "lc-AppFrame-module__app-frame__page-content-container--mobile___2HnOq",
  "app-frame__page-content-container__top-bar": "lc-AppFrame-module__app-frame__page-content-container__top-bar___cl5Ek",
  "app-frame__page-content-container__top-bar--visible": "lc-AppFrame-module__app-frame__page-content-container__top-bar--visible___ZfcRZ",
  "app-frame__page-content-container__content-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper___V0yIo",
  "app-frame__page-content-container__content-wrapper--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper--mobile___iUDnN",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper___eAkwB",
  "app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__nav-bar-wrapper--open___-rAxE",
  "app-frame__page-content-container__content-wrapper__content": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content___zHmoo",
  "app-frame__page-content-container__content-wrapper__content--mobile": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__content--mobile___HKy-9",
  "app-frame__page-content-container__content-wrapper__mobile-top-bar": "lc-AppFrame-module__app-frame__page-content-container__content-wrapper__mobile-top-bar___JeGo3"
}, V_ = "app-frame", We = `${V_}__page-content-container`, Yn = (e) => {
  const {
    children: a,
    className: r,
    navigation: _,
    mobileNavigation: o,
    sideNavigation: n,
    topBar: i,
    topBarClassName: c,
    sideNavigationContainerClassName: d,
    contentClassName: l
  } = e, s = u(Re[V_], r), {
    isSideNavigationVisible: m,
    setIsMobileViewEnabled: p,
    isMobileViewEnabled: v
  } = Xr(), h = g.useRef(null), { isOpen: b, isMounted: y } = Gt({
    isVisible: m,
    elementRef: h
  }), { isMobile: C, handleResizeRef: N } = tn({
    mobileBreakpoint: Wn
  });
  return g.useEffect(() => {
    p(C);
  }, [C]), /* @__PURE__ */ f("div", { className: s, ref: N, children: [
    !v && _,
    /* @__PURE__ */ f(
      "div",
      {
        className: u(Re[We], {
          [Re[`${We}--mobile`]]: v
        }),
        children: [
          !v && /* @__PURE__ */ t(
            "div",
            {
              className: u(
                Re[`${We}__top-bar`],
                {
                  [Re[`${We}__top-bar--visible`]]: i
                },
                c
              ),
              children: i
            }
          ),
          /* @__PURE__ */ f(
            "div",
            {
              className: u(Re[`${We}__content-wrapper`], {
                [Re[`${We}__content-wrapper--mobile`]]: v
              }),
              children: [
                !v && n && /* @__PURE__ */ t(
                  "div",
                  {
                    ref: h,
                    className: u(
                      Re[`${We}__content-wrapper__nav-bar-wrapper`],
                      "lc-dark-theme",
                      d,
                      {
                        [Re[`${We}__content-wrapper__nav-bar-wrapper--open`]]: b
                      }
                    ),
                    children: y && n
                  }
                ),
                v && /* @__PURE__ */ t(
                  "div",
                  {
                    className: Re[`${We}__content-wrapper__mobile-top-bar`],
                    children: i
                  }
                ),
                /* @__PURE__ */ t(
                  "div",
                  {
                    className: u(
                      Re[`${We}__content-wrapper__content`],
                      l,
                      {
                        [Re[`${We}__content-wrapper__content--mobile`]]: v
                      }
                    ),
                    children: a
                  }
                ),
                v && o
              ]
            }
          )
        ]
      }
    )
  ] });
}, bs = (e) => {
  const _ = e, { isSideNavigationVisible: a } = _, r = F(_, ["isSideNavigationVisible"]);
  return /* @__PURE__ */ t(en, { isSideNavigationVisible: a, children: /* @__PURE__ */ t(Yn, k({}, r)) });
}, Kt = {
  "side-navigation": "lc-SideNavigation-module__side-navigation___FuFGb",
  "side-navigation__header": "lc-SideNavigation-module__side-navigation__header___du0Jr",
  "side-navigation__header__title": "lc-SideNavigation-module__side-navigation__header__title___2dGWf",
  "side-navigation__footer": "lc-SideNavigation-module__side-navigation__footer___9LLon",
  "side-navigation__nav-wrapper": "lc-SideNavigation-module__side-navigation__nav-wrapper___8Opuh",
  "side-navigation__nav-wrapper--no-gaps": "lc-SideNavigation-module__side-navigation__nav-wrapper--no-gaps___1ApnT"
}, Yt = "side-navigation", vs = ({
  children: e,
  className: a,
  title: r,
  customHeader: _,
  customFooter: o,
  noGaps: n,
  rightNode: i
}) => {
  const c = _ || /* @__PURE__ */ f("div", { className: Kt[`${Yt}__header`], children: [
    /* @__PURE__ */ t(he, { size: "sm", className: Kt[`${Yt}__header__title`], children: r }),
    i
  ] });
  return /* @__PURE__ */ f(
    "div",
    {
      "data-testid": "side-navigation",
      className: u(Kt[Yt], a),
      children: [
        c,
        /* @__PURE__ */ t(
          "div",
          {
            className: u(Kt[`${Yt}__nav-wrapper`], {
              [Kt[`${Yt}__nav-wrapper--no-gaps`]]: n
            }),
            children: e
          }
        ),
        o && /* @__PURE__ */ t("div", { className: Kt[`${Yt}__footer`], children: o })
      ]
    }
  );
};
function Sa() {
}
const Xn = "side-navigation-item-test-id", Zn = "side-navigation-active-item-test-id", qn = "side-navigation-parent-icon", Me = {
  "side-navigation-item": "lc-SideNavigationItem-module__side-navigation-item___QCTSQ",
  "side-navigation-item__anchor": "lc-SideNavigationItem-module__side-navigation-item__anchor___PI--g",
  "side-navigation-item__custom-label": "lc-SideNavigationItem-module__side-navigation-item__custom-label___ATpTF",
  "side-navigation-item__anchor--main-entry": "lc-SideNavigationItem-module__side-navigation-item__anchor--main-entry___h9Lwx",
  "side-navigation-item__anchor--active": "lc-SideNavigationItem-module__side-navigation-item__anchor--active___iXojJ",
  "side-navigation-item__anchor--icon-hidden": "lc-SideNavigationItem-module__side-navigation-item__anchor--icon-hidden___KlK37",
  "side-navigation-item__left-node": "lc-SideNavigationItem-module__side-navigation-item__left-node___otK1S",
  "side-navigation-item__left-node--active": "lc-SideNavigationItem-module__side-navigation-item__left-node--active___5PNWM",
  "side-navigation-item__right-node": "lc-SideNavigationItem-module__side-navigation-item__right-node___MOwqj",
  "side-navigation-item__label": "lc-SideNavigationItem-module__side-navigation-item__label___dpMyX",
  "side-navigation-item__label--active": "lc-SideNavigationItem-module__side-navigation-item__label--active___4vImp",
  "side-navigation-item__custom-label--active": "lc-SideNavigationItem-module__side-navigation-item__custom-label--active___UWDu9"
}, Oe = "side-navigation-item", jn = (p) => {
  var v = p, {
    leftNode: e,
    shouldKeepIconSpace: a = !0,
    url: r,
    label: _,
    className: o,
    rightNode: n,
    onClick: i,
    isActive: c,
    isMainEntry: d,
    onItemHover: l,
    isIconHidden: s
  } = v, m = F(v, [
    "leftNode",
    "shouldKeepIconSpace",
    "url",
    "label",
    "className",
    "rightNode",
    "onClick",
    "isActive",
    "isMainEntry",
    "onItemHover",
    "isIconHidden"
  ]);
  const h = typeof _ == "string", b = (C) => {
    C.preventDefault(), i == null || i();
  }, y = (C) => {
    C.key === "Enter" && (C.preventDefault(), i == null || i());
  };
  return /* @__PURE__ */ t(
    "li",
    E(k({
      className: u([Me[Oe], o]),
      "data-testid": c ? Zn : Xn,
      "data-active": c
    }, m), {
      children: /* @__PURE__ */ f(
        "a",
        {
          tabIndex: 0,
          className: u(Me[`${Oe}__anchor`], {
            [Me[`${Oe}__anchor--active`]]: c,
            [Me[`${Oe}__anchor--main-entry`]]: d,
            [Me[`${Oe}__anchor--icon-hidden`]]: s
          }),
          href: r,
          onClick: b,
          onKeyDown: y,
          onMouseEnter: l || Sa,
          onFocus: l || Sa,
          children: [
            a && /* @__PURE__ */ t(
              "span",
              {
                className: u(Me[`${Oe}__left-node`], {
                  [Me[`${Oe}__left-node--active`]]: c || d
                }),
                "data-testid": qn,
                children: e
              }
            ),
            h ? /* @__PURE__ */ t(
              A,
              {
                bold: c || d,
                className: u(Me[`${Oe}__label`], {
                  [Me[`${Oe}__label--active`]]: c || d
                }),
                children: _
              }
            ) : /* @__PURE__ */ t(
              "span",
              {
                className: u(Me[`${Oe}__custom-label`], {
                  [Me[`${Oe}__custom-label--active`]]: c || d
                }),
                children: _
              }
            ),
            n && /* @__PURE__ */ t("span", { className: Me[`${Oe}__right-node`], children: n })
          ]
        }
      )
    })
  );
}, Bt = {
  "side-navigation-group": "lc-SideNavigationGroup-module__side-navigation-group___Cgruk",
  "side-navigation-group__chevron": "lc-SideNavigationGroup-module__side-navigation-group__chevron___4wv4s",
  "side-navigation-group__chevron--active": "lc-SideNavigationGroup-module__side-navigation-group__chevron--active___v7QK7",
  "side-navigation-group__label": "lc-SideNavigationGroup-module__side-navigation-group__label___pDDzF",
  "side-navigation-group__simple-label": "lc-SideNavigationGroup-module__side-navigation-group__simple-label___-KO5t",
  "side-navigation-group__list-wrapper": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper___moivM",
  "side-navigation-group__list-wrapper--expanded": "lc-SideNavigationGroup-module__side-navigation-group__list-wrapper--expanded___cwPUQ",
  "side-navigation-group__list": "lc-SideNavigationGroup-module__side-navigation-group__list___Srb-J"
}, Et = "side-navigation-group", Qn = 34, ks = ({
  label: e,
  rightNode: a,
  className: r,
  children: _,
  isCollapsible: o,
  onItemHover: n,
  shouldOpenOnInit: i = !1
}) => {
  const [c, d] = g.useState(!1), [l, s] = g.useState(0), m = g.useRef(!1), p = g.useRef(null), { isOpen: v, isMounted: h, setShouldBeVisible: b } = Gt({
    isVisible: !o || i,
    elementRef: p
  }), y = typeof a == "function" ? a(v) : a, C = typeof e == "function" ? e(v) : e, N = () => b(!0), B = () => {
    o && b(($) => !$);
  };
  return g.useEffect(() => {
    if (!_ || !o)
      return;
    const $ = _, x = !!($ != null && $.some(
      (S) => {
        var I;
        return (I = S.props) == null ? void 0 : I.isActive;
      }
    ));
    d(x);
    const w = (($ == null ? void 0 : $.length) || 0) * Qn;
    s(w);
  }, [_]), g.useEffect(() => {
    !m.current && c && N(), m.current = c;
  }, [c, m.current, i]), /* @__PURE__ */ f("div", { "data-testid": "side-navigation-group", className: Bt[Et], children: [
    o ? /* @__PURE__ */ t(
      jn,
      {
        leftNode: /* @__PURE__ */ t(
          "div",
          {
            className: u(Bt[`${Et}__chevron`], {
              [Bt[`${Et}__chevron--active`]]: v
            }),
            children: /* @__PURE__ */ t(P, { source: ir, size: "small" })
          }
        ),
        label: /* @__PURE__ */ t(A, { className: Bt[`${Et}__label`], bold: !0, children: C }),
        isMainEntry: !0,
        onClick: B,
        onItemHover: n,
        rightNode: y
      }
    ) : /* @__PURE__ */ t(
      A,
      {
        bold: !0,
        className: Bt[`${Et}__simple-label`],
        onMouseEnter: n || Sa,
        children: C
      }
    ),
    /* @__PURE__ */ t(
      "div",
      {
        ref: p,
        className: u([
          Bt[`${Et}__list-wrapper`],
          {
            [Bt[`${Et}__list-wrapper--expanded`]]: v
          }
        ]),
        style: o ? { maxHeight: v ? l : 0 } : void 0,
        children: h && /* @__PURE__ */ t("ul", { className: u(Bt[`${Et}__list`], r), children: _ })
      }
    )
  ] });
}, p_ = {
  "navigation-group": "lc-NavigationGroup-module__navigation-group___61JTX",
  "navigation-group--scrollable": "lc-NavigationGroup-module__navigation-group--scrollable___BL8-e"
}, g_ = "navigation-group", ys = (o) => {
  var n = o, {
    children: e,
    className: a,
    scrollable: r
  } = n, _ = F(n, [
    "children",
    "className",
    "scrollable"
  ]);
  return /* @__PURE__ */ t(
    "ul",
    E(k({
      className: u(
        p_[g_],
        {
          [p_[`${g_}--scrollable`]]: r
        },
        a
      )
    }, _), {
      children: e
    })
  );
};
function Jn(e, a) {
  return e > a ? `${a}+` : `${e}`;
}
const ei = "lc-Badge-module__badge___ZbEBU", ti = "lc-Badge-module__badge__dot___MSVVf", za = {
  badge: ei,
  badge__dot: ti,
  "badge--large": "lc-Badge-module__badge--large___P4qtE",
  "badge--medium": "lc-Badge-module__badge--medium___5HFVb",
  "badge--compact": "lc-Badge-module__badge--compact___AUaWg",
  "badge--primary": "lc-Badge-module__badge--primary___wOrp-",
  "badge--secondary": "lc-Badge-module__badge--secondary___mAh3w",
  "badge--tertiary": "lc-Badge-module__badge--tertiary___rFqKw"
}, Va = "badge", rr = (c) => {
  var d = c, {
    className: e,
    count: a = 0,
    max: r = 99,
    kind: _ = "primary",
    size: o = "medium",
    type: n = "counter"
  } = d, i = F(d, [
    "className",
    "count",
    "max",
    "kind",
    "size",
    "type"
  ]);
  const l = u(
    e,
    za[Va],
    za[`${Va}--${_}`],
    za[`${Va}--${o}`]
  ), s = {
    counter: Jn(a, r),
    alert: "!",
    dot: /* @__PURE__ */ t("span", { "data-testid": "badge-dot", className: za[`${Va}__dot`] })
  }[n];
  return /* @__PURE__ */ t("span", E(k({ className: l }, i), { children: s }));
}, kt = {
  "navigation-item": "lc-NavigationItem-module__navigation-item___KVL3Y",
  "navigation-item--disabled": "lc-NavigationItem-module__navigation-item--disabled___VY8pA",
  "navigation-item__badge": "lc-NavigationItem-module__navigation-item__badge___6RiK5",
  "navigation-item__button": "lc-NavigationItem-module__navigation-item__button___g-pAI",
  "navigation-item__button--disabled": "lc-NavigationItem-module__navigation-item__button--disabled___POYlQ",
  "navigation-item__button--active": "lc-NavigationItem-module__navigation-item__button--active___zsO2E",
  "navigation-item__button--opacity": "lc-NavigationItem-module__navigation-item__button--opacity___buZjS",
  "navigation-item__button--mobile": "lc-NavigationItem-module__navigation-item__button--mobile___GqQwP"
}, yt = "navigation-item", ai = (e, a) => typeof e == "number" ? /* @__PURE__ */ t(
  rr,
  {
    "data-testid": `${a}-badge-count`,
    className: kt[`${yt}__badge`],
    size: "compact",
    count: e
  }
) : /* @__PURE__ */ t(
  rr,
  {
    "data-testid": `${a}-badge`,
    className: kt[`${yt}__badge`],
    size: "compact",
    type: e
  }
), ws = (m) => {
  var p = m, {
    id: e,
    label: a,
    icon: r,
    url: _,
    disableOpacity: o,
    disabled: n = !1,
    badge: i,
    isActive: c,
    onClick: d,
    className: l
  } = p, s = F(p, [
    "id",
    "label",
    "icon",
    "url",
    "disableOpacity",
    "disabled",
    "badge",
    "isActive",
    "onClick",
    "className"
  ]);
  const { isMobileViewEnabled: v } = Xr();
  return /* @__PURE__ */ t(
    "li",
    {
      className: u(
        kt[yt],
        {
          [kt[`${yt}--disabled`]]: n
        },
        l
      ),
      children: /* @__PURE__ */ t(
        Ut,
        {
          floatingStrategy: "fixed",
          placement: "right",
          kind: "invert",
          isVisible: v || !a || n ? !1 : void 0,
          offsetMainAxis: 12,
          hoverOnDelay: 400,
          useClickHookProps: { ignoreMouse: !0 },
          useDismissHookProps: {
            referencePress: !0,
            referencePressEvent: "click"
          },
          triggerRenderer: /* @__PURE__ */ f(ne, { children: [
            /* @__PURE__ */ f(
              "a",
              E(k({
                tabIndex: n ? -1 : 0,
                "aria-label": a,
                className: u(
                  kt[`${yt}__button`],
                  {
                    [kt[`${yt}__button--active`]]: c,
                    [kt[`${yt}__button--opacity`]]: o,
                    [kt[`${yt}__button--disabled`]]: n,
                    [kt[`${yt}__button--mobile`]]: v
                  },
                  "lc-dark-theme"
                ),
                onClick: (h) => !n && d(h, e),
                href: _
              }, s), {
                children: [
                  r,
                  v && a
                ]
              })
            ),
            !!i && ai(i, e)
          ] }),
          children: a
        }
      )
    },
    e
  );
}, ri = "lc-Navigation-module__navigation___oNBOL", _i = {
  navigation: ri
}, oi = "navigation", Cs = (_) => {
  var o = _, {
    children: e,
    className: a
  } = o, r = F(o, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ t("nav", E(k({ className: u(_i[oi], a) }, r), { children: e }));
}, Qe = {
  "navigation-top-bar": "lc-NavigationTopBar-module__navigation-top-bar___WJzyv",
  "navigation-top-bar__title": "lc-NavigationTopBar-module__navigation-top-bar__title___ROYDp",
  "navigation-top-bar__alerts-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alerts-wrapper___wkJlE",
  "navigation-top-bar__alert": "lc-NavigationTopBar-module__navigation-top-bar__alert___x2xOO",
  "navigation-top-bar__alert--open": "lc-NavigationTopBar-module__navigation-top-bar__alert--open___ESpyQ",
  "navigation-top-bar__alert__wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper___rOnri",
  "navigation-top-bar__alert__wrapper--open": "lc-NavigationTopBar-module__navigation-top-bar__alert__wrapper--open___v-NG3",
  "navigation-top-bar__alert--info": "lc-NavigationTopBar-module__navigation-top-bar__alert--info___kfakN",
  "navigation-top-bar__alert--success": "lc-NavigationTopBar-module__navigation-top-bar__alert--success___s3tbr",
  "navigation-top-bar__alert--warning": "lc-NavigationTopBar-module__navigation-top-bar__alert--warning___giSMt",
  "navigation-top-bar__alert--error": "lc-NavigationTopBar-module__navigation-top-bar__alert--error___N4jFl",
  "navigation-top-bar__alert__children-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__children-wrapper___cfSYX",
  "navigation-top-bar__alert__close-button": "lc-NavigationTopBar-module__navigation-top-bar__alert__close-button___odqcf",
  "navigation-top-bar__alert__cta-wrapper": "lc-NavigationTopBar-module__navigation-top-bar__alert__cta-wrapper___0QtM0"
}, _r = "navigation-top-bar", It = `${_r}__alert`, W_ = ({
  children: e,
  className: a,
  additionalNodes: r
}) => {
  const { isMobileViewEnabled: _ } = Xr();
  return /* @__PURE__ */ f("div", { className: u(Qe[_r], a), children: [
    /* @__PURE__ */ t("div", { className: Qe[`${_r}__alerts-wrapper`], children: e }),
    !_ && r
  ] });
}, ni = ({
  children: e,
  className: a,
  "data-testid": r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(Qe[`${_r}__title`], a),
    "data-testid": r,
    children: e
  }
), ii = ({
  className: e,
  kind: a = "info",
  closeButton: r,
  children: _,
  primaryCta: o,
  secondaryCta: n,
  isVisible: i = !0
}) => {
  const [c, d] = g.useState(!1), l = g.useRef(null), { isMounted: s, isOpen: m } = Gt({
    isVisible: i,
    elementRef: l
  }), p = g.useCallback(
    (B) => Zr(
      B,
      ($) => d($.width < Kn)
    ),
    []
  ), v = a === "warning" ? "link-inverted" : "text", h = a === "warning" ? "plain-lock-black" : "high-contrast", b = o == null ? void 0 : o.kind, y = n == null ? void 0 : n.kind, C = o || n ? /* @__PURE__ */ f("div", { className: Qe[`${It}__cta-wrapper`], children: [
    o && /* @__PURE__ */ t(
      j,
      E(k({
        size: "compact"
      }, o), {
        kind: c ? v : b || h,
        children: o.label
      })
    ),
    n && /* @__PURE__ */ t(
      j,
      E(k({
        size: "compact"
      }, n), {
        kind: c ? v : y || h,
        children: n.label
      })
    )
  ] }) : null, N = /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ f("div", { className: Qe[`${It}__children-wrapper`], children: [
      _,
      C
    ] }),
    r && /* @__PURE__ */ t(
      "button",
      E(k({
        className: Qe[`${It}__close-button`]
      }, r), {
        children: /* @__PURE__ */ t(P, { source: Ue })
      })
    )
  ] });
  return /* @__PURE__ */ t(ne, { children: s && /* @__PURE__ */ t("div", { ref: p, children: /* @__PURE__ */ t(
    "div",
    {
      className: u(
        Qe[`${It}__wrapper`],
        {
          [Qe[`${It}__wrapper--open`]]: m
        },
        "lc-dark-theme"
        // Alerts are forced into dark mode to maintain consistency of the colors
      ),
      ref: l,
      role: "status",
      children: /* @__PURE__ */ t(
        "div",
        {
          "data-testid": "navigation-top-bar-alert",
          className: u(
            Qe[It],
            Qe[`${It}--${a}`],
            {
              [Qe[`${It}--open`]]: m
            },
            e
          ),
          children: N
        }
      )
    }
  ) }) });
};
W_.Alert = ii;
W_.Title = ni;
function or(e, a, r, _) {
  return e === 1 ? a : r;
}
const Wa = {
  "expiration-counter": "lc-ExpirationCounter-module__expiration-counter___ro9nL",
  "expiration-counter__button": "lc-ExpirationCounter-module__expiration-counter__button___Xv5Nx",
  "expiration-counter__button__number": "lc-ExpirationCounter-module__expiration-counter__button__number___9hZV4",
  "expiration-counter__button__label": "lc-ExpirationCounter-module__expiration-counter__button__label___nJAOv"
}, Ka = "expiration-counter", $s = (i) => {
  var c = i, {
    id: e,
    daysLeft: a,
    url: r,
    onClick: _,
    className: o
  } = c, n = F(c, [
    "id",
    "daysLeft",
    "url",
    "onClick",
    "className"
  ]);
  return /* @__PURE__ */ t("li", { className: u(Wa[Ka], o), children: /* @__PURE__ */ f(
    "a",
    E(k({
      tabIndex: 0,
      href: r,
      onClick: (d) => _(d, e),
      className: Wa[`${Ka}__button`]
    }, n), {
      children: [
        /* @__PURE__ */ t("span", { className: Wa[`${Ka}__button__number`], children: a }),
        /* @__PURE__ */ t("span", { className: Wa[`${Ka}__button__label`], children: or(a, "day", "days") })
      ]
    })
  ) }, e);
}, ci = {
  "mobile-navigation": "lc-MobileNavigation-module__mobile-navigation___a--p5"
}, li = "mobile-navigation", Ns = (_) => {
  var o = _, {
    children: e,
    className: a
  } = o, r = F(o, [
    "children",
    "className"
  ]);
  return /* @__PURE__ */ t("nav", E(k({ className: u(ci[li], a) }, r), { children: e }));
}, si = "lc-Input-module__input___505b7", Je = {
  input: si,
  "input--focused": "lc-Input-module__input--focused___rmg2U",
  "input--disabled": "lc-Input-module__input--disabled___QA4ie",
  "input--crop": "lc-Input-module__input--crop___63BIX",
  "input--read-only": "lc-Input-module__input--read-only___h3wBP",
  "input--error": "lc-Input-module__input--error___d2Aqj",
  "input--xsmall": "lc-Input-module__input--xsmall___6hLud",
  "input--compact": "lc-Input-module__input--compact___9Sw7d",
  "input--medium": "lc-Input-module__input--medium___gb5Z2",
  "input--large": "lc-Input-module__input--large___hfmAH",
  "input__icon--disabled": "lc-Input-module__input__icon--disabled___uTYsP",
  "input__icon--left": "lc-Input-module__input__icon--left___IBzj8",
  "input__icon--right": "lc-Input-module__input__icon--right___lw1xQ",
  "input__visibility-button": "lc-Input-module__input__visibility-button___lmD5H"
}, et = "input", h_ = (e, a) => g.cloneElement(e.source, {
  "data-testid": `input-icon-${e.place}`,
  className: u(
    Je[`${et}__icon`],
    Je[`${et}__icon--${e.place}`],
    {
      [Je[`${et}__icon--disabled`]]: a
    }
  )
}), di = g.forwardRef(
  (d, c) => {
    var l = d, {
      inputSize: e = "medium",
      error: a = !1,
      disabled: r,
      icon: _ = null,
      className: o,
      cropOnBlur: n = !0
    } = l, i = F(l, [
      "inputSize",
      "error",
      "disabled",
      "icon",
      "className",
      "cropOnBlur"
    ]);
    const s = g.useRef(null);
    g.useImperativeHandle(c, () => s.current, []);
    const [m, p] = g.useState(!1), [v, h] = g.useState(!1), { type: b, onFocus: y, onBlur: C } = i, N = u(
      o,
      Je[et],
      Je[`${et}--${e}`],
      {
        [Je[`${et}--disabled`]]: r,
        [Je[`${et}--focused`]]: m,
        [Je[`${et}--error`]]: a,
        [Je[`${et}--crop`]]: n,
        [Je[`${et}--read-only`]]: i.readOnly
      }
    ), B = r ? "var(--content-disabled)" : "var(--content-default)", $ = v ? ho : fo, x = _ && _.place === "left", w = _ && b !== "password" && _.place === "right";
    return /* @__PURE__ */ f(
      A,
      {
        as: "div",
        className: N,
        "aria-disabled": r,
        "tab-index": "0",
        onClick: () => {
          var I;
          (I = s.current) == null || I.focus();
        },
        children: [
          x && h_(_, r),
          /* @__PURE__ */ t(
            "input",
            E(k({}, i), {
              ref: s,
              onFocus: (I) => {
                p(!0), y == null || y(I);
              },
              onBlur: (I) => {
                p(!1), C == null || C(I);
              },
              disabled: r,
              type: b && !v ? b : "text"
            })
          ),
          w && h_(_, r),
          b === "password" && /* @__PURE__ */ t(
            j,
            {
              disabled: r,
              kind: "text",
              size: "compact",
              icon: /* @__PURE__ */ t(P, { customColor: B, source: $ }),
              onClick: () => h((I) => !I),
              className: Je[`${et}__visibility-button`]
            }
          )
        ]
      }
    );
  }
), ui = 2, K_ = 200, Y_ = 400;
[
  ...[...Array(100)].map((e, a) => ({
    key: `option${a + 8}`,
    name: `Option #${a + 8}`,
    disabled: a % 4 === 0
  }))
];
const Qt = "select-all", mi = (e, a) => {
  const r = [];
  return e.forEach((_, o) => {
    a(_) && r.push(o);
  }), r;
}, Gr = (e) => e.filter(
  ({ key: a, disabled: r, groupHeader: _ }) => !(a === Qt || r || _)
), f_ = ({ key: e }) => e, pi = (e, a) => e.includes(a) ? e.filter((r) => r !== a) : [...e, a], gi = {
  "field-description": "lc-FieldDescription-module__field-description___x5rXY"
}, hi = "field-description", ur = (_) => {
  var o = _, { children: e, className: a = "" } = o, r = F(o, ["children", "className"]);
  const n = u(gi[hi], a);
  return /* @__PURE__ */ t(A, E(k({ as: "span", size: "sm" }, r), { className: n, children: e }));
}, fi = "lc-Checkbox-module__checkbox___D0D4S", bi = "lc-Checkbox-module__checkbox__label___I472A", vi = "lc-Checkbox-module__checkbox__text___Ex7K1", ki = "lc-Checkbox-module__checkbox__input___3krUF", yi = "lc-Checkbox-module__checkbox__checkmark___eZIG1", wi = "lc-Checkbox-module__checkbox__square___yjtrH", Ci = "lc-Checkbox-module__checkbox__helper___hwxAV", Ft = {
  checkbox: fi,
  checkbox__label: bi,
  checkbox__text: vi,
  checkbox__input: ki,
  checkbox__checkmark: yi,
  "checkbox--selected": "lc-Checkbox-module__checkbox--selected___pU3Xh",
  checkbox__square: wi,
  "checkbox--disabled": "lc-Checkbox-module__checkbox--disabled___kRNDo",
  checkbox__helper: Ci
}, Rt = "checkbox", $i = g.forwardRef(
  (c, i) => {
    var d = c, { checked: e, disabled: a, children: r, description: _, className: o } = d, n = F(d, ["checked", "disabled", "children", "description", "className"]);
    return /* @__PURE__ */ f(
      "div",
      {
        className: u(Ft[Rt], o, {
          [Ft[`${Rt}--selected`]]: e,
          [Ft[`${Rt}--disabled`]]: a
        }),
        children: [
          /* @__PURE__ */ f("label", { className: Ft[`${Rt}__label`], children: [
            /* @__PURE__ */ t(
              "input",
              E(k({}, n), {
                ref: i,
                checked: e,
                disabled: a,
                className: Ft[`${Rt}__input`],
                type: "checkbox"
              })
            ),
            r && /* @__PURE__ */ t(A, { as: "div", size: "md", className: Ft[`${Rt}__text`], children: r })
          ] }),
          _ && /* @__PURE__ */ t(ur, { className: Ft[`${Rt}__helper`], children: _ })
        ]
      }
    );
  }
), ye = {
  "item-wrapper": "lc-PickerListItem-module__item-wrapper___xIByl",
  "item-wrapper__first": "lc-PickerListItem-module__item-wrapper__first___qcOML",
  "item-wrapper__last": "lc-PickerListItem-module__item-wrapper__last___Ac2Y-",
  "picker-list__item": "lc-PickerListItem-module__picker-list__item___Pvh-4",
  "picker-list__item--select-all": "lc-PickerListItem-module__picker-list__item--select-all___P0GzV",
  "picker-list__item__header": "lc-PickerListItem-module__picker-list__item__header___Besp-",
  "picker-list__item__custom": "lc-PickerListItem-module__picker-list__item__custom___UbY70",
  "picker-list__item__checkbox": "lc-PickerListItem-module__picker-list__item__checkbox___d5uLj",
  "picker-list__item__avatar": "lc-PickerListItem-module__picker-list__item__avatar___9AS0i",
  "picker-list__item__icon": "lc-PickerListItem-module__picker-list__item__icon___x6wiv",
  "picker-list__item__label-container": "lc-PickerListItem-module__picker-list__item__label-container___emTD1",
  "picker-list__item__label": "lc-PickerListItem-module__picker-list__item__label___kAkZc",
  "picker-list__item__main-label": "lc-PickerListItem-module__picker-list__item__main-label___8CJdc",
  "picker-list__item__secondary-label": "lc-PickerListItem-module__picker-list__item__secondary-label___i-DOd"
}, Ke = "picker-list__item", Ni = ({
  index: e,
  isActive: a,
  isSelected: r,
  listElementsRef: _,
  onSelect: o,
  getItemProps: n,
  item: i,
  numberOfItems: c
}) => {
  const d = (s) => {
    var m;
    return (m = s == null ? void 0 : s.customElement) != null && m.listItemBody ? /* @__PURE__ */ t("div", { className: ye[`${Ke}__custom`], children: s.customElement.listItemBody }) : /* @__PURE__ */ f(ne, { children: [
      s.showCheckbox && /* @__PURE__ */ t(
        $i,
        {
          className: ye[`${Ke}__checkbox`],
          checked: r
        }
      ),
      s.icon && /* @__PURE__ */ t(
        P,
        {
          className: ye[`${Ke}__icon`],
          kind: "link",
          source: s.icon
        }
      ),
      s.avatarSrc && /* @__PURE__ */ t(
        "img",
        {
          className: u(ye[`${Ke}__avatar`]),
          src: s.avatarSrc,
          alt: s.name
        }
      ),
      /* @__PURE__ */ f("div", { className: ye[`${Ke}__label-container`], children: [
        /* @__PURE__ */ t(
          A,
          {
            as: "span",
            className: u([ye[`${Ke}__label`]], {
              [ye[`${Ke}__main-label`]]: s.secondaryText
            }),
            "aria-disabled": s.disabled,
            children: s.name
          }
        ),
        s.secondaryText && /* @__PURE__ */ t("span", { className: ye[`${Ke}__secondary-label`], children: s.secondaryText })
      ] })
    ] });
  };
  if (i.groupHeader)
    return /* @__PURE__ */ t(
      "div",
      E(k({
        id: `item-${e}`,
        role: "group",
        className: ye[`${Ke}__header`]
      }, n()), {
        children: /* @__PURE__ */ t(he, { size: "2xs", uppercase: !0, bold: !0, as: "div", children: i.name })
      }),
      i.key
    );
  const l = (s) => {
    !i.disabled && o(s);
  };
  return /* @__PURE__ */ t(
    "div",
    E(k({
      id: i.key,
      tabIndex: a ? 0 : -1,
      ref: (s) => {
        s && (_.current[e] = s);
      },
      role: "option",
      "aria-setsize": c,
      "aria-posinset": e + 1
    }, n({
      onClick: () => l(i.key)
    })), {
      className: u(ye["item-wrapper"], {
        [ye["item-wrapper__first"]]: e === 0 && !i.groupHeader,
        [ye["item-wrapper__last"]]: e === c - 1 && !i.groupHeader
      }),
      children: /* @__PURE__ */ f(
        "div",
        {
          "aria-selected": r,
          "aria-disabled": i.disabled,
          "aria-current": a && !i.disabled,
          className: u(ye[Ke], {
            [ye[`${Ke}--select-all`]]: i.key === Qt
          }),
          children: [
            d(i),
            r && !i.showCheckbox && /* @__PURE__ */ t(
              P,
              {
                kind: "link",
                source: xa,
                customColor: "var(--content-basic-info)"
              }
            )
          ]
        }
      )
    }),
    i.key
  );
}, Si = "lc-PickerList-module__listbox___GgFk0", la = {
  listbox: Si,
  "no-results": "lc-PickerList-module__no-results___JSeou",
  "listbox-wrapper": "lc-PickerList-module__listbox-wrapper___1mIgW",
  "no-results-text": "lc-PickerList-module__no-results-text___r-f51"
}, X_ = ({
  context: e,
  setFloating: a,
  floatingStyles: r,
  maxHeight: _,
  options: o,
  activeIndex: n,
  selectedKeys: i,
  listElementsRef: c,
  isPositioned: d,
  searchDisabled: l,
  onItemRemove: s,
  setPointer: m,
  onSelect: p,
  getFloatingProps: v,
  getItemProps: h,
  emptyStateText: b = "No results found",
  hideWhenEmpty: y = !1,
  pickerType: C = "single",
  listClassName: N,
  virtuosoProps: B
}) => {
  const [$, x] = g.useState(0), w = Hr(null), S = o.length, I = g.useCallback(
    (T) => {
      T !== $ && (T < _ ? x(T + (S - 1) * ui) : x(_));
    },
    [S]
  );
  if (at(() => {
    var T;
    l && d && n !== null && ((T = w.current) == null || T.focus());
  }, [l, d, n]), at(() => {
    c.current = new Array(o.length);
  }, [o.length]), o.length === 0)
    return y ? null : /* @__PURE__ */ t(Fr, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ t(
      "div",
      {
        className: u(la.listbox, la["no-results"]),
        ref: a,
        tabIndex: -1,
        style: r,
        children: /* @__PURE__ */ t("div", { className: la["no-results-text"], children: b })
      }
    ) });
  const R = (T) => i.includes(T) || T === Qt && i.length === Gr(o).length, G = () => {
    C === "multi" && s(i[i.length - 1]);
  };
  return /* @__PURE__ */ t(Fr, { context: e, modal: !1, initialFocus: -1, children: /* @__PURE__ */ t(
    "div",
    {
      "data-testid": "picker-list",
      ref: a,
      tabIndex: -1,
      className: u(la.listbox, N),
      style: E(k({}, r), {
        maxHeight: _
      }),
      children: /* @__PURE__ */ t(
        "div",
        E(k({
          ref: w,
          tabIndex: 0,
          "aria-multiselectable": C === "multi",
          className: la["listbox-wrapper"]
        }, v({
          onKeyDown(T) {
            m(!1), T.key === "Enter" && n !== null && p(o[n].key), (T.key === "Backspace" || T.key === "Delete") && G(), T.key === " " && T.preventDefault();
          },
          onKeyUp(T) {
            T.key === " " && n !== null && p(o[n].key);
          },
          onPointerMove() {
            m(!0);
          }
        })), {
          children: /* @__PURE__ */ t(
            jo,
            E(k({
              totalListHeightChanged: I,
              style: { height: `${$}px`, maxHeight: _ },
              totalCount: o.length,
              data: o,
              increaseViewportBy: 200
            }, B), {
              itemContent: (T, D) => /* @__PURE__ */ t(
                Ni,
                {
                  index: T,
                  getItemProps: h,
                  listElementsRef: c,
                  isActive: n === T,
                  isSelected: R(D.key),
                  onSelect: p,
                  item: D,
                  numberOfItems: S
                }
              )
            })
          )
        })
      )
    }
  ) });
}, we = {
  "picker-trigger": "lc-PickerTrigger-module__picker-trigger___nSDgb",
  "picker-trigger--multi-select": "lc-PickerTrigger-module__picker-trigger--multi-select___XCt1K",
  "picker-trigger--multi-select--with-items": "lc-PickerTrigger-module__picker-trigger--multi-select--with-items___0VU14",
  "picker-trigger__content": "lc-PickerTrigger-module__picker-trigger__content___tAfyM",
  "picker-trigger__content--compact": "lc-PickerTrigger-module__picker-trigger__content--compact___iudK8",
  "picker-trigger__content--medium": "lc-PickerTrigger-module__picker-trigger__content--medium___1TZtT",
  "picker-trigger__content--large": "lc-PickerTrigger-module__picker-trigger__content--large___VUVXl",
  "picker-trigger__content--with-items": "lc-PickerTrigger-module__picker-trigger__content--with-items___6R0wr",
  "picker-trigger__controls": "lc-PickerTrigger-module__picker-trigger__controls___W7nRe",
  "picker-trigger__controls--compact": "lc-PickerTrigger-module__picker-trigger__controls--compact___y9w3B",
  "picker-trigger__controls--medium": "lc-PickerTrigger-module__picker-trigger__controls--medium___FYWxm",
  "picker-trigger__controls--large": "lc-PickerTrigger-module__picker-trigger__controls--large___jHbAJ",
  "picker-trigger__clear-icon": "lc-PickerTrigger-module__picker-trigger__clear-icon___Jgz6U",
  "picker-trigger__chevron-icon": "lc-PickerTrigger-module__picker-trigger__chevron-icon___Itnmh",
  "picker-trigger--disabled": "lc-PickerTrigger-module__picker-trigger--disabled___PKfb-",
  "picker-trigger--focused": "lc-PickerTrigger-module__picker-trigger--focused___xbQpR",
  "picker-trigger--error": "lc-PickerTrigger-module__picker-trigger--error___As8hf"
}, be = "picker-trigger", xi = ({
  setReference: e,
  getReferenceProps: a,
  testId: r,
  size: _ = "medium",
  isMultiSelect: o,
  isItemSelected: n,
  hideClearButton: i,
  isDisabled: c,
  isRequired: d,
  isOpen: l,
  isError: s,
  onClear: m,
  children: p,
  setTriggerFocus: v
}) => {
  const h = u(
    we[be],
    we[`${be}--${_}`],
    o && we[`${be}--multi-select`],
    o && n && we[`${be}--multi-select--with-items`],
    c && we[`${be}--disabled`],
    l && we[`${be}--focused`],
    s && we[`${be}--error`]
  ), b = !i && n && !c && !d, y = (C) => {
    C.stopPropagation(), m();
  };
  return g.useEffect(() => {
    l || v(!1);
  }, [l]), /* @__PURE__ */ f(
    "button",
    E(k({
      tabIndex: c ? -1 : 0,
      "aria-disabled": c,
      disabled: c,
      className: h,
      "data-testid": r,
      ref: e,
      type: "button"
    }, a()), {
      onFocus: () => v(!0),
      onBlur: () => v(!1),
      children: [
        /* @__PURE__ */ t(
          A,
          {
            as: "div",
            className: u(
              we[`${be}__content`],
              we[`${be}__content--${_}`],
              o && n && we[`${be}__content--with-items`]
            ),
            children: p
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            className: u(
              we[`${be}__controls`],
              we[`${be}__controls--${_}`]
            ),
            children: [
              b && /* @__PURE__ */ t(
                "div",
                {
                  "data-testid": `${be}__clear-icon`,
                  className: we[`${be}__clear-icon`],
                  onClick: y,
                  children: /* @__PURE__ */ t(P, { kind: "primary", size: "small", source: Ue })
                }
              ),
              /* @__PURE__ */ t(
                P,
                {
                  className: we[`${be}__chevron-icon`],
                  source: l ? cr : Ht,
                  size: "medium",
                  disabled: c
                }
              )
            ]
          }
        )
      ]
    })
  );
}, Bi = "lc-Tag-module__tag___0Cfjz", Ei = "lc-Tag-module__tag__remove___dYHt9", Ii = "lc-Tag-module__tag__node___3hHHq", Ti = "lc-Tag-module__tag__content___w-HK1", Be = {
  tag: Bi,
  "tag__content-wrapper": "lc-Tag-module__tag__content-wrapper___QrjSg",
  "tag--success": "lc-Tag-module__tag--success___Jr03z",
  tag__remove: Ei,
  "tag--error": "lc-Tag-module__tag--error___zAr59",
  "tag--warning": "lc-Tag-module__tag--warning___6FwV2",
  "tag--info": "lc-Tag-module__tag--info___Zk-om",
  "tag--purple": "lc-Tag-module__tag--purple___8cY3y",
  "tag--black": "lc-Tag-module__tag--black___hGskP",
  "tag--outline": "lc-Tag-module__tag--outline___d-iCv",
  "tag--gray": "lc-Tag-module__tag--gray___EKXt6",
  "tag--gradient01": "lc-Tag-module__tag--gradient01___MStHW",
  "tag--gradient02": "lc-Tag-module__tag--gradient02___9tDwp",
  "tag--gradient03": "lc-Tag-module__tag--gradient03___-Sy8M",
  "tag--gradient04": "lc-Tag-module__tag--gradient04___WA5o6",
  "tag--gradient05": "lc-Tag-module__tag--gradient05___RUXqI",
  "tag--gradient06": "lc-Tag-module__tag--gradient06___FucnK",
  "tag--gradient07": "lc-Tag-module__tag--gradient07___d4-hS",
  "tag--gradient08": "lc-Tag-module__tag--gradient08___cSb8n",
  "tag--gradient09": "lc-Tag-module__tag--gradient09___rqbii",
  "tag--gradient10": "lc-Tag-module__tag--gradient10___5GHLp",
  "tag--gradient11": "lc-Tag-module__tag--gradient11___c6LfC",
  "tag--medium": "lc-Tag-module__tag--medium___lxV77",
  "tag--small": "lc-Tag-module__tag--small___plGiu",
  "tag--icon-only": "lc-Tag-module__tag--icon-only___WYMzu",
  "tag--large": "lc-Tag-module__tag--large___IUzeG",
  "tag--xlarge": "lc-Tag-module__tag--xlarge___2i2T7",
  "tag--text-white": "lc-Tag-module__tag--text-white___Gc3-T",
  "tag--text-black": "lc-Tag-module__tag--text-black___0UD4h",
  "tag--dismissible-on-hover": "lc-Tag-module__tag--dismissible-on-hover___Id-yT",
  "tag__remove--hover": "lc-Tag-module__tag__remove--hover___tILiT",
  tag__node: Ii,
  tag__content: Ti
}, Ee = "tag", Ai = (e) => e ? Kr(e, "#FFFFFF") > 4.5 ? "text-white" : "text-black" : "", Z_ = (h) => {
  var b = h, {
    className: e = "",
    children: a,
    dismissibleOnHover: r = !1,
    disabled: _ = !1,
    size: o = "medium",
    kind: n = "default",
    onRemove: i,
    outline: c = !1,
    leftNode: d,
    rightNode: l,
    customColor: s,
    iconOnly: m = !1,
    value: p
  } = b, v = F(b, [
    "className",
    "children",
    "dismissibleOnHover",
    "disabled",
    "size",
    "kind",
    "onRemove",
    "outline",
    "leftNode",
    "rightNode",
    "customColor",
    "iconOnly",
    "value"
  ]);
  const y = r || i && m, C = u(
    Be[Ee],
    e,
    Be[`${Ee}--${o}`],
    Be[`${Ee}--${n}`],
    {
      [Be[`${Ee}--outline`]]: c,
      [Be[`${Ee}--${Ai(s)}`]]: !!s,
      [Be[`${Ee}--icon-only`]]: m,
      [Be[`${Ee}--dismissible-on-hover`]]: y
    }
  ), N = o === "small" ? "small" : "medium", B = o === "small" ? "sm" : "md", $ = () => s ? c ? {
    style: {
      backgroundColor: "transparent",
      color: s,
      borderColor: s
    }
  } : { style: { backgroundColor: s } } : {}, x = () => {
    if (s)
      return c ? s : Kr(s, "#FFFFFF") > 4.5 ? "#FFFFFF" : "#000000";
  };
  return /* @__PURE__ */ f(
    A,
    E(k(k({
      className: C
    }, v), $()), {
      as: "div",
      size: B,
      children: [
        /* @__PURE__ */ f("div", { className: Be[`${Ee}__content-wrapper`], children: [
          d && !m && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": "lc-tag-left-node",
              className: Be[`${Ee}__node`],
              style: { color: x() },
              children: d
            }
          ),
          /* @__PURE__ */ t("div", { className: Be[`${Ee}__content`], children: p || a }),
          l && !m && /* @__PURE__ */ t(
            "div",
            {
              "data-testid": "lc-tag-right-node",
              className: Be[`${Ee}__node`],
              style: { color: x() },
              children: l
            }
          )
        ] }),
        i && !_ && /* @__PURE__ */ t(
          "span",
          {
            tabIndex: -1,
            title: "Remove",
            onClick: i,
            role: "button",
            "aria-label": "Remove tag",
            className: u(Be[`${Ee}__remove`], {
              [Be[`${Ee}__remove--hover`]]: y
            }),
            children: /* @__PURE__ */ t(
              P,
              {
                "data-dismiss-icon": !0,
                source: Ue,
                size: N,
                customColor: x()
              }
            )
          }
        )
      ]
    })
  );
}, Ce = {
  "picker-trigger-body": "lc-PickerTriggerBody-module__picker-trigger-body___598fZ",
  "picker-trigger-body--single": "lc-PickerTriggerBody-module__picker-trigger-body--single___irxmq",
  "picker-trigger-body__item-container": "lc-PickerTriggerBody-module__picker-trigger-body__item-container___AnGk3",
  "picker-trigger-body__item": "lc-PickerTriggerBody-module__picker-trigger-body__item___k1S-g",
  "picker-trigger-body__item__content": "lc-PickerTriggerBody-module__picker-trigger-body__item__content___SKkl7",
  "picker-trigger-body__item__avatar": "lc-PickerTriggerBody-module__picker-trigger-body__item__avatar___gW6Qa",
  "picker-trigger-body__item__icon": "lc-PickerTriggerBody-module__picker-trigger-body__item__icon___TQrP2",
  "picker-trigger-body__placeholder": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder___IdI0e",
  "picker-trigger-body__placeholder--disabled": "lc-PickerTriggerBody-module__picker-trigger-body__placeholder--disabled___24BT1",
  "picker-trigger-body__input": "lc-PickerTriggerBody-module__picker-trigger-body__input___O7ypn",
  "picker-trigger-body__input--compact": "lc-PickerTriggerBody-module__picker-trigger-body__input--compact___0ml2Q",
  "picker-trigger-body__input--medium": "lc-PickerTriggerBody-module__picker-trigger-body__input--medium___Hstke",
  "picker-trigger-body__input--large": "lc-PickerTriggerBody-module__picker-trigger-body__input--large___jQE7Q",
  "picker-trigger-body__tag": "lc-PickerTriggerBody-module__picker-trigger-body__tag___usvP3",
  "picker-trigger-body__tag--compact": "lc-PickerTriggerBody-module__picker-trigger-body__tag--compact___o4dKd",
  "picker-trigger-body__tag--medium": "lc-PickerTriggerBody-module__picker-trigger-body__tag--medium___uU1CL",
  "picker-trigger-body__tag--large": "lc-PickerTriggerBody-module__picker-trigger-body__tag--large___IBtox"
}, $e = "picker-trigger-body", Di = ({
  isOpen: e,
  isSearchDisabled: a,
  isDisabled: r,
  placeholder: _,
  selectedItems: o,
  type: n,
  clearSearchAfterSelection: i,
  size: c = "medium",
  onItemRemove: d,
  onSelect: l,
  onFilter: s,
  onClear: m,
  searchPhrase: p,
  virtualItemRef: v,
  isTriggerFocused: h,
  inputRef: b,
  inputProps: y
}) => {
  const C = e && !a;
  g.useEffect(() => {
    i && b != null && b.current && b.current.focus();
  }, [o, i]);
  const N = (S) => {
    S.key === "Backspace" && o && o.length > 0 && (S.preventDefault(), n === "multi" ? d(o[o.length - 1].key) : m()), S.key === "Delete" && (S.preventDefault(), m());
  };
  g.useEffect(() => (!e && h ? document.addEventListener("keydown", N) : document.removeEventListener("keydown", N), () => document.removeEventListener("keydown", N)), [e, o, h]);
  const B = (S) => {
    var I;
    return n === "single" && e && !a ? null : (I = S == null ? void 0 : S.customElement) != null && I.selectedItemBody ? /* @__PURE__ */ t("div", { className: Ce[`${$e}__item`], children: S.customElement.selectedItemBody }) : /* @__PURE__ */ f("div", { className: Ce[`${$e}__item`], children: [
      S.icon && /* @__PURE__ */ t(
        P,
        {
          source: S.icon,
          className: Ce[`${$e}__item__icon`]
        }
      ),
      S.avatarSrc && /* @__PURE__ */ t(
        "img",
        {
          src: S.avatarSrc,
          alt: "",
          className: Ce[`${$e}__item__avatar`]
        }
      ),
      /* @__PURE__ */ t("div", { className: Ce[`${$e}__item__content`], children: S.name })
    ] });
  }, $ = (S) => s(S.target.value), x = (S) => {
    var I, R;
    (I = v.current) != null && I.id && S.key === "Enter" && l((R = v.current) == null ? void 0 : R.id), n === "multi" && (S.key === "Backspace" || S.key === "Delete") && !p && o && (o == null ? void 0 : o.length) > 0 && d(o[o.length - 1].key);
  }, w = () => /* @__PURE__ */ t(
    "input",
    E(k({}, y), {
      ref: b,
      className: u(
        Ce[`${$e}__input`],
        Ce[`${$e}__input--${c}`]
      ),
      placeholder: _,
      onChange: $,
      onKeyDown: x,
      autoFocus: !0,
      value: p
    })
  );
  return !o || o.length === 0 ? C ? w() : /* @__PURE__ */ t(
    "div",
    {
      className: u({
        [Ce[`${$e}__placeholder`]]: !0,
        [Ce[`${$e}__placeholder--disabled`]]: r
      }),
      children: _
    }
  ) : /* @__PURE__ */ f(
    "div",
    {
      className: u(Ce[$e], {
        [Ce[`${$e}--single`]]: n === "single"
      }),
      children: [
        /* @__PURE__ */ t("div", { className: Ce[`${$e}__item-container`], children: n === "single" ? B(o[0]) : o.map((S) => /* @__PURE__ */ t(
          Z_,
          E(k({
            className: u(
              Ce[`${$e}__tag`],
              Ce[`${$e}__tag--${c}`]
            ),
            disabled: r,
            onRemove: (I) => {
              I.stopPropagation(), d(S.key);
            }
          }, S.selectedTagOptions), {
            children: B(S)
          }),
          S.key
        )) }),
        C && w()
      ]
    }
  );
}, Pi = 10, q_ = ({
  disabled: e,
  items: a,
  placement: r,
  minListHeight: _,
  maxListHeight: o,
  floatingStrategy: n,
  useDismissHookProps: i,
  useClickHookProps: c,
  isOpen: d,
  onVisibilityChange: l,
  searchPhrase: s
}) => {
  const m = Ba(), [p, v] = g.useState(!1), [h, b] = g.useState(null), [y, C] = g.useState(o), N = g.useRef([]), B = g.useRef(null);
  g.useEffect(() => {
    B.current = null, b(null);
  }, [s]);
  const { refs: $, floatingStyles: x, context: w, isPositioned: S } = Ea({
    nodeId: m,
    open: d,
    strategy: n,
    onOpenChange: l,
    whileElementsMounted: Ta,
    placement: r,
    middleware: [
      Ia(4),
      sr({ padding: 10 }),
      Wr(),
      D_({
        apply({ availableHeight: V, rects: H, elements: K }) {
          Xo.flushSync(() => {
            C(
              Math.max(
                Math.min(o, Number(V)),
                _
              )
            );
          }), Object.assign(K.floating.style, {
            width: `${H.reference.width}px`
          });
        },
        padding: Pi
      })
    ]
  }), I = Aa(w, k({
    enabled: !e,
    keyboardHandlers: !1,
    toggle: !1
  }, c)), R = Pa(w, { role: "listbox" }), G = Da(w, i), T = Ko(w, {
    enabled: a.length > 0 && !e,
    listRef: N,
    activeIndex: h,
    onNavigate: b,
    virtual: !0,
    virtualItemRef: B,
    disabledIndices: mi(
      a,
      (V) => !!V.disabled || !!V.groupHeader
    )
  }), { getReferenceProps: D, getFloatingProps: z, getItemProps: ie } = Fa(
    [I, G, R, T]
  );
  return !d && p && v(!1), {
    getReferenceProps: D,
    getFloatingProps: z,
    getItemProps: ie,
    setReference: $.setReference,
    floatingStyles: x,
    isPositioned: S,
    context: w,
    nodeId: m,
    setFloating: $.setFloating,
    activeIndex: h,
    listElementsRef: N,
    virtualItemRef: B,
    maxHeight: y,
    pointer: p,
    setPointer: v
  };
}, j_ = ({
  selected: e,
  options: a,
  type: r,
  selectAllOptionText: _,
  onSelect: o,
  setOpen: n,
  clearSearchAfterSelection: i,
  inputRef: c
}) => {
  const [d, l] = g.useState(
    () => (e == null ? void 0 : e.map(f_)) || []
  ), s = e !== void 0, m = s ? (e == null ? void 0 : e.map(f_)) || [] : d, [p, v] = g.useState(""), h = ($) => v($), b = ($) => {
    r === "single" ? B($) : (l(m.filter((x) => x !== $)), o((e == null ? void 0 : e.filter(({ key: x }) => x !== $)) || null));
  }, y = () => {
    !s && l([]), o(null), v(""), n(!1);
  }, C = () => {
    h(""), c.current && (c.current.value = "");
  }, N = g.useMemo(() => {
    const $ = r === "multi" && _;
    let x = a;
    return p && (x = x.filter((w) => {
      var G;
      if (w.groupHeader)
        return !1;
      const S = p.toLowerCase(), I = w.name.toLowerCase(), R = (G = w.secondaryText) == null ? void 0 : G.toLowerCase();
      return I.includes(S) || (R == null ? void 0 : R.includes(S));
    })), $ && x.length > 1 && (x = [
      {
        key: Qt,
        name: _
      },
      ...x
    ]), x;
  }, [p, a, r, _]), B = ($) => {
    const x = a.find((w) => w.key === $);
    (!x || x.disabled) && $ !== Qt || (r === "single" ? (l(() => (x && o([x]), [$])), n(!1)) : $ === Qt ? m.length === Gr(a).length ? l(() => (o(null), [])) : l(() => {
      const w = Gr(a);
      return o(w), w.map(({ key: S }) => S);
    }) : (s ? m.includes($) ? (o(
      (e == null ? void 0 : e.filter(({ key: w }) => w !== $)) || null
    ), l((w) => w.filter((S) => S !== $))) : (o([...e || [], x]), l((w) => [...w, $])) : l((w) => {
      const S = pi(w, $);
      return o(a.filter(({ key: I }) => S.includes(I))), S;
    }), i && C()));
  };
  return {
    selectedKeys: m,
    items: N,
    searchPhrase: p,
    handleSelect: B,
    handleOnFilter: h,
    handleItemRemove: b,
    handleClear: y
  };
}, Fi = {
  "picker-wrapper": "lc-Picker-module__picker-wrapper___uaLHq"
}, Ss = (ie) => {
  var V = ie, {
    id: e,
    className: a,
    listClassName: r,
    minListHeight: _ = K_,
    maxListHeight: o = Y_,
    disabled: n,
    error: i,
    options: c,
    selected: d,
    size: l = "medium",
    placeholder: s = "Select option",
    isRequired: m,
    noSearchResultText: p = "No results found",
    selectAllOptionText: v,
    type: h = "single",
    searchDisabled: b = !1,
    hideClearButton: y,
    isVisible: C,
    onOpen: N,
    onClose: B,
    openedOnInit: $ = !1,
    clearSearchAfterSelection: x = !0,
    onSelect: w,
    placement: S,
    floatingStrategy: I,
    useDismissHookProps: R,
    useClickHookProps: G,
    virtuosoProps: T,
    inputProps: D
  } = V, z = F(V, [
    "id",
    "className",
    "listClassName",
    "minListHeight",
    "maxListHeight",
    "disabled",
    "error",
    "options",
    "selected",
    "size",
    "placeholder",
    "isRequired",
    "noSearchResultText",
    "selectAllOptionText",
    "type",
    "searchDisabled",
    "hideClearButton",
    "isVisible",
    "onOpen",
    "onClose",
    "openedOnInit",
    "clearSearchAfterSelection",
    "onSelect",
    "placement",
    "floatingStrategy",
    "useDismissHookProps",
    "useClickHookProps",
    "virtuosoProps",
    "inputProps"
  ]);
  const [H, K] = g.useState($), [He, rt] = g.useState(!1), Ct = C !== void 0, xe = Ct ? C : H, ct = g.useRef(null), _t = (Ra, Ma) => {
    Ra ? !xe && (N == null || N(Ma)) : xe && (B == null || B(Ma)), !Ct && K(Ra);
  }, {
    selectedKeys: lt,
    items: ze,
    searchPhrase: $t,
    handleSelect: Nt,
    handleOnFilter: st,
    handleItemRemove: M,
    handleClear: J
  } = j_({
    selected: d,
    options: c,
    type: h,
    selectAllOptionText: v,
    onSelect: w,
    setOpen: _t,
    clearSearchAfterSelection: x,
    inputRef: ct
  }), {
    context: se,
    nodeId: W,
    getReferenceProps: Y,
    setReference: dt,
    getFloatingProps: zt,
    getItemProps: St,
    setFloating: mr,
    floatingStyles: pr,
    listElementsRef: gr,
    virtualItemRef: hr,
    activeIndex: fr,
    maxHeight: br,
    setPointer: vr,
    isPositioned: kr
  } = q_({
    openedOnInit: $,
    disabled: n,
    items: ze,
    placement: S,
    minListHeight: _,
    maxListHeight: o,
    floatingStrategy: I,
    useClickHookProps: G,
    useDismissHookProps: R,
    isOpen: xe,
    onVisibilityChange: _t,
    searchPhrase: $t
  });
  return /* @__PURE__ */ f("div", { id: e, className: u(Fi["picker-wrapper"], a), children: [
    /* @__PURE__ */ t(
      xi,
      {
        getReferenceProps: Y,
        setReference: dt,
        testId: z["data-testid"],
        isItemSelected: lt.length > 0,
        isOpen: xe,
        onClear: J,
        hideClearButton: y,
        isDisabled: n,
        isError: i,
        isRequired: m,
        isMultiSelect: h === "multi",
        size: l,
        setTriggerFocus: rt,
        children: /* @__PURE__ */ t(
          Di,
          {
            isOpen: xe,
            isSearchDisabled: b,
            isDisabled: n,
            placeholder: s,
            selectedItems: d,
            type: h,
            size: l,
            clearSearchAfterSelection: x,
            inputRef: ct,
            onItemRemove: M,
            onSelect: Nt,
            onFilter: st,
            onClear: J,
            searchPhrase: $t,
            virtualItemRef: hr,
            isTriggerFocused: He,
            inputProps: D
          }
        )
      }
    ),
    /* @__PURE__ */ t(ta, { id: W, children: xe && /* @__PURE__ */ t(ea, { children: /* @__PURE__ */ t(
      X_,
      {
        pickerType: h,
        options: ze,
        listClassName: r,
        context: se,
        setFloating: mr,
        floatingStyles: pr,
        maxHeight: br,
        activeIndex: fr,
        selectedKeys: lt,
        listElementsRef: gr,
        searchDisabled: b,
        isPositioned: kr,
        onItemRemove: M,
        setPointer: vr,
        onSelect: Nt,
        getFloatingProps: zt,
        getItemProps: St,
        emptyStateText: p,
        virtuosoProps: T
      }
    ) }) })
  ] });
}, Ri = (e) => e !== void 0 && typeof e[0] == "string", Mi = (e) => e.map((a) => ({ name: a, key: a })), Oi = (e) => e.map((o) => {
  var n = o, { customElement: a, name: r } = n, _ = F(n, ["customElement", "name"]);
  return k(k({
    name: r,
    key: r
  }, a && {
    customElement: {
      listItemBody: a,
      selectedItemBody: /* @__PURE__ */ t(ne, {})
    }
  }), _);
}), Li = (e, a, r, _) => {
  const o = e.length === 1 && e[0].name === _, n = a ? e.slice(0, 1) : e;
  return r && o ? [] : n;
}, xs = g.forwardRef(
  (v, p) => {
    var h = v, {
      disabled: e,
      minListHeight: a = K_,
      maxListHeight: r = Y_,
      autocompleteOpenOnInit: _ = !1,
      placement: o,
      options: n,
      readOnly: i,
      floatingStrategy: c,
      single: d,
      alwaysShowAllOptions: l,
      hideIfExactMatch: s = !0
    } = h, m = F(h, [
      "disabled",
      "minListHeight",
      "maxListHeight",
      "autocompleteOpenOnInit",
      "placement",
      "options",
      "readOnly",
      "floatingStrategy",
      "single",
      "alwaysShowAllOptions",
      "hideIfExactMatch"
    ]);
    const b = g.useRef(null);
    g.useImperativeHandle(p, () => b.current, []);
    const [y, C] = g.useState(""), B = m.value !== void 0 ? m.value : y, [$, x] = g.useState(
      _
    ), w = (W) => {
      x(W);
    }, S = (W) => {
      ie(W);
    }, I = (W) => {
      var Y, dt;
      (Y = m.onChange) == null || Y.call(m, W), C(W.target.value), l || S(W.target.value), (dt = b.current) == null || dt.focus();
    }, R = (W) => {
      var dt, zt, St;
      const Y = W.key === "Enter";
      (dt = st.current) != null && dt.id && Y && (G([{ key: (zt = st.current) == null ? void 0 : zt.id }]), W.preventDefault()), Y || w(!0), (St = m.onKeyDown) == null || St.call(m, W);
    }, G = (W) => {
      if (W) {
        const Y = W[0].key;
        I({
          target: { value: Y }
        }), setTimeout(() => {
          w(!1);
        }, 0);
      }
    }, T = g.useMemo(() => n ? Ri(n) ? Mi(n) : Oi(n) : [], [n]), { items: D, searchPhrase: z, handleOnFilter: ie, handleSelect: V, selectedKeys: H } = j_({
      selected: [],
      options: T,
      type: "single",
      onSelect: G,
      setOpen: x,
      clearSearchAfterSelection: !0,
      inputRef: b
    }), K = Li(
      D,
      d || !1,
      s || !1,
      (B == null ? void 0 : B.toString()) || ""
    ), {
      nodeId: He,
      context: rt,
      setFloating: Ct,
      getReferenceProps: xe,
      getItemProps: ct,
      getFloatingProps: _t,
      floatingStyles: lt,
      maxHeight: ze,
      setPointer: $t,
      setReference: Nt,
      virtualItemRef: st,
      listElementsRef: M,
      activeIndex: J,
      isPositioned: se
    } = q_({
      openedOnInit: _,
      disabled: e || i,
      items: D,
      searchPhrase: l ? "" : z,
      isOpen: $,
      onVisibilityChange: w,
      minListHeight: a,
      maxListHeight: r,
      placement: o,
      floatingStrategy: c
    });
    return /* @__PURE__ */ f("div", E(k({ ref: Nt }, xe()), { children: [
      /* @__PURE__ */ t(
        di,
        E(k({}, m), {
          ref: b,
          onChange: I,
          onKeyDown: R,
          value: B,
          disabled: e,
          readOnly: i,
          type: "text"
        })
      ),
      /* @__PURE__ */ t(ta, { id: He, children: $ && /* @__PURE__ */ t(ea, { children: /* @__PURE__ */ t(
        X_,
        {
          context: rt,
          options: K,
          setFloating: Ct,
          getFloatingProps: _t,
          floatingStyles: lt,
          maxHeight: ze,
          listElementsRef: M,
          activeIndex: J,
          selectedKeys: H,
          setPointer: $t,
          hideWhenEmpty: !0,
          getItemProps: ct,
          onSelect: V,
          isPositioned: se,
          searchDisabled: !1,
          onItemRemove: Sa
        }
      ) }) })
    ] }));
  }
), b_ = Array.from(
  { length: 10 },
  (e, a) => `--surface-avatar-${a + 1}`
);
function Gi(e) {
  if (!e)
    return;
  const a = e.split("").reduce((r, _) => r + _.charCodeAt(0), 0);
  return `var(${b_[a % b_.length]})`;
}
function Ui(e = "", a = 2) {
  const r = e.trim().split(/\s+/), _ = r.map((n) => [...n][0]);
  if (a < 1) return "";
  if (r.length <= a)
    return _.join("").toUpperCase();
  const o = [_[0]];
  for (let n = r.length - a + 1; n < r.length; n++)
    o.push(_[n]);
  return o.join("").toUpperCase();
}
function Hi(e) {
  let a = e;
  if (e.startsWith("var(--") && e.endsWith(")")) {
    const r = e.slice(4, -1);
    a = window.getComputedStyle(document.documentElement).getPropertyValue(r).trim();
  }
  return a && Kr(a, "#FFFFFF") > 3 ? "var(--color-white)" : "var(--color-black)";
}
const zi = "lc-Avatar-module__avatar___5-kP8", Vi = "lc-Avatar-module__avatar__status___HNURz", Wi = "lc-Avatar-module__avatar__rim___2AzYM", Ki = "lc-Avatar-module__avatar__image___OeTCV", Ie = {
  avatar: zi,
  avatar__status: Vi,
  "avatar__status--available": "lc-Avatar-module__avatar__status--available___e8YYH",
  "avatar__status--unavailable": "lc-Avatar-module__avatar__status--unavailable___EZN8K",
  "avatar__status--unknown": "lc-Avatar-module__avatar__status--unknown___ig3u2",
  "avatar__status--xxxsmall": "lc-Avatar-module__avatar__status--xxxsmall___ywnfb",
  "avatar__status--circle": "lc-Avatar-module__avatar__status--circle___hluXh",
  "avatar__status--xxsmall": "lc-Avatar-module__avatar__status--xxsmall___1cyef",
  "avatar__status--xsmall": "lc-Avatar-module__avatar__status--xsmall___oamOI",
  "avatar__status--small": "lc-Avatar-module__avatar__status--small___mXtgJ",
  "avatar__status--medium": "lc-Avatar-module__avatar__status--medium___itZ--",
  "avatar__status--large": "lc-Avatar-module__avatar__status--large___xhFK7",
  "avatar__status--xlarge": "lc-Avatar-module__avatar__status--xlarge___Tt--f",
  "avatar__status--xxlarge": "lc-Avatar-module__avatar__status--xxlarge___nlhY4",
  "avatar__status--xxxlarge": "lc-Avatar-module__avatar__status--xxxlarge___jOQH-",
  "avatar__status--rounded-square": "lc-Avatar-module__avatar__status--rounded-square___vbnS3",
  avatar__rim: Wi,
  "avatar__rim--xxxsmall": "lc-Avatar-module__avatar__rim--xxxsmall___i9Sfv",
  "avatar__rim--xxsmall": "lc-Avatar-module__avatar__rim--xxsmall___oTxsG",
  "avatar__rim--xsmall": "lc-Avatar-module__avatar__rim--xsmall___EP67J",
  "avatar__rim--small": "lc-Avatar-module__avatar__rim--small___GO4DE",
  "avatar__rim--medium": "lc-Avatar-module__avatar__rim--medium___PwmzG",
  "avatar__rim--large": "lc-Avatar-module__avatar__rim--large___uvcTs",
  "avatar__rim--xlarge": "lc-Avatar-module__avatar__rim--xlarge___bjiXr",
  "avatar__rim--xxlarge": "lc-Avatar-module__avatar__rim--xxlarge___YjUzl",
  "avatar__rim--xxxlarge": "lc-Avatar-module__avatar__rim--xxxlarge___KvgAh",
  avatar__image: Ki,
  "avatar__icon--xxxsmall": "lc-Avatar-module__avatar__icon--xxxsmall___wMbtg",
  "avatar__icon--xxsmall": "lc-Avatar-module__avatar__icon--xxsmall___x736T",
  "avatar__icon--xsmall": "lc-Avatar-module__avatar__icon--xsmall___FEY-4",
  "avatar__icon--small": "lc-Avatar-module__avatar__icon--small___2YWc9",
  "avatar__icon--medium": "lc-Avatar-module__avatar__icon--medium___zNzZn",
  "avatar__icon--large": "lc-Avatar-module__avatar__icon--large___xKot9",
  "avatar__icon--xlarge": "lc-Avatar-module__avatar__icon--xlarge___SaIEW",
  "avatar__icon--xxlarge": "lc-Avatar-module__avatar__icon--xxlarge___nKxnM",
  "avatar__icon--xxxlarge": "lc-Avatar-module__avatar__icon--xxxlarge___2MVJa",
  "avatar--circle": "lc-Avatar-module__avatar--circle___Ys84D",
  "avatar--rounded-square": "lc-Avatar-module__avatar--rounded-square___awk7U",
  "avatar--xxxsmall": "lc-Avatar-module__avatar--xxxsmall___S5mVR",
  "avatar--xxsmall": "lc-Avatar-module__avatar--xxsmall___i7spO",
  "avatar--xsmall": "lc-Avatar-module__avatar--xsmall___WWgCM",
  "avatar--small": "lc-Avatar-module__avatar--small___KH6pw",
  "avatar--medium": "lc-Avatar-module__avatar--medium___un4U9",
  "avatar--large": "lc-Avatar-module__avatar--large___C8hm4",
  "avatar--xlarge": "lc-Avatar-module__avatar--xlarge___hjIy5",
  "avatar--xxlarge": "lc-Avatar-module__avatar--xxlarge___AjkHw",
  "avatar--xxxlarge": "lc-Avatar-module__avatar--xxxlarge___4Hhp9"
}, me = "avatar", Q_ = (p) => {
  var v = p, {
    alt: e,
    className: a,
    color: r,
    shape: _ = "circle",
    size: o = "medium",
    src: n,
    status: i,
    text: c,
    type: d,
    withRim: l = !1,
    style: s
  } = v, m = F(v, [
    "alt",
    "className",
    "color",
    "shape",
    "size",
    "src",
    "status",
    "text",
    "type",
    "withRim",
    "style"
  ]);
  const h = d === "image" && !n, [b, y] = g.useState(h), C = d === "image" && !!n && !b, N = d === "text", B = ["xxxsmall", "xxsmall", "xsmall"].includes(o) ? 1 : 2, $ = Ui(c, B), x = ["xxxsmall", "xxsmall", "xsmall", "small"].includes(o), w = r || Gi(c), S = w ? Hi(w) : void 0, I = N ? { backgroundColor: w } : {}, R = u(k({
    [Ie[me]]: !0,
    [Ie[`${me}--${_}`]]: !0,
    [Ie[`${me}--${o}`]]: !0,
    [Ie[`${me}--with-rim`]]: l
  }, a ? { [`${a}`]: a } : {})), G = u(
    Ie[`${me}__status`],
    Ie[`${me}__status--${_}`],
    Ie[`${me}__status--${o}`],
    ...i ? [Ie[`${me}__status--${i}`]] : []
  ), T = u(
    Ie[`${me}__icon`],
    Ie[`${me}__icon--${o}`]
  ), D = u(
    Ie[`${me}__rim`],
    Ie[`${me}__rim--${o}`]
  ), z = (V) => x ? "2xs" : ["medium"].includes(V) ? "xs" : ["large", "xlarge"].includes(V) ? "sm" : ["xxlarge"].includes(V) ? "lg" : "xl", ie = g.useCallback(() => y(!0), []);
  return g.useEffect(() => {
    y(h);
  }, [h]), /* @__PURE__ */ f(
    "div",
    E(k({
      className: R,
      style: k(k({}, I), s)
    }, m), {
      children: [
        l && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${me}__rim`,
            className: D
          }
        ),
        i && /* @__PURE__ */ t(
          "div",
          {
            "data-testid": `${me}__status`,
            className: G
          }
        ),
        C && /* @__PURE__ */ t(
          "img",
          {
            className: Ie[`${me}__image`],
            src: n,
            alt: e,
            onError: ie
          }
        ),
        N && /* @__PURE__ */ t(
          he,
          {
            as: "span",
            size: z(o),
            style: { color: S },
            bold: x,
            uppercase: x,
            children: $
          }
        ),
        b && /* @__PURE__ */ t(
          P,
          {
            "data-testid": `${me}__icon`,
            className: T,
            source: bo
          }
        )
      ]
    })
  );
}, Yi = "lc-SegmentedControl-module__btn___pG309", Ya = {
  "segmented-control": "lc-SegmentedControl-module__segmented-control___v3EXg",
  btn: Yi,
  "btn--active": "lc-SegmentedControl-module__btn--active___n93GT",
  "btn--compact": "lc-SegmentedControl-module__btn--compact___grlBl",
  "btn--medium": "lc-SegmentedControl-module__btn--medium___YGzgQ",
  "btn--large": "lc-SegmentedControl-module__btn--large___DCJ-p"
}, Xi = "segmented-control", Bs = ({
  size: e = "medium",
  buttons: a,
  className: r,
  initialId: _,
  currentId: o,
  fullWidth: n = !1,
  onButtonClick: i = Sa
}) => {
  const c = u(Ya[Xi], r), [d, l] = g.useState(() => _), s = typeof o == "string";
  g.useEffect(() => {
    s && l(o);
  }, [o]);
  const m = (v, h) => {
    s || l(v), i(v, h);
  }, p = a.map(({ id: v, label: h, loading: b, disabled: y, icon: C }) => {
    const N = v === d, B = N ? Ya["btn--active"] : "";
    return /* @__PURE__ */ t(
      j,
      {
        fullWidth: n,
        loading: N ? !1 : b,
        disabled: y,
        "aria-pressed": N,
        kind: "secondary",
        icon: C,
        className: u(Ya.btn, Ya[`btn--${e}`], B),
        onClick: (x) => {
          m(v, x);
        },
        children: h
      },
      v
    );
  });
  return /* @__PURE__ */ t("div", { role: "group", className: c, children: p });
}, Zi = "lc-Card-module__card___LzN-3", qi = "lc-Card-module__card__header___SRONR", ji = "lc-Card-module__card__header__image___93pD4", Qi = "lc-Card-module__card__header__heading___jK55U", Ji = "lc-Card-module__card__header__heading__title___5090w", ec = "lc-Card-module__card__header__heading__description___iVYoq", tc = "lc-Card-module__card__content___9G1YM", ac = "lc-Card-module__card__actions___gp-xf", rc = "lc-Card-module__card__actions__line___C6TI0", _c = "lc-Card-module__card__actions__buttons___XJlFJ", Te = {
  card: Zi,
  card__header: qi,
  card__header__image: ji,
  card__header__heading: Qi,
  card__header__heading__title: Ji,
  card__header__heading__description: ec,
  "card__header__no-image": "lc-Card-module__card__header__no-image___2gPx6",
  card__content: tc,
  "card__expanded-content": "lc-Card-module__card__expanded-content___WBjEn",
  card__actions: ac,
  card__actions__line: rc,
  card__actions__buttons: _c,
  "card__actions__buttons-expander": "lc-Card-module__card__actions__buttons-expander___I--MQ"
}, $a = "card", nr = `${$a}__header`, Cr = `${nr}__heading`, Xa = `${$a}__actions`, oc = `${nr}__no-image`, Es = (l) => {
  var s = l, {
    alt: e,
    buttonsOptions: a = [],
    children: r,
    className: _,
    description: o,
    expandableContent: n,
    src: i,
    title: c
  } = s, d = F(s, [
    "alt",
    "buttonsOptions",
    "children",
    "className",
    "description",
    "expandableContent",
    "src",
    "title"
  ]);
  const [m, p] = g.useState(!1), v = m ? cr : Ht, h = m ? "Hide" : "Show more", b = (a == null ? void 0 : a.length) > 0, y = !!n, C = b || y, N = c, B = i, $ = B ? "" : Te[oc];
  return /* @__PURE__ */ f("div", E(k({ className: u(Te[$a], _) }, d), { children: [
    N && /* @__PURE__ */ f("div", { className: u(Te[nr], $), children: [
      B && /* @__PURE__ */ t(
        "img",
        {
          alt: e,
          className: Te[`${nr}__image`],
          src: i
        }
      ),
      /* @__PURE__ */ f("div", { className: Te[Cr], children: [
        /* @__PURE__ */ t(he, { size: "xs", className: Te[`${Cr}__title`], children: c }),
        o && /* @__PURE__ */ t(
          A,
          {
            size: "sm",
            className: Te[`${Cr}__description`],
            children: o
          }
        )
      ] })
    ] }),
    /* @__PURE__ */ t(A, { as: "div", size: "md", className: Te[`${$a}__content`], children: r }),
    m && /* @__PURE__ */ t(
      A,
      {
        as: "div",
        size: "md",
        className: Te[`${$a}__expanded-content`],
        children: n
      }
    ),
    C && /* @__PURE__ */ f("div", { className: Te[Xa], children: [
      /* @__PURE__ */ t("div", { className: Te[`${Xa}__line`] }),
      /* @__PURE__ */ f("div", { className: Te[`${Xa}__buttons`], children: [
        b && a.map(
          ({ kind: x, onClick: w, children: S }, I) => /* @__PURE__ */ t(
            j,
            {
              size: "compact",
              kind: x,
              onClick: w,
              children: S
            },
            I
          )
        ),
        y && /* @__PURE__ */ t(
          j,
          {
            className: Te[`${Xa}__buttons-expander`],
            kind: "link",
            iconPosition: "right",
            icon: /* @__PURE__ */ t(P, { source: v }),
            onClick: () => p(!m),
            children: h
          }
        )
      ] })
    ] })
  ] }));
}, O = {
  "date-picker": "lc-DatePicker-module__date-picker___MOZFY",
  "date-picker--interaction-disabled": "lc-DatePicker-module__date-picker--interaction-disabled___HsYQt",
  "date-picker__day": "lc-DatePicker-module__date-picker__day___L1YZn",
  "date-picker__day--disabled": "lc-DatePicker-module__date-picker__day--disabled___9gHax",
  "date-picker__day--selected": "lc-DatePicker-module__date-picker__day--selected___0TQPc",
  "date-picker__day--outside": "lc-DatePicker-module__date-picker__day--outside___1juh7",
  "date-picker__day-content": "lc-DatePicker-module__date-picker__day-content___lZw5f",
  "date-picker__wrapper": "lc-DatePicker-module__date-picker__wrapper___aOFS3",
  "date-picker__months": "lc-DatePicker-module__date-picker__months___RVM2Y",
  "date-picker__month": "lc-DatePicker-module__date-picker__month___Rza9X",
  "date-picker__nav-bar": "lc-DatePicker-module__date-picker__nav-bar___El6Tj",
  "date-picker__nav-button": "lc-DatePicker-module__date-picker__nav-button___fkK9u",
  "date-picker__nav-button--interaction-disabled": "lc-DatePicker-module__date-picker__nav-button--interaction-disabled___65WZH",
  "date-picker__caption": "lc-DatePicker-module__date-picker__caption___-H6z5",
  "date-picker__weekdays": "lc-DatePicker-module__date-picker__weekdays___aqHU0",
  "date-picker__weekdays-row": "lc-DatePicker-module__date-picker__weekdays-row___6IxeG",
  "date-picker__weekday": "lc-DatePicker-module__date-picker__weekday___bdNjp",
  "date-picker__body": "lc-DatePicker-module__date-picker__body___IRpX7",
  "date-picker__week": "lc-DatePicker-module__date-picker__week___vNL3i",
  "date-picker__day-wrapper": "lc-DatePicker-module__date-picker__day-wrapper___Hl3p4",
  "date-picker__day--today": "lc-DatePicker-module__date-picker__day--today___RDhBO",
  "date-picker__footer": "lc-DatePicker-module__date-picker__footer___Fw-oD",
  "date-picker__input": "lc-DatePicker-module__date-picker__input___-cniX",
  "date-picker__input-overlay-wrapper": "lc-DatePicker-module__date-picker__input-overlay-wrapper___uTxhz",
  "date-picker__input-overlay": "lc-DatePicker-module__date-picker__input-overlay___02-SU",
  "date-picker--range": "lc-DatePicker-module__date-picker--range___7dClG",
  "date-picker__day--start": "lc-DatePicker-module__date-picker__day--start___EZNua",
  "date-picker__day--end": "lc-DatePicker-module__date-picker__day--end___XjYEG",
  "date-picker__day--single": "lc-DatePicker-module__date-picker__day--single___g-hc9",
  "date-picker__day--sunday": "lc-DatePicker-module__date-picker__day--sunday___CsSiU",
  "date-picker__day--monday": "lc-DatePicker-module__date-picker__day--monday___iedSa",
  "date-picker--range__select-input": "lc-DatePicker-module__date-picker--range__select-input___hOC44",
  "date-picker--range__calendars-wrapper": "lc-DatePicker-module__date-picker--range__calendars-wrapper___6Nmys",
  "date-picker__navbar-buttons-wrapper": "lc-DatePicker-module__date-picker__navbar-buttons-wrapper___zfbQt"
}, v_ = "date-picker", nc = (e) => {
  const {
    onPreviousClick: a,
    onMonthChange: r,
    onNextClick: _,
    showNextButton: o,
    showPreviousButton: n,
    className: i,
    classNames: c,
    numberOfMonths: d,
    month: l,
    fromMonth: s,
    toMonth: m
  } = e, p = () => {
    typeof a == "function" && a();
  }, v = () => {
    typeof _ == "function" && _();
  }, h = () => {
    if (!s) {
      const N = jt(l, 12);
      return r(N);
    }
    const y = Math.abs(t_(l, s)), C = jt(
      l,
      !Number.isNaN(y) && y > 12 ? 12 : y
    );
    return r(C);
  }, b = () => {
    if (!m) {
      const N = a_(l, 12);
      return r(N);
    }
    const y = Math.abs(t_(m, l)), C = a_(
      l,
      !Number.isNaN(y) && y > 12 ? 12 : y
    );
    return d === 2 && Rr(C, m) ? r(jt(C, 1)) : r(C);
  };
  return /* @__PURE__ */ f("div", { className: i, children: [
    /* @__PURE__ */ f("div", { className: O[`${v_}__navbar-buttons-wrapper`], children: [
      /* @__PURE__ */ t(
        "button",
        {
          "data-testid": "date-picker-prev-year-button",
          className: u({
            [c.navButtonPrev]: !0,
            [c.navButtonInteractionDisabled]: !n
          }),
          onClick: h,
          children: /* @__PURE__ */ t(P, { source: vo, kind: "subtle" })
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          "data-testid": "date-picker-prev-month-button",
          className: u({
            [c.navButtonPrev]: !0,
            [c.navButtonInteractionDisabled]: !n
          }),
          onClick: p,
          children: /* @__PURE__ */ t(P, { source: ko, kind: "subtle" })
        }
      )
    ] }),
    /* @__PURE__ */ f("div", { className: O[`${v_}__navbar-buttons-wrapper`], children: [
      /* @__PURE__ */ t(
        "button",
        {
          "data-testid": "date-picker-next-month-button",
          className: u({
            [c.navButtonNext]: !0,
            [c.navButtonInteractionDisabled]: !o
          }),
          onClick: v,
          children: /* @__PURE__ */ t(P, { source: ir, kind: "subtle" })
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          "data-testid": "date-picker-next-year-button",
          className: u({
            [c.navButtonNext]: !0,
            [c.navButtonInteractionDisabled]: !o
          }),
          onClick: b,
          children: /* @__PURE__ */ t(P, { source: yo, kind: "subtle" })
        }
      )
    ] })
  ] });
}, U = "date-picker", J_ = (e, a) => {
  const { from: r, to: _ } = a;
  return !(_ && !Mr(e, _) && Or(e, _) || r && !Mr(e, r) && !Or(e, r));
}, eo = (e, a, r) => a ? e && !Rr(e, a) || r && Rr(a, r) ? jt(a, 1) : a : jt(r || /* @__PURE__ */ new Date(), 1), ic = (e, a) => {
  const r = {
    [O[`${U}__day--monday`]]: { daysOfWeek: [1] },
    [O[`${U}__day--sunday`]]: { daysOfWeek: [0] },
    [O[`${U}__day--start`]]: e,
    [O[`${U}__day--end`]]: e
  };
  if (!a || !e) return r;
  const _ = Yr(a, e);
  return _ > 0 ? E(k({}, r), {
    [O[`${U}__day--end`]]: a
  }) : _ < 0 ? E(k({}, r), {
    [O[`${U}__day--start`]]: a
  }) : r;
}, wa = (e, a) => {
  const r = a.find((_) => _.id === e);
  return r || void 0;
}, k_ = (e, a) => !!(!e || e && a), cc = (e) => {
  const a = {};
  if (!e.initialSelectedItemKey)
    return a;
  const r = wa(
    e.initialSelectedItemKey,
    e.options
  );
  return r ? (a.selectedItem = e.initialSelectedItemKey, r.isManual && (e.initialFromDate && (a.from = e.initialFromDate), e.initialToDate && (a.to = e.initialToDate, a.temporaryTo = e.initialToDate)), a) : {};
}, lc = (e, a) => k({
  container: u({
    [O[`${U}`]]: !0,
    [O[`${U}--range`]]: e
  }),
  wrapper: O[`${U}__wrapper`],
  interactionDisabled: O[`${U}--interaction-disabled`],
  months: O[`${U}__months`],
  month: O[`${U}__month`],
  navBar: O[`${U}__nav-bar`],
  navButtonPrev: u(
    O[`${U}__nav-button`],
    O[`${U}__nav-button--prev`]
  ),
  navButtonNext: u(
    O[`${U}__nav-button`],
    O[`${U}__nav-button--next`]
  ),
  navButtonInteractionDisabled: O[`${U}__nav-button--interaction-disabled`],
  caption: O[`${U}__caption`],
  weekdays: O[`${U}__weekdays`],
  weekdaysRow: O[`${U}__weekdays-row`],
  weekday: O[`${U}__weekday`],
  body: O[`${U}__body`],
  week: O[`${U}__week`],
  weekNumber: O[`${U}__week-number`],
  day: O[`${U}__day`],
  footer: O[`${U}__footer`],
  todayButton: O[`${U}__today-button`],
  today: O[`${U}__day--today`],
  selected: O[`${U}__day--selected`],
  disabled: O[`${U}__day--disabled`],
  outside: O[`${U}__day--outside`],
  start: O[`${U}__day--start`],
  end: O[`${U}__day--end`]
}, a), y_ = "date-picker", sc = (e) => {
  const a = e.getDate();
  return /* @__PURE__ */ t("div", { className: O[`${y_}__day-wrapper`], children: /* @__PURE__ */ t("div", { className: O[`${y_}__day-content`], children: a }) });
}, dc = (e) => {
  const C = e, {
    classNames: a,
    range: r,
    toMonth: _,
    month: o,
    fromMonth: n,
    firstDayOfWeek: i,
    numberOfMonths: c,
    navbarElement: d,
    renderDay: l,
    innerRef: s
  } = C, m = F(C, [
    "classNames",
    "range",
    "toMonth",
    "month",
    "fromMonth",
    "firstDayOfWeek",
    "numberOfMonths",
    "navbarElement",
    "renderDay",
    "innerRef"
  ]), [p, v] = g.useState(o || /* @__PURE__ */ new Date());
  g.useEffect(() => {
    o && o !== p && v(o);
  }, [o, p]), g.useEffect(() => {
    _ && o !== p && (J_(p, { from: n, to: _ }) || v(_));
  }, [o, p, _, n]);
  const h = g.useCallback(
    (N) => {
      if (e.onMonthChange && N) {
        e.onMonthChange(N);
        return;
      }
      v(N);
    },
    [o, e.onMonthChange]
  );
  let b = 1;
  (i === 0 || i && i < 7) && (b = i);
  const y = g.useMemo(
    () => lc(r, a),
    [r, a]
  );
  return /* @__PURE__ */ t(
    Qo,
    k({
      navbarElement: d || /* @__PURE__ */ t(
        nc,
        {
          month: p,
          classNames: y,
          numberOfMonths: c,
          onMonthChange: h,
          toMonth: _,
          fromMonth: n
        }
      ),
      ref: s,
      classNames: y,
      numberOfMonths: c,
      toMonth: _,
      fromMonth: n,
      firstDayOfWeek: b,
      month: p,
      renderDay: l || sc
    }, m)
  );
}, uc = g.forwardRef(
  (e, a) => /* @__PURE__ */ t(dc, k({ innerRef: a }, e))
);
uc.displayName = "DatePicker";
var ae = /* @__PURE__ */ ((e) => (e.NEW_SELECTED_ITEM = "NEW_SELECTED_ITEM", e.NEW_TEMPORARY_TO_VALUE = "NEW_TEMPORARY_TO_VALUE", e.CLEAR = "CLEAR", e.SET_FROM = "SET_FROM", e.SET_TO = "SET_TO", e.SELECT_FIRST_DAY = "SELECT_FIRST_DAY", e.SELECT_SECOND_DAY_AS_FROM = "SELECT_SECOND_DAY_AS_FROM", e.SELECT_SECOND_DAY_AS_TO = "SELECT_SECOND_DAY_AS_TO", e.CURRENT_MONTH_CHANGE = "CURRENT_MONTH_CHANGE", e))(ae || {});
const mc = (e) => {
  const a = eo(
    e.initialFromDate,
    e.initialToDate,
    e.toMonth
  ), _ = k(k({}, {
    selectedItem: null,
    from: void 0,
    to: void 0,
    temporaryTo: void 0,
    currentMonth: a
  }), cc(e));
  function o(n, i) {
    switch (i.type) {
      case ae.NEW_SELECTED_ITEM:
        return {
          selectedItem: i.payload.selectedItem,
          from: void 0,
          to: void 0,
          temporaryTo: void 0,
          currentMonth: a
        };
      case ae.NEW_TEMPORARY_TO_VALUE:
        return E(k({}, n), {
          temporaryTo: i.payload.date
        });
      case ae.SELECT_FIRST_DAY:
        return E(k({}, n), {
          from: i.payload.date,
          to: void 0,
          temporaryTo: void 0
        });
      case ae.SELECT_SECOND_DAY_AS_FROM:
        return E(k({}, n), {
          from: i.payload.date,
          to: n.from,
          temporaryTo: n.from
        });
      case ae.SELECT_SECOND_DAY_AS_TO:
        return E(k({}, n), {
          to: i.payload.date,
          temporaryTo: i.payload.date
        });
      case ae.CURRENT_MONTH_CHANGE:
        return E(k({}, n), {
          currentMonth: i.payload.date
        });
      case ae.SET_FROM:
        return E(k({}, n), {
          from: i.payload.date
        });
      case ae.SET_TO:
        return E(k({}, n), {
          to: i.payload.date
        });
      default:
        return n;
    }
  }
  return po(o, _);
}, pc = ({
  options: e,
  initialSelectedItemKey: a,
  initialFromDate: r,
  initialToDate: _,
  toMonth: o,
  onChange: n,
  children: i
}) => {
  const c = Hr(
    a || null
  ), [d, l] = mc({
    options: e,
    initialSelectedItemKey: a,
    initialFromDate: r,
    initialToDate: _,
    toMonth: o,
    onChange: n,
    children: i
  });
  at(() => {
    l({
      type: ae.SET_FROM,
      payload: { date: r }
    });
  }, [r]), at(() => {
    l({
      type: ae.SET_TO,
      payload: { date: _ }
    });
  }, [_]), at(() => {
    const b = eo(
      r,
      _,
      o
    );
    l({
      type: ae.CURRENT_MONTH_CHANGE,
      payload: { date: b }
    });
  }, [o, r, _]), at(() => {
    const { from: b, selectedItem: y, to: C } = d;
    if (!(b && C))
      return;
    const N = wa(y, e);
    N && (n == null || n(E(k({}, N), {
      value: {
        from: b,
        to: C
      }
    })));
  }, [d.from, d.to, d.selectedItem, e, n]), at(() => {
    const { selectedItem: b } = d;
    if (b === c.current)
      return;
    if (!b) {
      n(null);
      return;
    }
    if (!wa(b, e))
      return;
    const C = e.reduce(
      (N, B) => E(k({}, N), { [B.id]: B }),
      {}
    );
    n(C[b]);
  }, [n, d.selectedItem, e]);
  const s = Ga(
    (b) => {
      const y = o ? Yr(o, b) >= 0 : !0;
      !k_(d.from, d.to) && y && l({
        type: ae.NEW_TEMPORARY_TO_VALUE,
        payload: { date: b }
      });
    },
    [o, d.from, d.to]
  ), m = Ga(
    (b) => {
      const { from: y, to: C } = d;
      J_(b, { to: o }) && (k_(y, C) ? l({
        type: ae.SELECT_FIRST_DAY,
        payload: { date: b }
      }) : y && Mr(b, y) || y && Or(b, y) ? l({
        type: ae.SELECT_SECOND_DAY_AS_TO,
        payload: { date: b }
      }) : l({
        type: ae.SELECT_SECOND_DAY_AS_FROM,
        payload: { date: b }
      }));
    },
    [o, d.from, d.to]
  ), p = Ga(
    (b) => {
      if (b === null) {
        l({
          type: ae.NEW_SELECTED_ITEM,
          payload: { selectedItem: null }
        });
        return;
      }
      wa(b, e) && l({
        type: ae.NEW_SELECTED_ITEM,
        payload: { selectedItem: b }
      });
    },
    [e]
  ), v = Ga((b) => {
    l({
      type: ae.CURRENT_MONTH_CHANGE,
      payload: { date: b }
    });
  }, []);
  return i((() => {
    const { currentMonth: b, from: y, selectedItem: C, temporaryTo: N, to: B } = d, $ = qt(
      () => ic(y, N),
      [y, N]
    ), x = qt(() => wa(C, e), [e, C]), w = qt(() => [y, { from: y, to: N }], [y, N]), S = qt(() => o ? { after: o } : void 0, [o]);
    return {
      select: {
        onItemSelect: p,
        selected: C || ""
      },
      inputs: {
        fromDate: y,
        toDate: B
      },
      datepicker: {
        range: !0,
        month: b,
        numberOfMonths: 2,
        onDayClick: m,
        selectedDays: w,
        modifiers: $,
        initialMonth: o && jt(o, 1),
        toMonth: o,
        disabledDays: S,
        onDayMouseEnter: s,
        onMonthChange: v
      },
      selectedOption: x
    };
  })());
};
pc.defaultProps = {
  options: [
    {
      id: "default",
      label: "Default option",
      isManual: !0,
      value: {
        from: void 0,
        to: void 0
      }
    }
  ]
};
const Is = (e) => {
  const n = e, { className: a, children: r } = n, _ = F(n, ["className", "children"]), o = u(
    a,
    O["date-picker--range__calendars-wrapper"]
  );
  return /* @__PURE__ */ t("div", E(k({}, _), { className: o, children: r }));
}, X = {
  "details-card": "lc-DetailsCard-module__details-card___v-Avc",
  "details-card__button--fading": "lc-DetailsCard-module__details-card__button--fading___LlMMo",
  "details-card--with-divider": "lc-DetailsCard-module__details-card--with-divider___AhDnH",
  "details-card__label-wrapper": "lc-DetailsCard-module__details-card__label-wrapper___r70F3",
  "details-card__label-wrapper--hide": "lc-DetailsCard-module__details-card__label-wrapper--hide___Nz6ap",
  "details-card__label-wrapper--fading": "lc-DetailsCard-module__details-card__label-wrapper--fading___gPYF3",
  "details-card__label": "lc-DetailsCard-module__details-card__label___4cvW8",
  "details-card__label--with-margin": "lc-DetailsCard-module__details-card__label--with-margin___3bSuV",
  "details-card__label__left-node": "lc-DetailsCard-module__details-card__label__left-node___Vpq-P",
  "details-card__label__right-node": "lc-DetailsCard-module__details-card__label__right-node___640HC",
  "details-card__label__content": "lc-DetailsCard-module__details-card__label__content___iMTpo",
  "details-card__button": "lc-DetailsCard-module__details-card__button___x6Yex",
  "details-card__button--closed": "lc-DetailsCard-module__details-card__button--closed___4sjdi",
  "details-card__button__icon": "lc-DetailsCard-module__details-card__button__icon___clN8y",
  "details-card__button__icon--open": "lc-DetailsCard-module__details-card__button__icon--open___IU-Rk",
  "details-card__content-wrapper": "lc-DetailsCard-module__details-card__content-wrapper___6U9cE",
  "details-card__content-wrapper--open": "lc-DetailsCard-module__details-card__content-wrapper--open___n-ZsY",
  "details-card__content": "lc-DetailsCard-module__details-card__content___aJux3",
  "details-card__content--spacing": "lc-DetailsCard-module__details-card__content--spacing___F17pU",
  "details-card__content--full-space": "lc-DetailsCard-module__details-card__content--full-space___8CLFw"
}, Z = "details-card", gc = ["input", "button", "select", "textarea", "a"], Ts = ({
  children: e,
  className: a,
  leftNode: r,
  rightNode: _,
  label: o,
  withDivider: n,
  fullSpaceContent: i,
  openOnInit: c = !1,
  hideLabelOnOpen: d,
  onClick: l
}) => {
  const [s, m] = g.useState(c), [p, v] = g.useState(0), h = g.useRef(null), b = u(
    X[Z],
    n && X[`${Z}--with-divider`],
    a
  ), y = d && s, C = typeof o == "string", N = ($) => {
    m((x) => !x), $.currentTarget.blur(), l == null || l($);
  }, B = ($) => {
    const w = $.target.tagName.toLowerCase();
    gc.includes(w) || (m((S) => !S), l == null || l($));
  };
  return g.useEffect(() => {
    const $ = !!window.IntersectionObserver;
    if (h.current && $) {
      const x = new ResizeObserver(() => {
        h.current && p !== h.current.offsetHeight && v(h.current.offsetHeight);
      });
      return x.observe(h.current), () => x.disconnect();
    }
  }, [h]), /* @__PURE__ */ f("div", { className: b, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: u(
          X[`${Z}__label-wrapper`],
          d && X[`${Z}__label-wrapper--fading`],
          y && X[`${Z}__label-wrapper--hide`],
          s && X[`${Z}__label-wrapper--open`]
        ),
        "aria-expanded": s,
        "aria-hidden": y,
        "data-testid": "details-card-label",
        onClick: B,
        children: /* @__PURE__ */ f(
          "div",
          {
            className: u(
              X[`${Z}__label`],
              d && X[`${Z}__label--with-margin`]
            ),
            children: [
              r && /* @__PURE__ */ t("div", { className: X[`${Z}__label__left-node`], children: r }),
              C ? /* @__PURE__ */ t(
                he,
                {
                  size: "xs",
                  className: X[`${Z}__label__content`],
                  children: o
                }
              ) : /* @__PURE__ */ t("div", { className: X[`${Z}__label__content`], children: o }),
              _ && /* @__PURE__ */ t("div", { className: X[`${Z}__label__right-node`], children: _ })
            ]
          }
        )
      }
    ),
    /* @__PURE__ */ t(
      j,
      {
        kind: s && d ? "float" : "text",
        icon: /* @__PURE__ */ t(
          P,
          {
            source: ir,
            className: u(
              X[`${Z}__button__icon`],
              s && X[`${Z}__button__icon--open`]
            )
          }
        ),
        className: u(
          X[`${Z}__button`],
          !s && X[`${Z}__button--closed`],
          s && X[`${Z}__button--open`],
          d && X[`${Z}__button--fading`]
        ),
        onClick: N,
        "aria-expanded": s
      }
    ),
    /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
      "div",
      {
        className: u(
          X[`${Z}__content-wrapper`],
          s && X[`${Z}__content-wrapper--open`]
        ),
        style: {
          maxHeight: s ? p : 0
        },
        children: /* @__PURE__ */ t(
          "div",
          {
            ref: h,
            className: u(
              X[`${Z}__content`],
              i && X[`${Z}__content--full-space`],
              d && X[`${Z}__content--spacing`]
            ),
            children: e
          }
        )
      }
    ) })
  ] });
}, $r = {
  "details-card-info": "lc-DetailsCardInfo-module__details-card-info___22mOK",
  "details-card-info__label": "lc-DetailsCardInfo-module__details-card-info__label___LXTXh",
  "details-card-info__content": "lc-DetailsCardInfo-module__details-card-info__content___03cfr"
}, Nr = "details-card-info", As = ({ children: e, label: a }) => /* @__PURE__ */ f("div", { className: $r[Nr], children: [
  /* @__PURE__ */ t("div", { className: $r[`${Nr}__label`], children: a }),
  /* @__PURE__ */ t("div", { className: $r[`${Nr}__content`], children: e })
] }), w_ = {
  "field-error": "lc-FieldError-module__field-error___-rtI3",
  "field-error__icon": "lc-FieldError-module__field-error__icon___4KpOc"
}, C_ = "field-error", jr = (_) => {
  var o = _, {
    children: e,
    className: a = ""
  } = o, r = F(o, [
    "children",
    "className"
  ]);
  const n = u(w_[C_], a);
  return /* @__PURE__ */ f(A, E(k({ as: "span", size: "sm" }, r), { className: n, children: [
    /* @__PURE__ */ t(
      P,
      {
        source: Na,
        className: w_[`${C_}__icon`],
        size: "small"
      }
    ),
    e
  ] }));
}, Sr = {
  "field-group": "lc-FieldGroup-module__field-group___--i2x",
  "field-group--inline": "lc-FieldGroup-module__field-group--inline___iSg4S",
  "field-group--stretched": "lc-FieldGroup-module__field-group--stretched___4Evlw"
}, xr = "field-group", Ds = (c) => {
  var d = c, {
    className: e = "",
    children: a,
    description: r,
    error: _,
    inline: o,
    stretch: n
  } = d, i = F(d, [
    "className",
    "children",
    "description",
    "error",
    "inline",
    "stretch"
  ]);
  const l = u(Sr[xr], e, {
    [Sr[`${xr}--inline`]]: o,
    [Sr[`${xr}--stretched`]]: n
  });
  return /* @__PURE__ */ f("div", E(k({}, i), { className: l, children: [
    a,
    _ && /* @__PURE__ */ t(jr, { children: _ }),
    r && /* @__PURE__ */ t(ur, { children: r })
  ] }));
}, hc = "lc-Form-module__form___ddwfw", fc = "lc-Form-module__form__header___mr4AX", bc = "lc-Form-module__form__footer___NJUBH", vc = "lc-Form-module__form__label___2hAXA", kc = "lc-Form-module__form__helper___r1lJG", sa = {
  form: hc,
  form__header: fc,
  form__footer: bc,
  form__label: vc,
  form__helper: kc
}, da = "form", Ps = (i) => {
  var c = i, {
    className: e,
    children: a,
    labelText: r,
    helperText: _,
    formFooter: o
  } = c, n = F(c, [
    "className",
    "children",
    "labelText",
    "helperText",
    "formFooter"
  ]);
  return /* @__PURE__ */ f("form", E(k({ className: u(sa[da], e) }, n), { children: [
    (r || _) && /* @__PURE__ */ f("div", { className: sa[`${da}__header`], children: [
      r && /* @__PURE__ */ t(he, { size: "sm", className: sa[`${da}__label`], children: r }),
      _ && /* @__PURE__ */ t(A, { as: "p", size: "sm", className: sa[`${da}__helper`], children: _ })
    ] }),
    a,
    o && /* @__PURE__ */ t("div", { className: sa[`${da}__footer`], children: o })
  ] }));
}, re = {
  "form-field": "lc-FormField-module__form-field___kx7Vx",
  "form-field--inline": "lc-FormField-module__form-field--inline___1xuhX",
  "form-field__wrapper--inline": "lc-FormField-module__form-field__wrapper--inline___MPvG-",
  "form-field__label": "lc-FormField-module__form-field__label___xZ4Qz",
  "form-field__label--inline": "lc-FormField-module__form-field__label--inline___x9AUt",
  "form-field__label--no-text": "lc-FormField-module__form-field__label--no-text___h2VqV",
  "form-field__label-wrapper": "lc-FormField-module__form-field__label-wrapper___O1XAl",
  "form-field__label-wrapper--inline": "lc-FormField-module__form-field__label-wrapper--inline___5hqdR",
  "form-field__label-adornment": "lc-FormField-module__form-field__label-adornment___4uieF",
  "form-field__label-adornment--inline": "lc-FormField-module__form-field__label-adornment--inline___Uj4Y6",
  "form-field__label-left-node": "lc-FormField-module__form-field__label-left-node___XWg6l",
  "form-field__label-right-node": "lc-FormField-module__form-field__label-right-node___dzUl6",
  "form-field__label-right-node--inline": "lc-FormField-module__form-field__label-right-node--inline___zfQ8H",
  "form-field__row-break": "lc-FormField-module__form-field__row-break___ibOb7",
  "form-field__content": "lc-FormField-module__form-field__content___7Cnwe",
  "form-field__content__description": "lc-FormField-module__form-field__content__description___qdMlU"
}, _e = "form-field", Fs = ({
  inline: e,
  error: a,
  description: r,
  labelText: _,
  labelAdornment: o,
  className: n,
  labelFor: i,
  children: c,
  labelRightNode: d
}) => {
  const l = g.useRef(null), [s, m] = g.useState("auto"), p = u(
    re[_e],
    {
      [re[`${_e}--inline`]]: e
    },
    n
  );
  return g.useEffect(() => {
    const v = l;
    return e && v.current ? m(`${v.current.clientHeight}px`) : m("auto");
  }), /* @__PURE__ */ f("div", { className: p, children: [
    d && e && /* @__PURE__ */ f(g.Fragment, { children: [
      /* @__PURE__ */ t(
        A,
        {
          as: "div",
          size: "sm",
          className: u(
            re[`${_e}__label-right-node`],
            re[`${_e}__label-right-node--inline`]
          ),
          children: d
        }
      ),
      /* @__PURE__ */ t("div", { className: re[`${_e}__row-break`] })
    ] }),
    /* @__PURE__ */ f(
      "div",
      {
        className: u(
          re[`${_e}__wrapper`],
          e && re[`${_e}__wrapper--inline`]
        ),
        children: [
          (_ || d) && /* @__PURE__ */ f(
            "div",
            {
              className: u(
                re[`${_e}__label`],
                e && re[`${_e}__label--inline`],
                !_ && re[`${_e}__label--no-text`]
              ),
              children: [
                _ && /* @__PURE__ */ f(
                  "div",
                  {
                    className: u(
                      re[`${_e}__label-wrapper`],
                      e && re[`${_e}__label-wrapper--inline`]
                    ),
                    style: {
                      height: s
                    },
                    children: [
                      /* @__PURE__ */ t(
                        "label",
                        {
                          className: re[`${_e}__label-left-node`],
                          htmlFor: i,
                          children: /* @__PURE__ */ t(A, { as: "span", size: "sm", children: _ })
                        }
                      ),
                      o && /* @__PURE__ */ t(
                        A,
                        {
                          as: "div",
                          size: "sm",
                          className: u(
                            re[`${_e}__label-adornment`],
                            e && re[`${_e}__label-adornment--inline`]
                          ),
                          children: o
                        }
                      )
                    ]
                  }
                ),
                d && !e && /* @__PURE__ */ t(
                  A,
                  {
                    as: "div",
                    size: "sm",
                    className: u(re[`${_e}__label-right-node`]),
                    children: d
                  }
                )
              ]
            }
          ),
          /* @__PURE__ */ f("div", { className: u(re[`${_e}__content`]), children: [
            /* @__PURE__ */ t("div", { ref: l, children: c }),
            a && /* @__PURE__ */ t(jr, { children: a }),
            !a && r && /* @__PURE__ */ t(
              ur,
              {
                className: u(re[`${_e}__content__description`]),
                children: r
              }
            )
          ] })
        ]
      }
    )
  ] });
}, Za = {
  "form-group": "lc-FormGroup-module__form-group___uAHnp",
  "form-group__header": "lc-FormGroup-module__form-group__header___U4FrR",
  "form-group__label": "lc-FormGroup-module__form-group__label___9AcBX",
  "form-group__helper": "lc-FormGroup-module__form-group__helper___2XQcm"
}, qa = "form-group", Rs = (n) => {
  var i = n, {
    className: e = "",
    children: a,
    labelText: r,
    helperText: _
  } = i, o = F(i, [
    "className",
    "children",
    "labelText",
    "helperText"
  ]);
  const c = u(Za[qa], e);
  return /* @__PURE__ */ f(
    "div",
    E(k(E(k({}, o), {
      role: "group"
    }), r && { "aria-label": r }), {
      className: c,
      children: [
        (r || _) && /* @__PURE__ */ f("div", { className: Za[`${qa}__header`], children: [
          r && /* @__PURE__ */ t(
            he,
            {
              as: "div",
              size: "sm",
              className: Za[`${qa}__label`],
              children: r
            }
          ),
          _ && /* @__PURE__ */ t(A, { as: "div", size: "sm", className: Za[`${qa}__helper`], children: _ })
        ] }),
        a
      ]
    })
  );
}, yc = "lc-AnimatedButton-module__icon___x-2D0", wc = "lc-AnimatedButton-module__text___JEZ-a", Cc = "lc-AnimatedButton-module__expanded___oXA4t", ja = {
  "animated-button": "lc-AnimatedButton-module__animated-button___d1ume",
  icon: yc,
  text: wc,
  expanded: Cc
}, $c = ({
  icon: e,
  text: a,
  onClick: r,
  className: _,
  isExpanded: o
}) => {
  const [n, i] = Jt(!1), c = o !== void 0, d = c ? o : n, l = () => {
    i(!0);
  }, s = () => {
    i(!1);
  };
  return at(() => {
    c && !o && i(!1);
  }, [c, o]), /* @__PURE__ */ f(
    "button",
    {
      type: "button",
      className: u(
        ja["animated-button"],
        { [ja.expanded]: d },
        _
      ),
      onClick: r,
      onMouseEnter: l,
      onMouseLeave: s,
      children: [
        /* @__PURE__ */ t("span", { className: ja.icon, children: e }),
        /* @__PURE__ */ t("span", { className: ja.text, children: a })
      ]
    }
  );
}, $_ = {
  available: 1,
  unavailable: 2,
  unknown: 3
}, Nc = (e) => [...e].sort((a, r) => $_[a.status] - $_[r.status]), Ae = {
  "invite-agents": "lc-InviteAgents-module__invite-agents___XHov-",
  "invite-agents--empty": "lc-InviteAgents-module__invite-agents--empty___-uyZv",
  "invite-agents--only-unavailable": "lc-InviteAgents-module__invite-agents--only-unavailable___rwGmo",
  "invite-agents__not-accepting": "lc-InviteAgents-module__invite-agents__not-accepting___GF-hX",
  "invite-agents__tooltip": "lc-InviteAgents-module__invite-agents__tooltip___8CJxu",
  "invite-agents__tooltip-trigger": "lc-InviteAgents-module__invite-agents__tooltip-trigger___I77qz",
  "invite-agents__not-accepting-status-dot": "lc-InviteAgents-module__invite-agents__not-accepting-status-dot___BnVII",
  "invite-agents__avatar-container": "lc-InviteAgents-module__invite-agents__avatar-container___r56c3",
  "invite-agents__avatar": "lc-InviteAgents-module__invite-agents__avatar___Qs6yT",
  "invite-agents__available-agents-number": "lc-InviteAgents-module__invite-agents__available-agents-number___WpNqr",
  "invite-agents__accepting-agents": "lc-InviteAgents-module__invite-agents__accepting-agents___KNMQw",
  "invite-agents__accepting-agents-row": "lc-InviteAgents-module__invite-agents__accepting-agents-row___bTb9i"
}, De = "invite-agents", Sc = 50, xc = (l) => {
  var s = l, {
    agents: e,
    onSetUpChatbotClick: a,
    onAddTeammateClick: r,
    className: _,
    animatedInviteButton: o = !1,
    tooltipArrowOffset: n = 13,
    onAvailableAgentsClick: i,
    showBotsInTooltip: c = !0
  } = s, d = F(s, [
    "agents",
    "onSetUpChatbotClick",
    "onAddTeammateClick",
    "className",
    "animatedInviteButton",
    "tooltipArrowOffset",
    "onAvailableAgentsClick",
    "showBotsInTooltip"
  ]);
  const [m, p] = Jt(!1), [v, h] = Jt(!1), {
    availableAgentsNumber: b,
    visibleAgents: y,
    hasOnlyUnavailableAgents: C,
    onlyAgentsNumber: N,
    onlyBotsNumber: B
  } = qt(() => {
    const I = e.filter(
      (V) => V.status === "available"
    ), R = Nc(I), G = I.length, T = R.length > 4 ? R.slice(0, 3) : R, D = e.length > 0 && G === 0, z = I.filter(
      (V) => !V.isBot
    ).length, ie = G - z;
    return {
      availableAgentsNumber: G,
      visibleAgents: T,
      hasOnlyUnavailableAgents: D,
      onlyAgentsNumber: z,
      onlyBotsNumber: ie
    };
  }, [e]), $ = () => {
    a(), p(!1), h(!1);
  }, x = () => {
    r(), p(!1), h(!1);
  }, w = () => {
    i(), p(!1), h(!1);
  }, S = [
    {
      key: "chatbot",
      onClick: $,
      element: /* @__PURE__ */ t(Lr, { leftNode: /* @__PURE__ */ t(P, { source: No }), children: "Set up ChatBot" })
    },
    {
      key: "teammate",
      element: /* @__PURE__ */ t(Lr, { leftNode: /* @__PURE__ */ t(P, { source: So }), children: "Invite teammate" }),
      onClick: x
    }
  ];
  return /* @__PURE__ */ f(
    "div",
    E(k({}, d), {
      className: u(
        Dt.Dark,
        Ae[De],
        {
          [Ae[`${De}--empty`]]: e.length === 0,
          [Ae[`${De}--only-unavailable`]]: C
        },
        _
      ),
      children: [
        e.length > 0 && /* @__PURE__ */ t(
          Ut,
          {
            isVisible: v && !m,
            offsetMainAxis: n,
            floatingStrategy: "fixed",
            hoverOnDelay: Sc,
            onOpen: () => h(!0),
            onClose: () => h(!1),
            className: u(Dt.Dark, Ae[`${De}__tooltip`]),
            triggerRenderer: C ? /* @__PURE__ */ f(
              "div",
              {
                className: Ae[`${De}__not-accepting`],
                onClick: w,
                children: [
                  /* @__PURE__ */ t(
                    "div",
                    {
                      className: u(
                        Ae[`${De}__not-accepting-status-dot`]
                      )
                    }
                  ),
                  /* @__PURE__ */ t(A, { noMargin: !0, bold: !0, size: "sm", children: "No active agents" })
                ]
              }
            ) : /* @__PURE__ */ f(
              "div",
              {
                className: Ae[`${De}__tooltip-trigger`],
                onClick: w,
                children: [
                  /* @__PURE__ */ t("div", { className: Ae[`${De}__avatar-container`], children: y.map((I, R) => /* @__PURE__ */ t(
                    Q_,
                    {
                      text: I.name,
                      className: Ae[`${De}__avatar`],
                      type: I.avatar ? "image" : "text",
                      size: "xsmall",
                      status: I.status,
                      src: I.avatar,
                      style: { zIndex: e.length - R }
                    },
                    I.email
                  )) }),
                  b > 0 && /* @__PURE__ */ t(
                    A,
                    {
                      className: Ae[`${De}__available-agents-number`],
                      children: b
                    }
                  )
                ]
              }
            ),
            children: C ? /* @__PURE__ */ t(
              An,
              {
                header: "No one's available to assist customers",
                text: "Offer 24/7 support with ChatBot.",
                primaryButton: {
                  handleClick: $,
                  label: "Set up ChatBot"
                }
              }
            ) : /* @__PURE__ */ f(
              A,
              {
                as: "div",
                noMargin: !0,
                size: "md",
                className: Ae[`${De}__accepting-agents`],
                children: [
                  /* @__PURE__ */ t(A, { bold: !0, noMargin: !0, children: "Accepting chats:" }),
                  /* @__PURE__ */ f(
                    A,
                    {
                      noMargin: !0,
                      className: Ae[`${De}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ t(P, { source: wo }),
                        or(
                          N,
                          "1 agent",
                          `${N} agents`
                        )
                      ]
                    }
                  ),
                  c && /* @__PURE__ */ f(
                    A,
                    {
                      noMargin: !0,
                      className: Ae[`${De}__accepting-agents-row`],
                      children: [
                        /* @__PURE__ */ t(P, { source: Co }),
                        or(B, "1 bot", `${B} bots`)
                      ]
                    }
                  )
                ]
              }
            )
          }
        ),
        /* @__PURE__ */ t(
          G_,
          {
            floatingStrategy: "fixed",
            visible: m,
            onOpen: () => p(!0),
            onClose: () => p(!1),
            options: S,
            triggerRenderer: /* @__PURE__ */ t(
              $c,
              {
                icon: /* @__PURE__ */ t(P, { source: $o }),
                text: "Invite",
                onClick: () => p((I) => !I),
                isExpanded: o ? m || void 0 : !0
              }
            )
          }
        )
      ]
    })
  );
}, Ms = go(xc), Bc = "lc-Link-module__link___35Vo1", N_ = {
  link: Bc,
  "link--bold": "lc-Link-module__link--bold___9Uq3Z"
}, S_ = "link", Os = (_) => {
  var o = _, {
    bold: e = !1,
    className: a = ""
  } = o, r = F(o, [
    "bold",
    "className"
  ]);
  return /* @__PURE__ */ t(
    "a",
    k({
      className: u(
        N_[S_],
        e && N_[`${S_}--bold`],
        a
      )
    }, r)
  );
}, Ec = "lc-Modal-module__modal__body___K3X3J", Ic = "lc-Modal-module__modal__header___22qVU", Tc = "lc-Modal-module__modal__heading___TQl-G", Ac = "lc-Modal-module__modal__footer___-z-ze", ve = {
  "modal-base": "lc-Modal-module__modal-base___W3hsn",
  "fade-in": "lc-Modal-module__fade-in___uf1sy",
  "modal-base--full-space": "lc-Modal-module__modal-base--full-space___I5mqs",
  "modal-base__overlay": "lc-Modal-module__modal-base__overlay___BXG-c",
  "modal-base__overlay--visible": "lc-Modal-module__modal-base__overlay--visible___SkPQ3",
  "modal-base__overlay--labelled": "lc-Modal-module__modal-base__overlay--labelled___XJo16",
  "modal-base__close": "lc-Modal-module__modal-base__close___a2xPW",
  "modal-base__close--label-type": "lc-Modal-module__modal-base__close--label-type___IWIlG",
  modal__body: Ec,
  modal__header: Ic,
  "modal__header--without-heading": "lc-Modal-module__modal__header--without-heading___-zvH5",
  "modal__label-header": "lc-Modal-module__modal__label-header___LL-pz",
  modal__heading: Tc,
  "modal__label-heading": "lc-Modal-module__modal__label-heading___OZoP1",
  modal__footer: Ac
}, ua = "modal-base", Dc = (d) => {
  var l = d, {
    children: e,
    className: a = "",
    onClose: r,
    closeOnEscPress: _ = !0,
    closeOnOverlayPress: o = !0,
    fullSpaceContent: n,
    isLabelled: i
  } = l, c = F(l, [
    "children",
    "className",
    "onClose",
    "closeOnEscPress",
    "closeOnOverlayPress",
    "fullSpaceContent",
    "isLabelled"
  ]);
  const s = u(
    ve[ua],
    a,
    n && ve[`${ua}--full-space`]
  );
  return g.useEffect(() => {
    if (!_)
      return;
    const p = (v) => {
      v.key === ke.esc && r();
    };
    return document.addEventListener("keyup", p, !0), () => document.removeEventListener("keyup", p, !0);
  }, [_]), /* @__PURE__ */ t(
    Yo,
    {
      "data-testid": "lc-modal-overlay",
      onMouseDown: (p) => {
        o && p.target === p.currentTarget && r();
      },
      className: u(
        ve[`${ua}__overlay`],
        ve[`${ua}__overlay--visible`],
        i && ve[`${ua}__overlay--labelled`]
      ),
      children: /* @__PURE__ */ t(
        "div",
        E(k({
          role: "dialog",
          "aria-modal": !0,
          className: s
        }, c), {
          children: e
        })
      )
    }
  );
}, x_ = ({
  labelType: e,
  customColor: a,
  onClick: r
}) => /* @__PURE__ */ t(
  j,
  {
    type: "button",
    kind: "plain",
    "aria-label": "Close modal",
    title: "Close modal",
    className: u(
      ve["modal-base__close"],
      e && ve["modal-base__close--label-type"]
    ),
    onClick: r,
    icon: /* @__PURE__ */ t(P, { source: Ue, size: "medium", customColor: a })
  }
), Tt = "modal", Ls = (l) => {
  var s = l, {
    children: e,
    className: a = "",
    heading: r,
    labelHeading: _,
    fullSpaceContent: o,
    footer: n,
    onClose: i,
    contentClassName: c
  } = s, d = F(s, [
    "children",
    "className",
    "heading",
    "labelHeading",
    "fullSpaceContent",
    "footer",
    "onClose",
    "contentClassName"
  ]);
  const m = u(ve[Tt], a), p = typeof e == "string", v = (h) => {
    h.preventDefault(), h.stopPropagation(), i();
  };
  return /* @__PURE__ */ f(
    Dc,
    E(k({
      className: m,
      fullSpaceContent: o,
      onClose: i,
      isLabelled: !!_
    }, d), {
      children: [
        _ && /* @__PURE__ */ f("div", { className: ve[`${Tt}__label-header`], children: [
          /* @__PURE__ */ t(
            he,
            {
              size: "sm",
              as: "div",
              className: ve[`${Tt}__label-heading`],
              children: _
            }
          ),
          /* @__PURE__ */ t(
            x_,
            {
              labelType: !!_,
              customColor: "var(--color-white)",
              onClick: v
            }
          )
        ] }),
        !_ && /* @__PURE__ */ f(
          "div",
          {
            className: u(ve[`${Tt}__header`], {
              [ve[`${Tt}__header--without-heading`]]: !r
            }),
            children: [
              r && /* @__PURE__ */ t(
                he,
                {
                  size: "sm",
                  as: "div",
                  className: ve[`${Tt}__heading`],
                  children: r
                }
              ),
              /* @__PURE__ */ t(x_, { onClick: v })
            ]
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "modal-body",
            className: u(ve[`${Tt}__body`], c),
            children: p ? /* @__PURE__ */ t(A, { as: "div", children: e }) : e
          }
        ),
        n && /* @__PURE__ */ t("div", { className: ve[`${Tt}__footer`], children: n })
      ]
    })
  );
}, Gs = ({
  children: e,
  className: a = "",
  parentElementName: r = "body",
  zIndex: _
}) => {
  const o = Hr(document.createElement("div"));
  return at(() => {
    const n = o.current, i = document.querySelector(r);
    return i && i.appendChild(n), () => {
      i && i.removeChild(n);
    };
  }, [r]), at(() => {
    const n = o.current;
    a && (n.className = a), _ && (n.style.zIndex = `${_}`);
  }, [a, _]), qo(/* @__PURE__ */ t(ne, { children: e }), o.current);
}, ma = {
  "modal-header": "lc-ModalHeader-module__modal-header___YwkiN",
  "modal-header__heading-left-node": "lc-ModalHeader-module__modal-header__heading-left-node___SZBRX",
  "modal-header__heading-body": "lc-ModalHeader-module__modal-header__heading-body___aBgMz",
  "modal-header__heading-description": "lc-ModalHeader-module__modal-header__heading-description___dpbWK"
}, pa = "modal-header", Us = ({ title: e, iconProps: a, avatarProps: r, children: _, className: o = "" }) => {
  const n = u(ma[pa], o);
  return /* @__PURE__ */ f("div", { className: n, children: [
    a && /* @__PURE__ */ t(
      P,
      k({
        className: ma[`${pa}__heading-left-node`]
      }, a)
    ),
    r && /* @__PURE__ */ t(
      Q_,
      k({
        className: ma[`${pa}__heading-left-node`]
      }, r)
    ),
    /* @__PURE__ */ f("div", { className: ma[`${pa}__heading-body`], children: [
      /* @__PURE__ */ t(he, { as: "div", size: "sm", children: e }),
      _ && /* @__PURE__ */ t(
        A,
        {
          as: "div",
          className: ma[`${pa}__heading-description`],
          children: _
        }
      )
    ] })
  ] });
}, ga = {
  "action-modal-content": "lc-ActionModalContent-module__action-modal-content___LGNxr",
  "action-modal-content__icon": "lc-ActionModalContent-module__action-modal-content__icon___JYTP2",
  "action-modal-content__heading": "lc-ActionModalContent-module__action-modal-content__heading___gGgOD",
  "action-modal-content__content": "lc-ActionModalContent-module__action-modal-content__content___K4e5r",
  "action-modal-content__actions": "lc-ActionModalContent-module__action-modal-content__actions___bgnDV"
}, ha = "action-modal-content", Hs = ({
  children: e,
  className: a,
  icon: r,
  heading: _,
  actions: o,
  headerClassName: n,
  contentClassName: i
}) => {
  const c = u(ga[ha], a);
  return /* @__PURE__ */ f("div", { className: c, children: [
    r && /* @__PURE__ */ t("div", { className: ga[`${ha}__icon`], children: r }),
    _ && /* @__PURE__ */ t(
      he,
      {
        className: u(ga[`${ha}__heading`], n),
        children: _
      }
    ),
    /* @__PURE__ */ t(
      A,
      {
        as: "div",
        className: u(ga[`${ha}__content`], i),
        children: e
      }
    ),
    o && /* @__PURE__ */ t("div", { className: ga[`${ha}__actions`], children: o })
  ] });
}, Xt = {
  "numeric-input": "lc-NumericInput-module__numeric-input___qYvYK",
  "numeric-input__increment": "lc-NumericInput-module__numeric-input__increment___7AdPN",
  "numeric-input__decrement": "lc-NumericInput-module__numeric-input__decrement___18Raa",
  "numeric-input--disabled": "lc-NumericInput-module__numeric-input--disabled___s2O8w",
  "numeric-input--no-controls": "lc-NumericInput-module__numeric-input--no-controls___nO8zN",
  "numeric-input--error": "lc-NumericInput-module__numeric-input--error___y9v6f"
}, Zt = "numeric-input", zs = (s) => {
  var m = s, {
    className: e,
    error: a,
    value: r,
    max: _,
    min: o,
    disabled: n,
    noControls: i,
    style: c,
    onChange: d
  } = m, l = F(m, [
    "className",
    "error",
    "value",
    "max",
    "min",
    "disabled",
    "noControls",
    "style",
    "onChange"
  ]);
  const p = g.useRef(null), v = u(
    Xt[Zt],
    {
      [Xt[`${Zt}--error`]]: a,
      [Xt[`${Zt}--no-controls`]]: i,
      [Xt[`${Zt}--disabled`]]: n
    },
    e
  ), h = (w) => d(String(w)), b = (w) => _ !== void 0 && w > _ ? _ : o !== void 0 && w < o ? o : w, y = (w) => {
    const S = parseInt(r, 10) + w;
    return h(b(S));
  }, C = (w) => {
    w.key === ke.arrowDown && (w.preventDefault(), y(-1)), w.key === ke.arrowUp && (w.preventDefault(), y(1));
  }, N = (w, S) => S !== void 0 && parseInt(w, 10) === S, B = (w) => {
    w.preventDefault(), w.stopPropagation();
    const S = w.currentTarget.value.replace(
      /((?!([-]|([-]?\d+))).)/,
      ""
    );
    if (S === "" || S === "-")
      return h(S);
    const I = parseInt(S, 10);
    return h(b(I));
  }, $ = () => {
    var w;
    return (w = p.current) == null || w.focus(), y(1);
  }, x = () => {
    var w;
    return (w = p.current) == null || w.focus(), y(-1);
  };
  return /* @__PURE__ */ f("div", { className: v, style: c, children: [
    /* @__PURE__ */ t(
      "input",
      E(k({
        type: "text",
        ref: p
      }, l), {
        value: r,
        disabled: n,
        onChange: B,
        onKeyDown: C,
        min: o,
        max: _
      })
    ),
    !i && /* @__PURE__ */ f(ne, { children: [
      /* @__PURE__ */ t(
        "button",
        {
          tabIndex: -1,
          disabled: n || N(r, _),
          onClick: $,
          "aria-label": "Increment value",
          className: Xt[`${Zt}__increment`],
          type: "button",
          children: /* @__PURE__ */ t(
            P,
            {
              source: cr,
              disabled: n || N(r, _),
              kind: "primary"
            }
          )
        }
      ),
      /* @__PURE__ */ t(
        "button",
        {
          tabIndex: -1,
          disabled: n || N(r, o),
          "aria-label": "Decrement value",
          className: Xt[`${Zt}__decrement`],
          onClick: x,
          type: "button",
          children: /* @__PURE__ */ t(
            P,
            {
              source: Ht,
              kind: "primary",
              disabled: n || N(r, o)
            }
          )
        }
      )
    ] })
  ] });
}, pe = {
  "checklist-item": "lc-CheckListItem-module__checklist-item___iuIlB",
  "checklist-item--active": "lc-CheckListItem-module__checklist-item--active___aoLek",
  "checklist-item__check-mark": "lc-CheckListItem-module__checklist-item__check-mark___stkGB",
  "checklist-item__check-mark--checked": "lc-CheckListItem-module__checklist-item__check-mark--checked___qcaKG",
  "checklist-item__check-mark__line": "lc-CheckListItem-module__checklist-item__check-mark__line___lbHk-",
  "checklist-item__content": "lc-CheckListItem-module__checklist-item__content___dUQrj",
  "checklist-item__content--open": "lc-CheckListItem-module__checklist-item__content--open___Gb8Bj",
  "checklist-item__content__label": "lc-CheckListItem-module__checklist-item__content__label___IECjY",
  "checklist-item__content__label--open": "lc-CheckListItem-module__checklist-item__content__label--open___bXXcm",
  "checklist-item__content__label--checked": "lc-CheckListItem-module__checklist-item__content__label--checked___v-CRg",
  "checklist-item__content__hint": "lc-CheckListItem-module__checklist-item__content__hint___zyxAI",
  "checklist-item__content__inner": "lc-CheckListItem-module__checklist-item__content__inner___T9e7f",
  "checklist-item__content__inner--open": "lc-CheckListItem-module__checklist-item__content__inner--open___hVtIm",
  "checklist-item__content__inner__description": "lc-CheckListItem-module__checklist-item__content__inner__description___oQx09",
  "checklist-item__content__inner__cta": "lc-CheckListItem-module__checklist-item__content__inner__cta___pPrxs",
  "checklist-item__chevron": "lc-CheckListItem-module__checklist-item__chevron___S9Cp1"
}, ge = "checklist-item", Pc = 3, Fc = ({
  id: e,
  isActive: a,
  isChecked: r,
  isLastElement: _,
  title: o,
  titleHint: n,
  description: i,
  onClick: c,
  cta: d
}) => {
  const l = g.useRef(null), s = g.useRef(null), [m, p] = g.useState(0), v = g.useRef(m);
  return g.useEffect(() => {
    a && l.current && l.current.focus();
  }, [a]), g.useEffect(() => {
    const h = !!window.ResizeObserver;
    if (s.current && h) {
      const b = new ResizeObserver((y) => {
        const C = y[0];
        if (!C) return;
        const N = C.contentRect.height + Pc;
        v.current !== N && (p(N), v.current = N);
      });
      return b.observe(s.current), () => b.disconnect();
    }
  }, [s]), /* @__PURE__ */ f(
    "div",
    {
      className: u(pe[ge], {
        [pe[`${ge}--active`]]: a
      }),
      children: [
        /* @__PURE__ */ f(
          "span",
          {
            className: u(pe[`${ge}__check-mark`], {
              [pe[`${ge}__check-mark--checked`]]: r
            }),
            children: [
              r && /* @__PURE__ */ t(P, { size: "small", source: xa }),
              !_ && /* @__PURE__ */ t("span", { className: pe[`${ge}__check-mark__line`] })
            ]
          }
        ),
        /* @__PURE__ */ f(
          "div",
          {
            ref: l,
            "data-testid": `checklist-item-${e}`,
            "aria-expanded": a,
            tabIndex: 0,
            onFocus: a ? void 0 : () => c(e),
            onClick: a ? void 0 : () => c(e),
            className: u(pe[`${ge}__content`], {
              [pe[`${ge}__content--open`]]: a
            }),
            children: [
              /* @__PURE__ */ f("div", { children: [
                /* @__PURE__ */ f(
                  he,
                  {
                    size: "xs",
                    className: u(pe[`${ge}__content__label`], {
                      [pe[`${ge}__content__label--open`]]: a,
                      [pe[`${ge}__content__label--checked`]]: r
                    }),
                    children: [
                      o,
                      " ",
                      n && /* @__PURE__ */ f(
                        A,
                        {
                          noMargin: !0,
                          size: "lg",
                          className: pe[`${ge}__content__hint`],
                          children: [
                            " ",
                            n
                          ]
                        }
                      )
                    ]
                  }
                ),
                /* @__PURE__ */ t(
                  "div",
                  {
                    className: u(pe[`${ge}__content__inner`], {
                      [pe[`${ge}__content__inner--open`]]: a
                    }),
                    style: { maxHeight: a ? m : 0 },
                    children: /* @__PURE__ */ f("div", { ref: s, children: [
                      /* @__PURE__ */ t(
                        A,
                        {
                          size: "lg",
                          className: pe[`${ge}__content__inner__description`],
                          children: i
                        }
                      ),
                      /* @__PURE__ */ t("div", { className: pe[`${ge}__content__inner__cta`], children: d })
                    ] })
                  }
                )
              ] }),
              !a && /* @__PURE__ */ t("div", { className: pe[`${ge}__chevron`], children: /* @__PURE__ */ t(P, { source: ir }) })
            ]
          }
        )
      ]
    }
  );
}, ee = {
  "onboarding-checklist": "lc-OnboardingChecklist-module__onboarding-checklist___98RSw",
  "onboarding-checklist--complete": "lc-OnboardingChecklist-module__onboarding-checklist--complete___Cmld9",
  "onboarding-checklist__complete": "lc-OnboardingChecklist-module__onboarding-checklist__complete___ihqN7",
  "onboarding-checklist__complete__icon": "lc-OnboardingChecklist-module__onboarding-checklist__complete__icon___LDJ-I",
  "onboarding-checklist__complete__label": "lc-OnboardingChecklist-module__onboarding-checklist__complete__label___-wqtx",
  "onboarding-checklist__complete__title": "lc-OnboardingChecklist-module__onboarding-checklist__complete__title___MvGM7",
  "onboarding-checklist__column": "lc-OnboardingChecklist-module__onboarding-checklist__column___juqpr",
  "onboarding-checklist__column--right": "lc-OnboardingChecklist-module__onboarding-checklist__column--right___9lOFL",
  "onboarding-checklist__column--right--completed": "lc-OnboardingChecklist-module__onboarding-checklist__column--right--completed___nHt44",
  "onboarding-checklist__header": "lc-OnboardingChecklist-module__onboarding-checklist__header___RB1O7",
  "onboarding-checklist__header__label": "lc-OnboardingChecklist-module__onboarding-checklist__header__label___O2yRJ",
  "onboarding-checklist__header__title": "lc-OnboardingChecklist-module__onboarding-checklist__header__title___H36qW",
  "onboarding-checklist__checklist": "lc-OnboardingChecklist-module__onboarding-checklist__checklist___0vKse",
  "onboarding-checklist__placeholder": "lc-OnboardingChecklist-module__onboarding-checklist__placeholder___JYc-z",
  "onboarding-checklist__button": "lc-OnboardingChecklist-module__onboarding-checklist__button___ZmZ2j",
  "onboarding-checklist__button__icon": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon___ta8M6",
  "onboarding-checklist__button__icon--open": "lc-OnboardingChecklist-module__onboarding-checklist__button__icon--open___Jnrn8"
}, te = "onboarding-checklist", Vs = ({
  activeItemId: e,
  completedItemsIds: a,
  title: r,
  greetingText: _,
  items: o,
  onActiveChange: n,
  placeholderClassName: i,
  isCompleted: c = !1,
  completionMessageData: d,
  className: l
}) => {
  var B;
  const [s, m] = g.useState(c), [p, v] = g.useState(!c), [h, b] = g.useState(void 0), y = g.useRef(null), C = d.height || 96, N = () => {
    v(($) => !$);
  };
  return g.useEffect(() => {
    const $ = d.delay || 1500, x = y.current;
    if (c && x) {
      const w = x.offsetHeight;
      b(w);
      const S = setTimeout(() => {
        m(!0), v(!1);
      }, $);
      return () => {
        clearTimeout(S);
      };
    }
  }, [c]), /* @__PURE__ */ f(
    "div",
    {
      ref: y,
      className: u(
        ee[te],
        {
          [ee[`${te}--complete`]]: s && !p
        },
        l
      ),
      style: {
        height: !s || p ? h : C
      },
      children: [
        p && /* @__PURE__ */ f(ne, { children: [
          /* @__PURE__ */ f("div", { className: ee[`${te}__column`], children: [
            /* @__PURE__ */ f("div", { className: ee[`${te}__header`], children: [
              _ && /* @__PURE__ */ t(
                A,
                {
                  size: "lg",
                  className: ee[`${te}__header__label`],
                  children: _
                }
              ),
              /* @__PURE__ */ t(
                he,
                {
                  size: "lg",
                  className: ee[`${te}__header__title`],
                  children: r
                }
              )
            ] }),
            /* @__PURE__ */ t("div", { className: ee[`${te}__checklist`], children: o.map(($, x) => /* @__PURE__ */ t(
              Fc,
              {
                id: $.id,
                description: $.description,
                title: $.title,
                titleHint: $.titleHint,
                isActive: $.id === e,
                isChecked: a.includes($.id),
                isLastElement: x === o.length - 1,
                onClick: n,
                cta: $.cta
              },
              x
            )) })
          ] }),
          /* @__PURE__ */ f(
            "div",
            {
              className: u(
                ee[`${te}__column`],
                ee[`${te}__column--right`],
                {
                  [ee[`${te}__column--right--completed`]]: c
                },
                i
              ),
              children: [
                !c && /* @__PURE__ */ t("div", { className: ee[`${te}__placeholder`], children: (B = o.find(($) => $.id === e)) == null ? void 0 : B.placeholder }),
                c && /* @__PURE__ */ t("div", { className: ee[`${te}__placeholder`], children: d.placeholder })
              ]
            }
          )
        ] }),
        !p && /* @__PURE__ */ t(ne, { children: /* @__PURE__ */ f("div", { className: ee[`${te}__complete`], children: [
          /* @__PURE__ */ t("div", { children: /* @__PURE__ */ t(
            P,
            {
              size: "large",
              className: ee[`${te}__complete__icon`],
              source: zr
            }
          ) }),
          /* @__PURE__ */ f("div", { children: [
            (d == null ? void 0 : d.greetingText) && /* @__PURE__ */ t(
              A,
              {
                size: "lg",
                className: ee[`${te}__complete__label`],
                children: d.greetingText
              }
            ),
            /* @__PURE__ */ t(
              he,
              {
                size: "sm",
                className: ee[`${te}__complete__title`],
                children: d.title
              }
            )
          ] })
        ] }) }),
        s && /* @__PURE__ */ t(
          j,
          {
            kind: p ? "float" : "text",
            icon: /* @__PURE__ */ t(
              P,
              {
                source: Ht,
                className: u(
                  ee[`${te}__button__icon`],
                  p && ee[`${te}__button__icon--open`]
                )
              }
            ),
            className: ee[`${te}__button`],
            onClick: N,
            "aria-expanded": p
          }
        )
      ]
    }
  );
}, Rc = "lc-Popover-module__popover___rvS3X", Mc = {
  popover: Rc
}, Ws = ({
  triggerRenderer: e,
  onClose: a,
  onOpen: r,
  children: _,
  className: o,
  triggerClassName: n,
  placement: i,
  flipOptions: c,
  offsetSize: d = 4,
  isVisible: l,
  openedOnInit: s,
  closeOnEsc: m = !0,
  useDismissHookProps: p,
  useClickHookProps: v,
  floatingStrategy: h
}) => {
  const [b, y] = g.useState(s), C = lr(), N = Ba(), B = l !== void 0, $ = B ? l : b, x = typeof _ == "string", w = typeof e == "function", S = (He, rt) => {
    He ? r == null || r(rt) : a == null || a(rt), !B && y(He);
  }, { refs: I, context: R, floatingStyles: G } = Ea({
    nodeId: N,
    open: $,
    onOpenChange: S,
    middleware: [Ia(d), sr(c), Wr()],
    placement: i,
    strategy: h,
    whileElementsMounted: Ta
  }), T = Aa(R, v), D = Da(R, k({
    escapeKey: m
  }, p)), z = Pa(R), { getReferenceProps: ie, getFloatingProps: V } = Fa([
    T,
    D,
    z
  ]), H = u(Mc.popover, o), K = /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ t(
      "div",
      E(k({
        "data-testid": "popover-trigger-button",
        ref: I.setReference
      }, ie()), {
        className: n,
        children: w ? e() : e
      })
    ),
    /* @__PURE__ */ t(ta, { id: N, children: $ && /* @__PURE__ */ t(Fr, { context: R, modal: !1, children: /* @__PURE__ */ t(
      "div",
      E(k({
        className: H,
        ref: I.setFloating,
        style: G
      }, V()), {
        children: x ? /* @__PURE__ */ t(A, { as: "div", children: _ }) : _
      })
    ) }) })
  ] });
  return C === null ? /* @__PURE__ */ t(dr, { children: K }) : K;
}, Le = {
  "outer-border": "lc-ProductTile-module__outer-border___tsyqh",
  "product-tile-wrapper": "lc-ProductTile-module__product-tile-wrapper___iKDxM",
  "product-tile-wrapper__animated": "lc-ProductTile-module__product-tile-wrapper__animated___xwIAa",
  "product-tile": "lc-ProductTile-module__product-tile___SAnnV",
  "product-tile__second-layer": "lc-ProductTile-module__product-tile__second-layer___YFtzE",
  "product-tile__third-layer": "lc-ProductTile-module__product-tile__third-layer___W0nsL",
  "product-tile__main-product": "lc-ProductTile-module__product-tile__main-product___Imdix",
  "product-tile__badge": "lc-ProductTile-module__product-tile__badge___EwFjs",
  "product-tile__badge--bordered": "lc-ProductTile-module__product-tile__badge--bordered___H08Ep",
  "product-tile__icon": "lc-ProductTile-module__product-tile__icon___IQqzd",
  "product-tile__icon--large": "lc-ProductTile-module__product-tile__icon--large___Ta9v0",
  "product-tile__icon--expired": "lc-ProductTile-module__product-tile__icon--expired___5PbNr"
}, gt = "product-tile", to = ({
  icon: e,
  iconColor: a,
  expired: r,
  backgroundColors: _,
  borderColor: o,
  notificationCount: n,
  withBorder: i = !1,
  isMainProduct: c = !1
}) => /* @__PURE__ */ t("div", { className: u({ [Le["outer-border"]]: i }), children: /* @__PURE__ */ f(
  "div",
  {
    tabIndex: c ? 0 : -1,
    className: u(Le["product-tile-wrapper"], {
      [Le["product-tile-wrapper__animated"]]: c
    }),
    children: [
      c && /* @__PURE__ */ f(ne, { children: [
        /* @__PURE__ */ t(
          "div",
          {
            className: Le[`${gt}__third-layer`],
            style: { background: _.third }
          }
        ),
        /* @__PURE__ */ t(
          "div",
          {
            className: Le[`${gt}__second-layer`],
            style: { background: _.second }
          }
        )
      ] }),
      /* @__PURE__ */ f(
        "div",
        {
          className: u(Le[gt], {
            [Le[`${gt}__main-product`]]: c
          }),
          style: {
            background: r ? "var(--surface-moderate-default)" : _.main,
            border: o ? `1px solid ${o}` : ""
          },
          children: [
            n && !r ? /* @__PURE__ */ t(
              rr,
              {
                size: "compact",
                count: n,
                className: u(Le[`${gt}__badge`], {
                  [Le[`${gt}__badge--bordered`]]: c
                })
              }
            ) : null,
            /* @__PURE__ */ t(
              P,
              {
                source: e,
                className: u(Le[`${gt}__icon`], {
                  [Le[`${gt}__icon--large`]]: c,
                  [Le[`${gt}__icon--expired`]]: r
                }),
                customColor: a
              }
            )
          ]
        }
      )
    ]
  }
) }), Ye = {
  "product-row": "lc-ProductRow-module__product-row___eDpb-",
  "product-row--expired": "lc-ProductRow-module__product-row--expired___-ttqU",
  "product-row__divider": "lc-ProductRow-module__product-row__divider___Fe--b",
  "product-row__heading": "lc-ProductRow-module__product-row__heading___xjZuH",
  "product-row__shortcut": "lc-ProductRow-module__product-row__shortcut___g3-0w",
  "product-row__name": "lc-ProductRow-module__product-row__name___qAIq-",
  "product-row__tooltip-icon": "lc-ProductRow-module__product-row__tooltip-icon___XO-IY",
  "product-row__trial-tooltip": "lc-ProductRow-module__product-row__trial-tooltip___naThN",
  "product-row__tooltip-dark-shadow": "lc-ProductRow-module__product-row__tooltip-dark-shadow___U8Tqp"
}, Xe = "product-row", Oc = ({
  product: {
    id: e,
    icon: a,
    iconColor: r,
    backgroundColors: _,
    borderColor: o,
    notificationCount: n,
    name: i,
    url: c,
    withDivider: d,
    shortcutKey: l,
    expired: s,
    trialDaysLeft: m,
    nameAdornment: p
  },
  onClick: v,
  isActive: h = !1,
  isDarkMode: b
}) => /* @__PURE__ */ f(ne, { children: [
  d && /* @__PURE__ */ t("div", { className: Ye[`${Xe}__divider`] }),
  /* @__PURE__ */ f(
    "a",
    {
      href: c,
      target: "_blank",
      "aria-label": `Go to ${i} product`,
      onClick: (y) => v(y, e),
      className: u(Ye[Xe], {
        [Ye[`${Xe}--expired`]]: s
      }),
      children: [
        /* @__PURE__ */ f("div", { className: Ye[`${Xe}__heading`], children: [
          /* @__PURE__ */ t(
            to,
            {
              icon: a,
              iconColor: r,
              expired: s,
              backgroundColors: _,
              borderColor: o,
              notificationCount: n,
              withBorder: h
            }
          ),
          /* @__PURE__ */ f(A, { as: "div", bold: !0, className: Ye[`${Xe}__name`], children: [
            i,
            s && /* @__PURE__ */ t(
              Ut,
              {
                className: u({
                  [Ye[`${Xe}__tooltip-dark-shadow`]]: b
                }),
                triggerRenderer: /* @__PURE__ */ t(
                  P,
                  {
                    source: Na,
                    className: Ye[`${Xe}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: "Your licence is expired."
              }
            ),
            typeof m != "undefined" && /* @__PURE__ */ f(
              Ut,
              {
                className: u(Ye[`${Xe}__trial-tooltip`], {
                  [Ye[`${Xe}__tooltip-dark-shadow`]]: b
                }),
                triggerRenderer: /* @__PURE__ */ t(
                  P,
                  {
                    source: Na,
                    className: Ye[`${Xe}__tooltip-icon`]
                  }
                ),
                placement: "right",
                children: [
                  m,
                  " ",
                  or(m, "day", "days"),
                  " left in your trial. Time to upgrade."
                ]
              }
            ),
            p
          ] })
        ] }),
        l && /* @__PURE__ */ f(A, { size: "sm", className: Ye[`${Xe}__shortcut`], children: [
          "⌘",
          l
        ] })
      ]
    }
  )
] }), fa = {
  "product-switcher": "lc-ProductSwitcher-module__product-switcher___Dqwcp",
  "product-switcher__content": "lc-ProductSwitcher-module__product-switcher__content___-P5yw",
  "product-switcher__footer": "lc-ProductSwitcher-module__product-switcher__footer___YRPN9",
  "product-switcher__footer-link": "lc-ProductSwitcher-module__product-switcher__footer-link___X0VOn",
  "product-switcher__tooltip": "lc-ProductSwitcher-module__product-switcher__tooltip___kcVyp"
}, ba = "product-switcher", Ks = ({
  productOptions: e,
  mainProductId: a,
  openedOnInit: r = !1,
  isVisible: _,
  isDarkMode: o = !0,
  onOpen: n,
  onClose: i,
  onSelect: c,
  textURL: d = "https://www.text.com"
}) => {
  const [l, s] = g.useState(r), [m, p] = Jt(
    !1
  ), v = lr(), h = Ba(), b = _ !== void 0, y = b ? _ : l, C = (H, K) => {
    H ? n == null || n(K) : i == null || i(K), !b && s(H);
  }, { refs: N, context: B, floatingStyles: $ } = Ea({
    nodeId: h,
    strategy: "fixed",
    placement: "right-start",
    open: y,
    onOpenChange: (H, K) => {
      p(!1), C(H, K);
    },
    middleware: [Ia({ mainAxis: 5 })],
    whileElementsMounted: Ta
  }), x = Aa(B), w = Pa(B), S = Da(B), { isMounted: I, styles: R } = Vr(B, {
    duration: 200,
    common: {
      transformOrigin: "left top"
    },
    initial: {
      opacity: 0,
      transform: "scale(0.84) translateX(-22px)"
    }
  }), { getReferenceProps: G, getFloatingProps: T } = Fa([
    x,
    S,
    w
  ]), D = e.find(
    (H) => H.id === a
  );
  if (!D)
    return null;
  const z = (H, K) => {
    K === a && H.preventDefault(), s(!1), c == null || c(K);
  }, ie = e.reduce(
    (H, K) => H + (K.notificationCount || 0),
    0
  ), V = /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ t("div", E(k({ ref: N.setReference }, G()), { children: /* @__PURE__ */ t(
      Ut,
      {
        isVisible: m,
        onOpen: () => p(!0),
        onClose: () => p(!1),
        offsetCrossAxis: 2,
        arrowOffsetY: 2,
        offsetMainAxis: 10,
        hoverOnDelay: 400,
        className: u(fa[`${ba}__tooltip`]),
        placement: "right",
        floatingStrategy: "fixed",
        kind: "invert",
        triggerRenderer: /* @__PURE__ */ t(
          to,
          {
            isMainProduct: !0,
            icon: D.icon,
            iconColor: D.iconColor,
            backgroundColors: D.backgroundColors,
            notificationCount: ie
          }
        ),
        closeOnTriggerBlur: !0,
        children: "Switch product"
      }
    ) })),
    /* @__PURE__ */ t(ta, { id: h, children: /* @__PURE__ */ t(
      "div",
      E(k({
        ref: N.setFloating,
        style: $
      }, T()), {
        children: I && /* @__PURE__ */ f(
          "div",
          {
            className: u(
              o ? "lc-dark-theme" : "lc-light-theme",
              fa[ba]
            ),
            style: R,
            children: [
              /* @__PURE__ */ t("div", { className: fa[`${ba}__content`], children: e.map((H) => /* @__PURE__ */ t(
                Oc,
                {
                  isDarkMode: o,
                  isActive: H.id === a,
                  product: H,
                  onClick: z
                },
                H.id
              )) }),
              /* @__PURE__ */ t("div", { className: fa[`${ba}__footer`], children: /* @__PURE__ */ f(
                "a",
                {
                  href: d,
                  target: "_blank",
                  className: fa[`${ba}__footer-link`],
                  onClick: () => C(!1),
                  children: [
                    /* @__PURE__ */ t(A, { noMargin: !0, children: "powered by" }),
                    /* @__PURE__ */ t(
                      P,
                      {
                        size: "xlarge",
                        source: xo,
                        customColor: "var(--content-basic-primary)"
                      }
                    )
                  ]
                }
              ) })
            ]
          }
        )
      })
    ) })
  ] });
  return v === null ? /* @__PURE__ */ t(dr, { children: V }) : V;
}, Lc = 'data:image/svg+xml,%3Csvg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"%3E%3Cg clip-path="url(%23clip0_24854_8994)"%3E%3Crect width="40" height="40" fill="%230066FF"/%3E%3Cg filter="url(%23filter0_f_24854_8994)"%3E%3Cpath d="M32.6382 31.0816C41.9891 31.0816 49.5694 23.5012 49.5694 14.1504C49.5694 4.79953 41.9891 -2.78082 32.6382 -2.78082C23.2874 -2.78082 15.707 4.79953 15.707 14.1504C15.707 23.5012 23.2874 31.0816 32.6382 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter1_f_24854_8994)"%3E%3Cpath d="M10.417 50.1292C19.7679 50.1292 27.3482 42.5488 27.3482 33.198C27.3482 23.8471 19.7679 16.2668 10.417 16.2668C1.0662 16.2668 -6.51416 23.8471 -6.51416 33.198C-6.51416 42.5488 1.0662 50.1292 10.417 50.1292Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter2_f_24854_8994)"%3E%3Cpath d="M9.35788 16.2667C15.2022 16.2667 19.9399 11.529 19.9399 5.68472C19.9399 -0.159555 15.2022 -4.89728 9.35788 -4.89728C3.5136 -4.89728 -1.22412 -0.159555 -1.22412 5.68472C-1.22412 11.529 3.5136 16.2667 9.35788 16.2667Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter3_f_24854_8994)"%3E%3Cpath d="M7.24274 18.3831C13.6714 18.3831 18.8829 13.1716 18.8829 6.74292C18.8829 0.314217 13.6714 -4.89728 7.24274 -4.89728C0.814034 -4.89728 -4.39746 0.314217 -4.39746 6.74292C-4.39746 13.1716 0.814034 18.3831 7.24274 18.3831Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter4_f_24854_8994)"%3E%3Cpath d="M8.29938 21.5577C14.7281 21.5577 19.9396 16.3462 19.9396 9.91748C19.9396 3.48878 14.7281 -1.72272 8.29938 -1.72272C1.87068 -1.72272 -3.34082 3.48878 -3.34082 9.91748C-3.34082 16.3462 1.87068 21.5577 8.29938 21.5577Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter5_f_24854_8994)"%3E%3Cpath d="M33.6973 45.8964C40.126 45.8964 45.3375 40.6849 45.3375 34.2562C45.3375 27.8275 40.126 22.616 33.6973 22.616C27.2686 22.616 22.0571 27.8275 22.0571 34.2562C22.0571 40.6849 27.2686 45.8964 33.6973 45.8964Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter6_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter7_f_24854_8994)"%3E%3Cpath d="M29.4639 48.0128C35.8926 48.0128 41.1041 42.8013 41.1041 36.3726C41.1041 29.9439 35.8926 24.7324 29.4639 24.7324C23.0352 24.7324 17.8237 29.9439 17.8237 36.3726C17.8237 42.8013 23.0352 48.0128 29.4639 48.0128Z" fill="%23FFD001"/%3E%3C/g%3E%3Cg filter="url(%23filter8_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter9_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter10_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter11_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter12_f_24854_8994)"%3E%3Cpath d="M6.18299 39.5472C11.4428 39.5472 15.7068 35.2832 15.7068 30.0234C15.7068 24.7635 11.4428 20.4996 6.18299 20.4996C0.923135 20.4996 -3.34082 24.7635 -3.34082 30.0234C-3.34082 35.2832 0.923135 39.5472 6.18299 39.5472Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter13_f_24854_8994)"%3E%3Cpath d="M9.35898 38.489C12.8655 38.489 15.7082 35.6463 15.7082 32.1398C15.7082 28.6332 12.8655 25.7906 9.35898 25.7906C5.8524 25.7906 3.00977 28.6332 3.00977 32.1398C3.00977 35.6463 5.8524 38.489 9.35898 38.489Z" fill="%2373CE3B"/%3E%3C/g%3E%3Cg filter="url(%23filter14_f_24854_8994)"%3E%3Cpath d="M38.9871 31.0816C46.5846 31.0816 52.7437 24.9225 52.7437 17.325C52.7437 9.7274 46.5846 3.56836 38.9871 3.56836C31.3895 3.56836 25.2305 9.7274 25.2305 17.325C25.2305 24.9225 31.3895 31.0816 38.9871 31.0816Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter15_f_24854_8994)"%3E%3Cpath d="M38.9879 25.7905C45.4166 25.7905 50.6281 20.579 50.6281 14.1503C50.6281 7.72157 45.4166 2.51007 38.9879 2.51007C32.5592 2.51007 27.3477 7.72157 27.3477 14.1503C27.3477 20.579 32.5592 25.7905 38.9879 25.7905Z" fill="%23FF4205"/%3E%3C/g%3E%3Cg filter="url(%23filter16_f_24854_8994)"%3E%3Cpath d="M9.35868 21.5578C14.0341 21.5578 17.8243 17.7676 17.8243 13.0922C17.8243 8.41674 14.0341 4.62656 9.35868 4.62656C4.68325 4.62656 0.893066 8.41674 0.893066 13.0922C0.893066 17.7676 4.68325 21.5578 9.35868 21.5578Z" fill="%233750FF"/%3E%3C/g%3E%3Cg filter="url(%23filter17_f_24854_8994)"%3E%3Cpath d="M31.5797 18.3831C35.0862 18.3831 37.9289 15.5404 37.9289 12.0339C37.9289 8.5273 35.0862 5.68466 31.5797 5.68466C28.0731 5.68466 25.2305 8.5273 25.2305 12.0339C25.2305 15.5404 28.0731 18.3831 31.5797 18.3831Z" fill="%23FF2E00"/%3E%3C/g%3E%3Cg filter="url(%23filter18_f_24854_8994)"%3E%3Cpath d="M12.5312 14.1503C18.3755 14.1503 23.1132 9.41257 23.1132 3.5683C23.1132 -2.27598 18.3755 -7.0137 12.5312 -7.0137C6.68694 -7.0137 1.94922 -2.27598 1.94922 3.5683C1.94922 9.41257 6.68694 14.1503 12.5312 14.1503Z" fill="%233851FF"/%3E%3C/g%3E%3Cg filter="url(%23filter19_f_24854_8994)"%3E%3Cpath d="M28.4057 13.0921C34.25 13.0921 38.9877 8.35441 38.9877 2.51013C38.9877 -3.33415 34.25 -8.07187 28.4057 -8.07187C22.5615 -8.07187 17.8237 -3.33415 17.8237 2.51013C17.8237 8.35441 22.5615 13.0921 28.4057 13.0921Z" fill="%23F3354D"/%3E%3C/g%3E%3Cg filter="url(%23filter20_f_24854_8994)"%3E%3Cpath d="M33.6958 48.0128C39.54 48.0128 44.2778 43.275 44.2778 37.4308C44.2778 31.5865 39.54 26.8488 33.6958 26.8488C27.8515 26.8488 23.1138 31.5865 23.1138 37.4308C23.1138 43.275 27.8515 48.0128 33.6958 48.0128Z" fill="%23FFD101"/%3E%3C/g%3E%3Cg filter="url(%23filter21_f_24854_8994)"%3E%3Cpath d="M8.30173 43.78C14.146 43.78 18.8837 39.0422 18.8837 33.198C18.8837 27.3537 14.146 22.616 8.30173 22.616C2.45745 22.616 -2.28027 27.3537 -2.28027 33.198C-2.28027 39.0422 2.45745 43.78 8.30173 43.78Z" fill="%237FCF35"/%3E%3C/g%3E%3Cg filter="url(%23filter22_f_24854_8994)"%3E%3Cpath d="M6.18454 34.2562C12.0288 34.2562 16.7665 29.5184 16.7665 23.6742C16.7665 17.8299 12.0288 13.0922 6.18454 13.0922C0.340261 13.0922 -4.39746 17.8299 -4.39746 23.6742C-4.39746 29.5184 0.340261 34.2562 6.18454 34.2562Z" fill="%231D7DD0"/%3E%3C/g%3E%3C/g%3E%3Cdefs%3E%3Cfilter id="filter0_f_24854_8994" x="-8.29297" y="-26.7808" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter1_f_24854_8994" x="-30.5142" y="-7.73322" width="81.8623" height="81.8624" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter2_f_24854_8994" x="-25.2241" y="-28.8973" width="69.1641" height="69.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter3_f_24854_8994" x="-28.3975" y="-28.8973" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter4_f_24854_8994" x="-27.3408" y="-25.7227" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter5_f_24854_8994" x="-1.94287" y="-1.38403" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter6_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter7_f_24854_8994" x="-6.17627" y="0.732361" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter8_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter9_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter10_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter11_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter12_f_24854_8994" x="-27.3408" y="-3.50043" width="67.0479" height="67.0476" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter13_f_24854_8994" x="-20.9902" y="1.79056" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter14_f_24854_8994" x="1.23047" y="-20.4316" width="75.5132" height="75.5132" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter15_f_24854_8994" x="3.34766" y="-21.4899" width="71.2803" height="71.2804" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter16_f_24854_8994" x="-23.1069" y="-19.3734" width="64.9312" height="64.9312" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter17_f_24854_8994" x="1.23047" y="-18.3153" width="60.6982" height="60.6984" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="12" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter18_f_24854_8994" x="-9.05078" y="-18.0137" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter19_f_24854_8994" x="6.82373" y="-19.0719" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter20_f_24854_8994" x="12.1138" y="15.8488" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter21_f_24854_8994" x="-13.2803" y="11.616" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3Cfilter id="filter22_f_24854_8994" x="-15.3975" y="2.09216" width="43.1641" height="43.164" filterUnits="userSpaceOnUse" color-interpolation-filters="sRGB"%3E%3CfeFlood flood-opacity="0" result="BackgroundImageFix"/%3E%3CfeBlend mode="normal" in="SourceGraphic" in2="BackgroundImageFix" result="shape"/%3E%3CfeGaussianBlur stdDeviation="5.5" result="effect1_foregroundBlur_24854_8994"/%3E%3C/filter%3E%3CclipPath id="clip0_24854_8994"%3E%3Crect width="40" height="40" fill="white"/%3E%3C/clipPath%3E%3C/defs%3E%3C/svg%3E%0A', Gc = [
  {
    id: "livechat",
    name: "LiveChat",
    icon: Bo,
    backgroundColors: {
      main: "var(--products-livechat)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "chatbot",
    name: "ChatBot",
    icon: Eo,
    backgroundColors: {
      main: "var(--products-chatbot)",
      second: "var(--products-livechat)",
      third: "var(--products-helpdesk)"
    },
    url: ""
  },
  {
    id: "helpdesk",
    name: "HelpDesk",
    icon: Io,
    backgroundColors: {
      main: "var(--products-helpdesk)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: "",
    expired: !0
  },
  {
    id: "knowledgebase",
    name: "KnowledgeBase",
    icon: To,
    backgroundColors: {
      main: "var(--products-knowledgebase)",
      second: "var(--products-helpdesk)",
      third: "var(--products-chatbot)"
    },
    url: "",
    trialDaysLeft: 2
  },
  {
    id: "openwidget",
    name: "OpenWidget",
    icon: Ao,
    backgroundColors: {
      main: `url('${Lc}')`,
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "teamchat",
    name: "TeamChat",
    icon: Do,
    backgroundColors: {
      main: "var(--products-hello)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    url: ""
  },
  {
    id: "accounts",
    name: "Text Accounts",
    icon: Po,
    backgroundColors: {
      main: "var(--surface-locked-white)",
      second: "var(--products-livechat)",
      third: "var(--products-chatbot)"
    },
    iconColor: "var(--content-locked-black)",
    withDivider: !0,
    url: "",
    borderColor: "var(--border-basic-secondary)"
  }
], Uc = [
  {
    clientId: "58737b5829e65621a45d598aa6f2ed8e",
    redirectUri: "https://my.labs.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "ee078090-b721-4e2b-9cf2-65e95904634c",
    redirectUri: "https://app.labs.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "9638698004690917c9b787a2e16fc007",
    redirectUri: "https://app.staging.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "40f0baca4e364c84c2d89bf3403caa31",
    redirectUri: "https://app.labs.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "de5fce27f8c77fa41e9fa621beeed111",
    redirectUri: "https://app.staging.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6193fd6d9771645e2dc6a4614c677314",
    redirectUri: "https://teamchat.labs.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "0ab5cf9b99447db22109ff70003d4507",
    redirectUri: "https://accounts.labs.livechat.com/panel",
    product: "Accounts"
  }
], Hc = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.staging.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.staging.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "6c493637185258c1a937e68886906831",
    redirectUri: "https//teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.staging.livechat.com/panel",
    product: "Accounts"
  }
], ao = [
  {
    clientId: "bb9e5b2f1ab480e4a715977b7b1b4279",
    redirectUri: "https://my.livechatinc.com",
    product: "LiveChat"
  },
  {
    clientId: "82837eac-ff5e-45ca-bce1-00011acf925c",
    redirectUri: "https://app.helpdesk.com",
    product: "HelpDesk"
  },
  {
    clientId: "92418ea187dd3c572383cbf56f015b6c",
    redirectUri: "https://app.chatbot.com/auth",
    product: "ChatBot"
  },
  {
    clientId: "8c7275c9fa6f4853e8442df1387f7fe6",
    redirectUri: "https://app.openwidget.com",
    product: "OpenWidget"
  },
  {
    clientId: "0671f59cf1c3015a511619de69373e47",
    redirectUri: "https://app.knowledgebase.ai",
    product: "KnowledgeBase"
  },
  {
    clientId: "1ebfa721f575b1346b9c76bb8f86583c",
    redirectUri: "https://teamchat.text.com/app",
    product: "TeamChat"
  },
  {
    clientId: "2fd9f1923f2233763b8637f7d10a6fe6",
    redirectUri: "https://accounts.livechat.com/panel",
    product: "Accounts"
  }
], zc = [
  "livechat",
  "chatbot",
  "helpdesk",
  "accounts"
], Qr = {
  livechat: "LiveChat",
  helpdesk: "HelpDesk",
  accounts: "Accounts",
  knowledgebase: "KnowledgeBase",
  chatbot: "ChatBot",
  openwidget: "OpenWidget",
  teamchat: "TeamChat"
}, Vc = (e, a, r, _, o) => {
  let n = "";
  o && o !== "prod" ? n += `https://accounts.${o}.livechat.com` : n += "https://accounts.livechat.com";
  const i = Xc(o, _), c = `${n}?client_id=${e}&redirect_uri=${encodeURIComponent(
    a
  )}&response_type=token&organization_id=${r}`;
  return i ? `${c}&utm_source=${i}&utm_medium=referral&utm_campaign=productswitcher` : c;
}, Wc = (e) => {
  const a = new Date(e), r = /* @__PURE__ */ new Date();
  return Jo(a) ? 0 : Yr(a, r);
}, Kc = (e, a) => zc.includes(e) || a.some(
  (r) => r.product === Qr[e]
), Yc = (e, a, r, _, o, n) => {
  var c, d, l, s, m;
  const i = a.find(
    (p) => p.product === Qr[e.id]
  );
  if (!i)
    throw new Error(`Product data for ${e.id} not found`);
  return E(k({}, e), {
    trialDaysLeft: r[e.id] && ((c = r[e.id]) == null ? void 0 : c.status) === "trial" && ((d = r[e.id]) != null && d.next_charge_at) ? Wc((s = (l = r[e.id]) == null ? void 0 : l.next_charge_at) != null ? s : "") : void 0,
    expired: ((m = r[e.id]) == null ? void 0 : m.status) === "expired",
    url: Vc(
      i.clientId,
      i.redirectUri,
      _,
      o,
      n
    )
  });
}, ro = (e) => {
  switch (e) {
    case "prod":
      return ao;
    case "staging":
      return Hc;
    case "labs":
      return Uc;
    default:
      return [];
  }
}, Xc = (e, a) => {
  const _ = ro(e).find(
    (o) => o.product === Qr[a]
  );
  return _ == null ? void 0 : _.redirectUri.replace("https://", "");
}, Ys = ({
  env: e = "prod",
  installedProducts: a,
  subscriptions: r,
  organizationId: _,
  mainProductId: o
}) => {
  if (!a || !r || !_)
    throw new Error("Missing required parameters");
  const n = e ? ro(e) : ao;
  return {
    products: Gc.reduce(
      (i, c) => (Kc(c.id, a) && i.push(
        Yc(
          c,
          n,
          r,
          _,
          o,
          e
        )
      ), i),
      []
    )
  };
}, Zc = (e) => Math.min(Math.max(e, 0), 100);
function _o(e, a = 0) {
  return e === "error" ? 0 : Zc(parseInt(a.toString(), 10));
}
const va = {
  "progress-circle": "lc-ProgressCircle-module__progress-circle___H4Abd",
  "progress-circle--small": "lc-ProgressCircle-module__progress-circle--small___BH3y7",
  "progress-circle--medium": "lc-ProgressCircle-module__progress-circle--medium___0GWFs",
  "progress-circle--large": "lc-ProgressCircle-module__progress-circle--large___AxNYV",
  "progress-circle__bg-line--normal": "lc-ProgressCircle-module__progress-circle__bg-line--normal___LYe5F",
  "progress-circle__bg-line--success": "lc-ProgressCircle-module__progress-circle__bg-line--success___51Jk6",
  "progress-circle__bg-line--error": "lc-ProgressCircle-module__progress-circle__bg-line--error___uIy7L",
  "progress-circle__indicator--normal": "lc-ProgressCircle-module__progress-circle__indicator--normal___LVjBb",
  "progress-circle__indicator--success": "lc-ProgressCircle-module__progress-circle__indicator--success___JnXe0",
  "progress-circle__indicator--error": "lc-ProgressCircle-module__progress-circle__indicator--error___HejoU"
}, qc = {
  small: 2,
  medium: 3,
  large: 4
}, jc = {
  small: 15,
  medium: 36,
  large: 56
}, ka = "progress-circle", Qc = g.forwardRef(
  (i, n) => {
    var c = i, {
      status: e = "normal",
      progressValue: a,
      className: r,
      size: _ = "medium"
    } = c, o = F(c, [
      "status",
      "progressValue",
      "className",
      "size"
    ]);
    const d = _o(e, a), l = qc[_], s = jc[_], m = u(
      va[ka],
      {
        [va[`${ka}--${_}`]]: _,
        [va[`${ka}--${e}`]]: e
      },
      r
    ), p = 2 * Math.PI * ((s - l) / 2), v = {
      strokeDasharray: p.toFixed(3),
      strokeDashoffset: `${((100 - d) / 100 * p).toFixed(3)}px`
    }, h = `${s / 2} ${s / 2} ${s} ${s}`;
    return /* @__PURE__ */ t(
      "div",
      E(k({
        className: m,
        ref: n,
        role: "progressbar"
      }, o), {
        children: /* @__PURE__ */ f("svg", { viewBox: h, children: [
          /* @__PURE__ */ t(
            "circle",
            {
              className: va[`${ka}__bg-line--${e}`],
              cx: s,
              cy: s,
              r: (s - l) / 2,
              fill: "none",
              strokeWidth: l
            }
          ),
          /* @__PURE__ */ t(
            "circle",
            {
              className: va[`${ka}__indicator--${e}`],
              style: v,
              cx: s,
              cy: s,
              r: (s - l) / 2,
              fill: "none",
              strokeWidth: l
            }
          )
        ] })
      })
    );
  }
), Qa = {
  "progress-bar": "lc-ProgressBar-module__progress-bar___ERC2D",
  "progress-bar--small": "lc-ProgressBar-module__progress-bar--small___PPhCr",
  "progress-bar--medium": "lc-ProgressBar-module__progress-bar--medium___GgSEb",
  "progress-bar--large": "lc-ProgressBar-module__progress-bar--large___Seq-t",
  "progress-bar--error": "lc-ProgressBar-module__progress-bar--error___2AR1I",
  "progress-bar--success": "lc-ProgressBar-module__progress-bar--success___-fKPU",
  "progress-bar--normal": "lc-ProgressBar-module__progress-bar--normal___WboRI",
  "progress-bar__indicator--success": "lc-ProgressBar-module__progress-bar__indicator--success___MHAlN",
  "progress-bar__indicator--normal": "lc-ProgressBar-module__progress-bar__indicator--normal___sjEAI"
}, Ja = "progress-bar", Jc = g.forwardRef(
  (i, n) => {
    var c = i, {
      status: e = "normal",
      percent: a,
      size: r = "medium",
      className: _ = ""
    } = c, o = F(c, [
      "status",
      "percent",
      "size",
      "className"
    ]);
    const d = _o(e, a), l = u(
      Qa[Ja],
      {
        [Qa[`${Ja}--${r}`]]: r,
        [Qa[`${Ja}--${e}`]]: e
      },
      _
    );
    return /* @__PURE__ */ t(
      "div",
      E(k({}, o), {
        className: l,
        ref: n,
        role: "progressbar",
        children: /* @__PURE__ */ t(
          "div",
          {
            "data-testid": "progress-bar-indicator",
            className: Qa[`${Ja}__indicator--${e}`],
            style: { width: `${d}%` }
          }
        )
      })
    );
  }
), Ze = {
  "promo-banner": "lc-PromoBanner-module__promo-banner___XA9oI",
  "promo-banner__content": "lc-PromoBanner-module__promo-banner__content___UZfyN",
  "promo-banner__wrapper": "lc-PromoBanner-module__promo-banner__wrapper___5j4E2",
  "promo-banner__header": "lc-PromoBanner-module__promo-banner__header___MWcFz",
  "promo-banner__img": "lc-PromoBanner-module__promo-banner__img___Ov2tc",
  "promo-banner__button-text": "lc-PromoBanner-module__promo-banner__button-text___bqIT8",
  "promo-banner--light": "lc-PromoBanner-module__promo-banner--light___UqDI7",
  "promo-banner__footer": "lc-PromoBanner-module__promo-banner__footer___pFki4",
  "promo-banner--small": "lc-PromoBanner-module__promo-banner--small___8dqnJ",
  "promo-banner--large": "lc-PromoBanner-module__promo-banner--large___GDbja",
  "promo-banner__close-icon": "lc-PromoBanner-module__promo-banner__close-icon___rt1kN"
}, el = 400, tl = 800, al = 500, qe = "promo-banner", Xs = ({
  className: e,
  buttonText: a,
  children: r,
  header: _,
  img: o,
  light: n = !1,
  linkText: i,
  onButtonClick: c,
  onClose: d,
  onLinkClick: l
}) => {
  const s = g.useRef(null), [m, p] = g.useState("medium"), v = u(
    Ze[qe],
    {
      [Ze[`${qe}--light`]]: n,
      [Ze[`${qe}--small`]]: m === "small",
      [Ze[`${qe}--large`]]: m === "large"
    },
    e
  );
  g.useEffect(() => {
    const b = () => s.current && s.current.offsetWidth <= el ? p("small") : s.current && s.current.offsetWidth >= tl ? p("large") : p("medium"), y = P_(
      b,
      al
    );
    return window.addEventListener("resize", y), b(), () => {
      y.cancel(), window.removeEventListener("resize", y);
    };
  }, []);
  const h = /* @__PURE__ */ f("div", { className: Ze[`${qe}__footer`], children: [
    a && /* @__PURE__ */ t(
      j,
      {
        kind: "primary",
        size: "compact",
        onClick: c,
        className: Ze[`${qe}__button-text`],
        children: a
      }
    ),
    i && /* @__PURE__ */ t(j, { size: "compact", kind: "text", onClick: l, children: i })
  ] });
  return /* @__PURE__ */ f("div", { ref: s, className: v, children: [
    /* @__PURE__ */ f("div", { className: Ze[`${qe}__content`], children: [
      o && /* @__PURE__ */ t("img", { src: o, className: Ze[`${qe}__img`] }),
      /* @__PURE__ */ f("div", { className: Ze[`${qe}__wrapper`], children: [
        /* @__PURE__ */ t("div", { className: Ze[`${qe}__header`], children: _ }),
        /* @__PURE__ */ t(A, { as: "div", children: r }),
        m !== "large" && h
      ] }),
      m === "large" && h
    ] }),
    d && /* @__PURE__ */ t(
      "button",
      {
        type: "button",
        className: Ze[`${qe}__close-icon`],
        onClick: d,
        children: /* @__PURE__ */ t(P, { source: Ue, size: "large", kind: "primary" })
      }
    )
  ] });
}, it = {
  "main-wrapper": "lc-PromoBannerV2-module__main-wrapper___6Ka0j",
  "promo-banner-v2": "lc-PromoBannerV2-module__promo-banner-v2___vkVos",
  "promo-banner-v2__content": "lc-PromoBannerV2-module__promo-banner-v2__content___16-yG",
  "promo-banner-v2__content__cta": "lc-PromoBannerV2-module__promo-banner-v2__content__cta___59Ml7",
  "promo-banner-v2__content__cta__secondary": "lc-PromoBannerV2-module__promo-banner-v2__content__cta__secondary___ka6nD",
  "promo-banner-v2__additional-content": "lc-PromoBannerV2-module__promo-banner-v2__additional-content___QsE3z",
  "promo-banner-v2__close": "lc-PromoBannerV2-module__promo-banner-v2__close___HA3Hr",
  "promo-banner-v2__close__btn": "lc-PromoBannerV2-module__promo-banner-v2__close__btn___23Qui",
  "promo-banner-v2--dark": "lc-PromoBannerV2-module__promo-banner-v2--dark___pmXpS",
  "promo-banner-v2--vertical": "lc-PromoBannerV2-module__promo-banner-v2--vertical___hXlPD"
}, ht = "promo-banner-v2", Zs = ({
  children: e,
  className: a,
  additionalContent: r,
  primaryButton: _,
  secondaryButton: o,
  vertical: n,
  contentClassName: i,
  additionalContentClassName: c,
  onClose: d,
  kind: l = "default"
}) => {
  const s = u(
    it["main-wrapper"],
    it[`${ht}--${l}`],
    l === "dark" && Dt.Dark,
    a
  );
  return /* @__PURE__ */ t("div", { role: "banner", className: s, children: /* @__PURE__ */ f(
    "div",
    {
      className: u(
        it[ht],
        n && it[`${ht}--vertical`]
      ),
      children: [
        /* @__PURE__ */ f(
          "div",
          {
            "data-testId": "content",
            className: u(it[`${ht}__content`], i),
            children: [
              e,
              (_ || o) && /* @__PURE__ */ f("div", { className: it[`${ht}__content__cta`], children: [
                _ && /* @__PURE__ */ t(
                  j,
                  E(k({}, _), {
                    kind: (_ == null ? void 0 : _.kind) || "high-contrast",
                    onClick: _.handleClick,
                    children: _.label
                  })
                ),
                o && /* @__PURE__ */ t(
                  j,
                  E(k({}, o), {
                    kind: (o == null ? void 0 : o.kind) || "text",
                    onClick: o.handleClick,
                    className: u(
                      it[`${ht}__content__cta__secondary`],
                      o.className
                    ),
                    children: o.label
                  })
                )
              ] })
            ]
          }
        ),
        r && /* @__PURE__ */ t(
          "div",
          {
            "data-testId": "additional-content",
            className: u(
              it[`${ht}__additional-content`],
              c
            ),
            children: r
          }
        ),
        d && /* @__PURE__ */ t("div", { className: it[`${ht}__close`], children: /* @__PURE__ */ t(
          j,
          {
            className: it[`${ht}__close__btn`],
            onClick: d,
            icon: /* @__PURE__ */ t(P, { source: Ue, kind: "primary" }),
            kind: "plain",
            size: "compact"
          }
        ) })
      ]
    }
  ) });
}, ft = {
  "radio-button": "lc-RadioButton-module__radio-button___PtGXj",
  "radio-button__circle": "lc-RadioButton-module__radio-button__circle___-RXEf",
  "radio-button__label": "lc-RadioButton-module__radio-button__label___WGhio",
  "radio-button__inner-circle": "lc-RadioButton-module__radio-button__inner-circle___T5nYz",
  "radio-button__text": "lc-RadioButton-module__radio-button__text___8q8cs",
  "radio-button__input": "lc-RadioButton-module__radio-button__input___nd4MZ",
  "radio-button__helper": "lc-RadioButton-module__radio-button__helper___X4Ihv",
  "radio-button--selected": "lc-RadioButton-module__radio-button--selected___00LlN",
  "radio-button--disabled": "lc-RadioButton-module__radio-button--disabled___StpOi"
}, bt = "radio-button", qs = g.forwardRef(
  (c, i) => {
    var d = c, { children: e, className: a = "", description: r, checked: _, disabled: o } = d, n = F(d, ["children", "className", "description", "checked", "disabled"]);
    const l = u(ft[bt], a, {
      [ft[`${bt}--selected`]]: _,
      [ft[`${bt}--disabled`]]: o
    });
    return /* @__PURE__ */ f("div", { className: l, children: [
      /* @__PURE__ */ f("label", { className: ft[`${bt}__label`], children: [
        /* @__PURE__ */ f("div", { className: ft[`${bt}__circle`], children: [
          /* @__PURE__ */ t("span", { className: ft[`${bt}__inner-circle`] }),
          /* @__PURE__ */ t(
            "input",
            E(k({}, n), {
              className: ft[`${bt}__input`],
              ref: i,
              type: "radio",
              checked: _,
              disabled: o
            })
          )
        ] }),
        e && /* @__PURE__ */ t(A, { as: "div", size: "md", className: ft[`${bt}__text`], children: e })
      ] }),
      r && /* @__PURE__ */ t(ur, { className: ft[`${bt}__helper`], children: r })
    ] });
  }
), Ne = {
  "search-input": "lc-SearchInput-module__search-input___3J4w9",
  "search-input--compact": "lc-SearchInput-module__search-input--compact___4hBLm",
  "search-input--medium": "lc-SearchInput-module__search-input--medium___c3OEc",
  "search-input--large": "lc-SearchInput-module__search-input--large___RcwfK",
  "search-input--focused": "lc-SearchInput-module__search-input--focused___XvA05",
  "search-input--disabled": "lc-SearchInput-module__search-input--disabled___m1suy",
  "search-input--collapsable": "lc-SearchInput-module__search-input--collapsable___LgOIB",
  "search-input--collapsable--compact": "lc-SearchInput-module__search-input--collapsable--compact___QgiH-",
  "search-input--collapsable--medium": "lc-SearchInput-module__search-input--collapsable--medium___KVwWI",
  "search-input--collapsable--large": "lc-SearchInput-module__search-input--collapsable--large___ks2s-",
  "search-input__search-icon": "lc-SearchInput-module__search-input__search-icon___KYne6",
  "search-input--collapsable--open": "lc-SearchInput-module__search-input--collapsable--open___a3kOq",
  "search-input__search-icon--compact": "lc-SearchInput-module__search-input__search-icon--compact___3imck",
  "search-input__search-icon--medium": "lc-SearchInput-module__search-input__search-icon--medium___exSsN",
  "search-input__search-icon--large": "lc-SearchInput-module__search-input__search-icon--large___qFfxH",
  "search-input__clear-icon": "lc-SearchInput-module__search-input__clear-icon___PgKgA",
  "search-input__loader": "lc-SearchInput-module__search-input__loader___9veIC",
  "search-input__input-wrapper": "lc-SearchInput-module__search-input__input-wrapper___9NT39",
  "search-input__input-wrapper--compact": "lc-SearchInput-module__search-input__input-wrapper--compact___d-GJ7",
  "search-input__input-wrapper--medium": "lc-SearchInput-module__search-input__input-wrapper--medium___VN8Dh",
  "search-input__input-wrapper--large": "lc-SearchInput-module__search-input__input-wrapper--large___ZwZ0o",
  "search-input__input-wrapper--crop": "lc-SearchInput-module__search-input__input-wrapper--crop___JA7J1"
}, Ge = "search-input", Br = `${Ge}__input-wrapper`, rl = g.forwardRef(
  (m, s) => {
    var p = m, {
      isCollapsable: e,
      isDisabled: a,
      isLoading: r,
      placeholder: _ = "Search ...",
      size: o = "medium",
      value: n,
      className: i,
      cropOnBlur: c = !0,
      onChange: d
    } = p, l = F(p, [
      "isCollapsable",
      "isDisabled",
      "isLoading",
      "placeholder",
      "size",
      "value",
      "className",
      "cropOnBlur",
      "onChange"
    ]);
    const v = g.useRef(null);
    g.useImperativeHandle(s, () => v.current, [s]);
    const [h, b] = g.useState(!0), [y, C] = g.useState(!1), N = !!n && !a && !r, B = e && !h && "true", $ = u(
      i,
      Ne[Ge],
      Ne[`${Ge}--${o}`],
      y && Ne[`${Ge}--focused`],
      a && Ne[`${Ge}--disabled`],
      e && Ne[`${Ge}--collapsable`],
      e && Ne[`${Ge}--collapsable--${o}`],
      !h && Ne[`${Ge}--collapsable--open`]
    );
    g.useEffect(() => {
      e && n && b(!1);
    }, [e, n]);
    const x = (T) => {
      const D = T.currentTarget.value;
      d(D);
    }, w = () => {
      d("");
    }, S = () => {
      v.current && v.current.focus();
    }, I = () => {
      e && b(!1), C(!0);
    }, R = () => {
      e && !n && b(!0), C(!1);
    }, G = (T) => {
      T.key === ke.enter && (T.preventDefault(), d(n));
    };
    return /* @__PURE__ */ f(
      "div",
      {
        "aria-expanded": B,
        role: "search",
        className: $,
        onClick: S,
        children: [
          /* @__PURE__ */ t(
            P,
            {
              className: u(
                Ne[`${Ge}__search-icon`],
                Ne[`${Ge}__search-icon--${o}`]
              ),
              source: Fo,
              disabled: a,
              kind: "primary"
            }
          ),
          /* @__PURE__ */ t(
            A,
            {
              as: "div",
              className: u(
                Ne[Br],
                Ne[`${Br}--${o}`],
                c && Ne[`${Br}--crop`]
              ),
              children: /* @__PURE__ */ t(
                "input",
                k({
                  role: "searchbox",
                  ref: v,
                  type: "text",
                  value: n,
                  placeholder: _,
                  onChange: x,
                  onBlur: R,
                  onFocus: I,
                  onKeyDown: G,
                  disabled: a
                }, l)
              )
            }
          ),
          N && /* @__PURE__ */ t(
            j,
            {
              "aria-label": "Clear search",
              title: "Clear search",
              className: Ne[`${Ge}__clear-icon`],
              onClick: w,
              icon: /* @__PURE__ */ t(P, { source: Ue, kind: "primary" }),
              kind: "text",
              size: "compact"
            }
          ),
          r && /* @__PURE__ */ t("div", { className: Ne[`${Ge}__loader`], children: /* @__PURE__ */ t(qr, { size: "small" }) })
        ]
      }
    );
  }
);
rl.displayName = "SearchInput";
const _l = "lc-Skeleton-module__loading___fc1WK", Lt = {
  "skeleton-wrapper": "lc-Skeleton-module__skeleton-wrapper___5N-1n",
  "skeleton-wrapper--vertical": "lc-Skeleton-module__skeleton-wrapper--vertical___0sU7e",
  "skeleton-avatar": "lc-Skeleton-module__skeleton-avatar___7-CDQ",
  "skeleton-avatar--square": "lc-Skeleton-module__skeleton-avatar--square___NlK0K",
  "skeleton-avatar--animated": "lc-Skeleton-module__skeleton-avatar--animated___iFXkb",
  loading: _l,
  "skeleton-text": "lc-Skeleton-module__skeleton-text___WnwUw",
  "skeleton-text--animated": "lc-Skeleton-module__skeleton-text--animated___Bnr3Z"
}, B_ = "skeleton-wrapper", js = (o) => {
  var n = o, { children: e, vertical: a, animated: r } = n, _ = F(n, ["children", "vertical", "animated"]);
  const i = g.Children.map(e, (c) => g.isValidElement(c) ? g.cloneElement(c, {
    animated: r
  }) : c);
  return /* @__PURE__ */ t(
    "div",
    E(k({
      className: u(Lt[`${B_}`], {
        [Lt[`${B_}--vertical`]]: a
      })
    }, _), {
      children: i
    })
  );
}, Er = "skeleton-avatar", Qs = ({
  square: e = !1,
  size: a = 16,
  animated: r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(Lt[`${Er}`], {
      [Lt[`${Er}--square`]]: e,
      [Lt[`${Er}--animated`]]: r
    }),
    style: {
      width: a,
      height: a
    }
  }
), E_ = "skeleton-text", Js = ({
  height: e = 13,
  width: a,
  animated: r
}) => /* @__PURE__ */ t(
  "div",
  {
    className: u(Lt[`${E_}`], {
      [Lt[`${E_}--animated`]]: r
    }),
    style: {
      height: e,
      width: a
    }
  }
), Ir = {
  "status-badge": "lc-StatusBadge-module__status-badge___lygXF",
  "status-badge--3XS": "lc-StatusBadge-module__status-badge--3XS___A-lDu",
  "status-badge--2XS": "lc-StatusBadge-module__status-badge--2XS___7u4kB",
  "status-badge--XS": "lc-StatusBadge-module__status-badge--XS___M5fdN",
  "status-badge--SM": "lc-StatusBadge-module__status-badge--SM___How9K",
  "status-badge--MD": "lc-StatusBadge-module__status-badge--MD___tlaxX",
  "status-badge--LG": "lc-StatusBadge-module__status-badge--LG___2-7IC",
  "status-badge--XL": "lc-StatusBadge-module__status-badge--XL___m-MzF",
  "status-badge--2XL": "lc-StatusBadge-module__status-badge--2XL___lSyzS",
  "status-badge--3XL": "lc-StatusBadge-module__status-badge--3XL___LpjBZ",
  "status-badge--offline": "lc-StatusBadge-module__status-badge--offline___90IJN",
  "status-badge--accept": "lc-StatusBadge-module__status-badge--accept___UvRWg",
  "status-badge--not-accept": "lc-StatusBadge-module__status-badge--not-accept___bhNkL"
}, Tr = "status-badge", ed = (o) => {
  var n = o, {
    className: e,
    kind: a = "offline",
    size: r = "MD"
  } = n, _ = F(n, [
    "className",
    "kind",
    "size"
  ]);
  const i = u(
    Ir[Tr],
    Ir[`${Tr}--${a}`],
    Ir[`${Tr}--${r}`],
    e
  );
  return /* @__PURE__ */ t("span", k({ className: i }, _));
}, ol = "lc-Switch-module__switch__input___-bYMW", nl = "lc-Switch-module__switch__container___dYb8a", il = "lc-Switch-module__switch__track___3lNXx", cl = "lc-Switch-module__switch__slider___NmDHK", ll = "lc-Switch-module__switch__loader___Pbo1Q", sl = "lc-Switch-module__switch__icon___tCZTq", ce = {
  switch: "lc-Switch-module__switch___PKzsW",
  "switch__track--enabled": "lc-Switch-module__switch__track--enabled___Dwbmx",
  "switch__track--on": "lc-Switch-module__switch__track--on___7vdEj",
  "switch__track--off": "lc-Switch-module__switch__track--off___IAZA0",
  "switch--large": "lc-Switch-module__switch--large___dMF98",
  "switch--compact": "lc-Switch-module__switch--compact___T4bhh",
  "switch--medium": "lc-Switch-module__switch--medium___uruMu",
  "switch--focused": "lc-Switch-module__switch--focused___XADLL",
  switch__input: ol,
  "switch__input--disabled": "lc-Switch-module__switch__input--disabled___c1vVD",
  switch__container: nl,
  switch__track: il,
  "switch__container--focused": "lc-Switch-module__switch__container--focused___120ao",
  "switch__track--disabled": "lc-Switch-module__switch__track--disabled___pz3md",
  switch__slider: cl,
  "switch__slider--large": "lc-Switch-module__switch__slider--large___0-Vky",
  "switch__slider--large--on": "lc-Switch-module__switch__slider--large--on___HXudz",
  "switch__slider--large--off": "lc-Switch-module__switch__slider--large--off___zPuP6",
  "switch__slider--compact": "lc-Switch-module__switch__slider--compact___GD-ov",
  "switch__slider--compact--on": "lc-Switch-module__switch__slider--compact--on___VhXTF",
  "switch__slider--compact--off": "lc-Switch-module__switch__slider--compact--off___a0WyG",
  "switch__slider--medium": "lc-Switch-module__switch__slider--medium___j3xMd",
  "switch__slider--medium--on": "lc-Switch-module__switch__slider--medium--on___WNNGh",
  "switch__slider--medium--off": "lc-Switch-module__switch__slider--medium--off___pkbCl",
  "switch__slider--disabled": "lc-Switch-module__switch__slider--disabled___6rrSU",
  switch__loader: ll,
  "switch__loader--compact": "lc-Switch-module__switch__loader--compact___jKLak",
  "switch__loader--medium": "lc-Switch-module__switch__loader--medium___XpfaO",
  "switch__loader--large": "lc-Switch-module__switch__loader--large___NDgeg",
  switch__icon: sl
}, oe = "switch", td = (m) => {
  var p = m, {
    className: e = "",
    defaultOn: a = !1,
    disabled: r = !1,
    name: _ = oe,
    on: o,
    onChange: n,
    size: i = "large",
    state: c = "regular",
    innerRef: d,
    ariaLabel: l
  } = p, s = F(p, [
    "className",
    "defaultOn",
    "disabled",
    "name",
    "on",
    "onChange",
    "size",
    "state",
    "innerRef",
    "ariaLabel"
  ]);
  const v = o !== void 0, [h, b] = g.useState(
    () => v ? o : a
  ), [y, C] = g.useState(!1), N = v ? o : h, B = c === "loading", $ = c === "locked", x = i === "large" ? "small" : "xsmall", w = N ? "on" : "off", S = r || B || $, I = S ? "disabled" : "enabled", R = u(
    ce[oe],
    ce[`${oe}--${i}`],
    {
      [ce[`${oe}--focused`]]: y
    },
    e
  ), G = (T) => {
    n == null || n(T, !N), v || (T.stopPropagation(), b((D) => !D));
  };
  return /* @__PURE__ */ f("span", { className: R, children: [
    /* @__PURE__ */ t(
      "input",
      E(k({
        type: "checkbox",
        className: u(
          ce[`${oe}__input`],
          ce[`${oe}__input--${I}`]
        ),
        onChange: G,
        checked: N,
        name: _,
        ref: d,
        disabled: S,
        "aria-label": l
      }, s), {
        onFocus: () => C(!0),
        onBlur: () => C(!1)
      })
    ),
    /* @__PURE__ */ f(
      "span",
      {
        className: u(ce[`${oe}__container`], {
          [ce[`${oe}__container--focused`]]: y
        }),
        children: [
          /* @__PURE__ */ t(
            "span",
            {
              className: u(
                ce[`${oe}__track`],
                ce[`${oe}__track--${w}`],
                ce[`${oe}__track--${I}`]
              )
            }
          ),
          /* @__PURE__ */ f(
            "span",
            {
              className: u(
                ce[`${oe}__slider`],
                ce[`${oe}__slider--${I}`],
                ce[`${oe}__slider--${i}`],
                ce[`${oe}__slider--${i}--${w}`]
              ),
              children: [
                B && /* @__PURE__ */ t(
                  qr,
                  {
                    "data-testid": "switch-loader",
                    className: u(
                      ce[`${oe}__loader`],
                      ce[`${oe}__loader--${i}`]
                    )
                  }
                ),
                $ && /* @__PURE__ */ t(
                  P,
                  {
                    className: ce[`${oe}__icon`],
                    "data-testid": "lock-icon",
                    size: x,
                    source: Ro,
                    kind: "primary"
                  }
                )
              ]
            }
          )
        ]
      }
    )
  ] });
}, dl = "lc-Tab-module__tab___ShyYn", ul = "lc-Tab-module__tab__count___7QKoz", ml = "lc-Tab-module__tab__icon___eCD-d", pl = "lc-Tab-module__tab__badge___nwfVJ", Mt = {
  tab: dl,
  tab__count: ul,
  "tab--compact": "lc-Tab-module__tab--compact___yetP5",
  "tab--medium": "lc-Tab-module__tab--medium___KhPsI",
  "tab--large": "lc-Tab-module__tab--large___3GE8k",
  tab__icon: ml,
  tab__badge: pl,
  "tab--selected": "lc-Tab-module__tab--selected___vsPhT",
  "tab--disabled": "lc-Tab-module__tab--disabled___JPMHC"
}, Ot = "tab", ad = (d) => {
  var l = d, {
    children: e,
    className: a,
    count: r,
    isSelected: _,
    asBadge: o,
    size: n = "medium",
    icon: i
  } = l, c = F(l, [
    "children",
    "className",
    "count",
    "isSelected",
    "asBadge",
    "size",
    "icon"
  ]);
  const { disabled: s } = c, m = r !== void 0 && !o, p = r !== void 0 && o;
  return /* @__PURE__ */ f(
    A,
    E(k({}, c), {
      as: c.href ? "a" : "button",
      "aria-selected": _,
      size: "md",
      bold: _,
      className: u(
        a,
        Mt[Ot],
        Mt[`${Ot}--${n}`],
        _ && Mt[`${Ot}--selected`],
        s && Mt[`${Ot}--disabled`]
      ),
      children: [
        i && /* @__PURE__ */ t("div", { "data-testId": "icon", className: Mt[`${Ot}__icon`], children: i }),
        e,
        m && /* @__PURE__ */ f(A, { as: "span", size: "md", className: Mt[`${Ot}__count`], children: [
          "(",
          r,
          ")"
        ] }),
        p && /* @__PURE__ */ t(
          rr,
          {
            "data-testid": "tab-badge",
            count: r,
            size: "compact",
            className: Mt[`${Ot}__badge`]
          }
        )
      ]
    })
  );
}, gl = "lc-TabsWrapper-module__tabs___rJby-", hl = "lc-TabsWrapper-module__tabs__list___ylJuP", oo = {
  tabs: gl,
  tabs__list: hl
}, no = "tabs", rd = ({ className: e, children: a }) => /* @__PURE__ */ t("div", { className: u(oo[no], e), children: a }), _d = ({ className: e, children: a }) => /* @__PURE__ */ t("div", { role: "tablist", className: u(oo[`${no}__list`], e), children: a }), Ca = {
  "tag-input": "lc-TagInput-module__tag-input___zQKuG",
  "tag-input--error": "lc-TagInput-module__tag-input--error___0iuR-",
  "tag-input__input": "lc-TagInput-module__tag-input__input___skuNT",
  "tag-input__input--medium": "lc-TagInput-module__tag-input__input--medium___9ifYO",
  "tag-input__input--large": "lc-TagInput-module__tag-input__input--large___0xBUb",
  "tag-input__tag__content": "lc-TagInput-module__tag-input__tag__content___glcu0"
}, fl = ({
  className: e = "",
  innerEditableRef: a,
  inputRef: r,
  change: _,
  remove: o,
  value: n
}) => {
  const [i, c] = g.useState(!1), d = () => a.current, l = () => {
    const h = d();
    return h ? h.innerText : "";
  }, s = () => {
    r && r.current && r.current.focus();
  };
  return /* @__PURE__ */ t(
    "div",
    {
      ref: a,
      className: e,
      contentEditable: !0,
      onPaste: (h) => {
        h.preventDefault();
        const b = h.clipboardData.getData("text/plain");
        document.execCommand("insertHTML", !1, r_(b));
      },
      onBlur: () => {
        const h = d();
        if (!(i || !h)) {
          if (h.innerText === "") {
            o();
            return;
          }
          _(h.innerText);
        }
      },
      onKeyDown: (h) => {
        if (h.key === ke.enter) {
          h.preventDefault(), s();
          return;
        }
        h.key === ke.backspace && l() === "" && (c(!0), o(), s());
      },
      dangerouslySetInnerHTML: { __html: r_(n) }
    }
  );
}, bl = "tag-input__tag", I_ = ({
  children: e,
  index: a,
  remove: r,
  validator: _,
  inputRef: o,
  update: n,
  size: i,
  tagProps: c
}) => {
  const d = g.useMemo(() => _ !== void 0 ? _(e) : !0, [e, _]), l = g.useRef(null), s = () => r(a), m = () => d ? c ? c.kind : "default" : "error";
  return /* @__PURE__ */ t(Z_, E(k({ size: i }, c), { kind: m(), onRemove: s, children: /* @__PURE__ */ t(
    fl,
    {
      value: e,
      inputRef: o,
      innerEditableRef: l,
      className: Ca[`${bl}__content`],
      change: (p) => n(a, p),
      remove: s,
      validator: _
    }
  ) }));
}, er = "tag-input", vl = [
  ke.enter,
  ke.spacebar,
  ke.tab,
  ke.semicolon,
  ke.comma
], kl = [ke.backspace, ke.delete], yl = (p) => {
  var v = p, {
    id: e,
    tags: a,
    onChange: r,
    validator: _,
    error: o,
    placeholder: n,
    size: i = "medium",
    className: c,
    inputClassName: d,
    onBlur: l,
    addOnBlur: s = !0
  } = v, m = F(v, [
    "id",
    "tags",
    "onChange",
    "validator",
    "error",
    "placeholder",
    "size",
    "className",
    "inputClassName",
    "onBlur",
    "addOnBlur"
  ]);
  const h = u(
    Ca[er],
    {
      [Ca[`${er}--error`]]: o
    },
    c
  ), b = u(
    d,
    Ca[`${er}__input`],
    Ca[`${er}__input--${i}`]
  ), [y, C] = g.useState(""), N = g.useRef(null), B = (T) => {
    T.trim() !== "" && (r([...a || [], T]), C(""));
  }, $ = (T) => {
    const D = [...a || []];
    D.splice(T, 1), r(D);
  }, x = (T) => C(T.target.value), w = (T) => {
    if (vl.includes(T.key)) {
      if (T.preventDefault(), y === "")
        return;
      B(y);
    } else if (kl.includes(T.key)) {
      if (y !== "" || !(a != null && a.length))
        return;
      $(a.length - 1);
    }
  }, S = (T) => {
    s && B(y), l == null || l(T);
  }, I = (T, D) => {
    const z = [...a || []];
    z.reduce(
      (V, H, K) => V + (H === D && K !== T ? 1 : 0),
      0
    ) > 0 ? z.splice(T, 1) : z[T] = D, r(z);
  }, R = (T) => {
    T.preventDefault();
    const z = T.clipboardData.getData("text/plain").split(/[\s,;\n]+/);
    r([...a || [], ...z]);
  }, G = (T, D) => typeof T == "string" ? /* @__PURE__ */ t(
    I_,
    {
      index: D,
      update: I,
      remove: $,
      inputRef: N,
      validator: _,
      size: i,
      children: T
    },
    `${D}${T}`
  ) : /* @__PURE__ */ t(
    I_,
    {
      index: D,
      update: I,
      remove: $,
      inputRef: N,
      validator: _,
      size: i,
      tagProps: T,
      children: T.value || T.children
    },
    `${D}${T.children}`
  );
  return /* @__PURE__ */ f(ne, { children: [
    /* @__PURE__ */ f(A, { as: "div", className: h, children: [
      a == null ? void 0 : a.map(G),
      /* @__PURE__ */ t(
        "input",
        E(k({}, m), {
          id: e,
          ref: N,
          className: b,
          placeholder: n,
          value: y,
          onChange: x,
          onKeyDown: w,
          onPaste: R,
          onBlur: S
        })
      )
    ] }),
    o && /* @__PURE__ */ t(jr, { children: o })
  ] });
}, wl = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)])$/i, Cl = "name@company.com", $l = (e) => wl.test(e), od = (r) => {
  var _ = r, {
    placeholder: e = Cl
  } = _, a = F(_, [
    "placeholder"
  ]);
  return /* @__PURE__ */ t(yl, E(k({}, a), { placeholder: e, validator: $l }));
}, Nl = "lc-Toast-module__toast___ngbBR", Sl = "lc-Toast-module__toast__content___XGt2m", xl = "lc-Toast-module__toast__actions___iFshW", Bl = "lc-Toast-module__toast__actions__button___sQIbQ", le = {
  toast: Nl,
  toast__content: Sl,
  toast__actions: xl,
  toast__actions__button: Bl,
  "toast__actions__button--success": "lc-Toast-module__toast__actions__button--success___p53MR",
  "toast__actions__button--warning": "lc-Toast-module__toast__actions__button--warning___fCMO5",
  "toast__actions__button--error": "lc-Toast-module__toast__actions__button--error___hct1w",
  "toast__actions__button--info": "lc-Toast-module__toast__actions__button--info___KLzoG",
  "toast__actions--custom": "lc-Toast-module__toast__actions--custom___Lao00",
  "toast--success": "lc-Toast-module__toast--success___AcCed",
  "toast--warning": "lc-Toast-module__toast--warning___RsGqU",
  "toast--error": "lc-Toast-module__toast--error___a7RTS",
  "toast--info": "lc-Toast-module__toast--info___9t8Za",
  "toast-wrapper": "lc-Toast-module__toast-wrapper___jVb0j",
  "toast-wrapper--fixed": "lc-Toast-module__toast-wrapper--fixed___Wo3QO",
  "toast-wrapper--block": "lc-Toast-module__toast-wrapper--block___LNWD0",
  "toast-wrapper--horizontal-center": "lc-Toast-module__toast-wrapper--horizontal-center___yR1at",
  "toast-wrapper--horizontal-left": "lc-Toast-module__toast-wrapper--horizontal-left___CY-Z-",
  "toast-wrapper--horizontal-right": "lc-Toast-module__toast-wrapper--horizontal-right___f7ts5",
  "toast-wrapper--vertical-top": "lc-Toast-module__toast-wrapper--vertical-top___-8YHw",
  "toast-appear--slide": "lc-Toast-module__toast-appear--slide___vNvCV",
  "toast-appear-active--slide": "lc-Toast-module__toast-appear-active--slide___ROIEb",
  "toast-exit--slide": "lc-Toast-module__toast-exit--slide___DVOQp",
  "toast-exit-active--slide": "lc-Toast-module__toast-exit-active--slide___rBWPS",
  "toast-wrapper--vertical-bottom": "lc-Toast-module__toast-wrapper--vertical-bottom___rihzw",
  "toast-appear--fade": "lc-Toast-module__toast-appear--fade___AcODR",
  "toast-appear-active--fade": "lc-Toast-module__toast-appear-active--fade___Z39eu",
  "toast-exit--fade": "lc-Toast-module__toast-exit--fade___1t0Qp",
  "toast-exit-active--fade": "lc-Toast-module__toast-exit-active--fade___UK5Kw"
}, El = {
  success: {
    source: zr
  },
  warning: {
    source: T_
  },
  error: {
    source: A_
  },
  info: {
    source: Na
  }
}, At = "toast", Il = (c) => {
  var d = c, {
    action: e,
    className: a,
    children: r,
    removable: _,
    kind: o = "info",
    onClose: n
  } = d, i = F(d, [
    "action",
    "className",
    "children",
    "removable",
    "kind",
    "onClose"
  ]);
  const l = u(
    le[At],
    le[`${At}--${o}`],
    a
  ), s = typeof r == "string", m = (p) => p && p.closesOnClick && n ? (p.onClick(), n()) : p.onClick();
  return /* @__PURE__ */ f("div", E(k({ className: l }, i), { children: [
    /* @__PURE__ */ t("div", { className: le[`${At}__icon`], children: /* @__PURE__ */ t(P, E(k({}, El[o]), { size: "medium" })) }),
    /* @__PURE__ */ t("div", { className: le[`${At}__content`], children: s ? /* @__PURE__ */ t(A, { as: "div", children: r }) : r }),
    (e || _) && /* @__PURE__ */ f("div", { className: le[`${At}__actions`], children: [
      e && /* @__PURE__ */ t(
        j,
        {
          className: le[`${At}__actions--custom`],
          kind: "text",
          size: "compact",
          onClick: () => m(e),
          children: e.label
        }
      ),
      _ && /* @__PURE__ */ t(
        "button",
        {
          className: u(
            le[`${At}__actions__button`],
            le[`${At}__actions__button--${o}`]
          ),
          "aria-label": "Close toast",
          onClick: n,
          children: /* @__PURE__ */ t(P, { source: Ue, size: "medium" })
        }
      )
    ] })
  ] }));
}, Tl = 200, ya = "toast-wrapper", nd = ({
  className: e,
  toasts: a = [],
  fixed: r = !0,
  block: _ = !1,
  animationType: o = "slide",
  verticalPosition: n = "top",
  horizontalPosition: i = "center"
}) => {
  const c = u(
    le[ya],
    {
      [le[`${ya}--fixed`]]: r,
      [le[`${ya}--block`]]: !r && _,
      [le[`${ya}--horizontal-${i}`]]: i,
      [le[`${ya}--vertical-${n}`]]: n
    },
    e
  );
  return /* @__PURE__ */ t("div", { className: c, children: /* @__PURE__ */ t(F_, { component: null, children: a.map(({ id: d, kind: l, content: s, removable: m, action: p, onClose: v }) => /* @__PURE__ */ t(
    R_,
    {
      classNames: {
        enter: le[`toast-appear--${o}`],
        enterActive: le[`toast-appear-active--${o}`],
        exit: le[`toast-exit--${o}`],
        exitActive: le[`toast-exit-active--${o}`]
      },
      timeout: Tl,
      children: /* @__PURE__ */ t(
        Il,
        {
          kind: l,
          onClose: v,
          removable: m,
          action: p,
          children: s
        }
      )
    },
    d
  )) }) });
}, Al = "lc-Textarea-module__textarea___yE6jp", tr = {
  textarea: Al,
  "textarea--focused": "lc-Textarea-module__textarea--focused___YnB5S",
  "textarea--disabled": "lc-Textarea-module__textarea--disabled___zZJAq",
  "textarea--error": "lc-Textarea-module__textarea--error___n-fD5"
}, ar = "textarea", id = g.forwardRef(
  (o, _) => {
    var n = o, { className: e, error: a } = n, r = F(n, ["className", "error"]);
    const { disabled: i, onBlur: c, onFocus: d } = r, [l, s] = g.useState(!1), m = u(e, tr[ar], {
      [tr[`${ar}--disabled`]]: i,
      [tr[`${ar}--focused`]]: l,
      [tr[`${ar}--error`]]: a
    }), p = (h) => {
      s(!1), c == null || c(h);
    }, v = (h) => {
      s(!0), d == null || d(h);
    };
    return /* @__PURE__ */ t(A, { as: "div", className: m, children: /* @__PURE__ */ t(
      "textarea",
      E(k({}, r), {
        ref: _,
        onFocus: v,
        onBlur: p
      })
    ) });
  }
), Dl = {
  "update-badge": "lc-UpdateBadge-module__update-badge___heZyU"
}, Pl = "update-badge", cd = () => /* @__PURE__ */ t("span", { className: Dl[Pl] }), Ar = {
  "file-upload-progress-actions": "lc-FileUploadProgressActions-module__file-upload-progress-actions___XINkF",
  "file-upload-progress-actions__close-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__close-button___BHRcO",
  "file-upload-progress-actions__retry-button": "lc-FileUploadProgressActions-module__file-upload-progress-actions__retry-button___2Xd72"
}, Dr = "file-upload-progress-actions", Ur = ({ status: e, onCloseButtonClick: a, onRetryButtonClick: r }) => /* @__PURE__ */ f("div", { className: Ar[`${Dr}`], children: [
  r && e === "error" && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: Ar[`${Dr}__retry-button`],
      "aria-label": "Retry",
      onClick: r,
      children: /* @__PURE__ */ t(P, { size: "small", source: Mo })
    }
  ),
  a && e !== "success" && /* @__PURE__ */ t(
    "button",
    {
      type: "button",
      className: Ar[`${Dr}__close-button`],
      "aria-label": "Close",
      onClick: a,
      children: /* @__PURE__ */ t(P, { size: "small", source: Ue })
    }
  )
] }), je = {
  "file-upload-progress": "lc-FileUploadProgress-module__file-upload-progress___cAUbT",
  "file-upload-progress__icon": "lc-FileUploadProgress-module__file-upload-progress__icon___ZCOg9",
  "file-upload-progress__icon--success": "lc-FileUploadProgress-module__file-upload-progress__icon--success___mQkAS",
  "file-upload-progress__wrapper": "lc-FileUploadProgress-module__file-upload-progress__wrapper___Hrlp6",
  "file-upload-progress__wrapper--with-icon": "lc-FileUploadProgress-module__file-upload-progress__wrapper--with-icon___t56aA",
  "file-upload-progress__wrapper__header": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header___DKuHl",
  "file-upload-progress__wrapper__header__actions": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__actions___AM74G",
  "file-upload-progress__wrapper__header__title": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title___EYxE3",
  "file-upload-progress__wrapper__header__title--success": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--success___P0XSe",
  "file-upload-progress__wrapper__header__title--error": "lc-FileUploadProgress-module__file-upload-progress__wrapper__header__title--error___la8oa"
}, vt = "file-upload-progress", Pr = `${vt}__wrapper__header__title`, Fl = g.forwardRef(
  ({
    actionsVisibility: e = "hidden",
    className: a,
    icon: r,
    title: _,
    progressValue: o,
    size: n,
    status: i = "normal",
    onCloseButtonClick: c,
    onRetryButtonClick: d
  }, l) => /* @__PURE__ */ f("div", { className: je[vt], ref: l, children: [
    r && i !== "success" && /* @__PURE__ */ t("div", { className: je[`${vt}__icon`], children: r }),
    i === "success" && /* @__PURE__ */ t(
      "div",
      {
        className: u(
          je[`${vt}__icon`],
          je[`${vt}__icon--success`]
        ),
        children: /* @__PURE__ */ t(P, { source: xa })
      }
    ),
    /* @__PURE__ */ f(
      "div",
      {
        className: u(je[`${vt}__wrapper`], {
          [je[`${vt}__wrapper--with-icon`]]: r
        }),
        children: [
          /* @__PURE__ */ f("div", { className: je[`${vt}__wrapper__header`], children: [
            _ && /* @__PURE__ */ t(
              "div",
              {
                className: u(je[Pr], {
                  [je[`${Pr}--success`]]: i === "success",
                  [je[`${Pr}--error`]]: i === "error"
                }),
                children: /* @__PURE__ */ t(A, { size: "sm", as: "div", children: _ })
              }
            ),
            e !== "hidden" && /* @__PURE__ */ t(
              "div",
              {
                className: u({
                  [je[`${vt}__wrapper__header__actions`]]: e === "hover"
                }),
                children: /* @__PURE__ */ t(
                  Ur,
                  {
                    status: i,
                    onCloseButtonClick: c,
                    onRetryButtonClick: d
                  }
                )
              }
            )
          ] }),
          i !== "success" && /* @__PURE__ */ t(
            Jc,
            {
              className: a,
              percent: o,
              status: i,
              size: n
            }
          )
        ]
      }
    )
  ] })
), q = {
  "upload-bar": "lc-UploadBar-module__upload-bar___0ZOP3",
  "upload-bar__loader-test": "lc-UploadBar-module__upload-bar__loader-test___4QKID",
  "upload-bar--error": "lc-UploadBar-module__upload-bar--error___83It3",
  "upload-bar__wrapper": "lc-UploadBar-module__upload-bar__wrapper___vk3pI",
  "upload-bar__wrapper__header": "lc-UploadBar-module__upload-bar__wrapper__header___3z6fH",
  "upload-bar__wrapper__header__icon": "lc-UploadBar-module__upload-bar__wrapper__header__icon___97HQo",
  "upload-bar__wrapper__header__title": "lc-UploadBar-module__upload-bar__wrapper__header__title___CqykW",
  "upload-bar__wrapper__header__collapse-button": "lc-UploadBar-module__upload-bar__wrapper__header__collapse-button___9n0O7",
  "upload-bar__wrapper__header__actions-container": "lc-UploadBar-module__upload-bar__wrapper__header__actions-container___80EgZ",
  "upload-bar__wrapper__header__success-icon": "lc-UploadBar-module__upload-bar__wrapper__header__success-icon___eau3A",
  "upload-bar__wrapper__header__error-icon": "lc-UploadBar-module__upload-bar__wrapper__header__error-icon___VZLl2",
  "upload-bar__wrapper__header__loader": "lc-UploadBar-module__upload-bar__wrapper__header__loader___h0F6t",
  "upload-bar__files": "lc-UploadBar-module__upload-bar__files___jMFT-",
  "upload-bar__files--enter": "lc-UploadBar-module__upload-bar__files--enter___BNcoJ",
  "upload-bar__files--enter-active": "lc-UploadBar-module__upload-bar__files--enter-active___yj9Mq",
  "upload-bar__files--exit": "lc-UploadBar-module__upload-bar__files--exit___iEuiQ",
  "upload-bar__files--exit-active": "lc-UploadBar-module__upload-bar__files--exit-active___mz8u3",
  "upload-bar__files--exit-done": "lc-UploadBar-module__upload-bar__files--exit-done___-N5nJ",
  "upload-bar__files-wrapper": "lc-UploadBar-module__upload-bar__files-wrapper___C3au9",
  "upload-bar__files__list": "lc-UploadBar-module__upload-bar__files__list___95G7b"
}, Se = "upload-bar", wt = `${Se}__wrapper__header`, Rl = 300, Ml = (e, a) => e === "success" ? /* @__PURE__ */ t(
  "div",
  {
    "data-testid": "success-icon",
    className: q[`${wt}__success-icon`],
    children: /* @__PURE__ */ t(P, { source: xa })
  }
) : e === "error" ? /* @__PURE__ */ t(
  "div",
  {
    "data-testid": "error-icon",
    className: q[`${wt}__error-icon`],
    children: /* @__PURE__ */ t(P, { source: Oo })
  }
) : /* @__PURE__ */ t(
  Qc,
  {
    className: q[`${wt}__loader`],
    status: e,
    progressValue: a
  }
), ld = ({
  children: e,
  className: a,
  progressValue: r,
  title: _,
  isExpanded: o,
  errorMessage: n,
  status: i = "normal",
  icon: c,
  size: d,
  mode: l = "multiple",
  onCloseButtonClick: s,
  onRetryButtonClick: m
}) => {
  const [p, v] = g.useState(o || !1), h = i === "error", b = i === "success", y = u(q[Se], a, {
    [q[`${Se}--error`]]: h,
    [q[`${Se}--success`]]: b
  }), C = !(h && (m || s)), N = () => v(!p);
  return l === "single" ? /* @__PURE__ */ t("div", { className: y, children: /* @__PURE__ */ f("div", { className: q[`${Se}__wrapper`], children: [
    /* @__PURE__ */ t("div", { className: q[`${wt}`], children: /* @__PURE__ */ t(
      Fl,
      {
        title: h && n || _,
        progressValue: r,
        status: i,
        icon: c,
        size: d
      }
    ) }),
    i === "error" && /* @__PURE__ */ t(
      Ur,
      {
        status: i,
        onCloseButtonClick: s,
        onRetryButtonClick: m
      }
    )
  ] }) }) : /* @__PURE__ */ f("div", { className: y, children: [
    /* @__PURE__ */ t(
      "div",
      {
        className: q[`${Se}__wrapper`],
        onClick: N,
        children: /* @__PURE__ */ f("div", { className: q[`${wt}`], children: [
          /* @__PURE__ */ t("div", { className: q[`${wt}__icon`], children: Ml(i, r) }),
          /* @__PURE__ */ t("div", { className: q[`${wt}__title`], children: /* @__PURE__ */ t(A, { size: "sm", as: "div", children: h ? n : _ }) }),
          C && /* @__PURE__ */ t(
            "button",
            {
              className: q[`${wt}__collapse-button`],
              type: "button",
              "aria-label": "Collapse button",
              onClick: N,
              children: p ? /* @__PURE__ */ t(P, { source: cr }) : /* @__PURE__ */ t(P, { source: Ht })
            }
          ),
          i === "error" && /* @__PURE__ */ t("div", { className: q[`${wt}__actions-container`], children: /* @__PURE__ */ t(
            Ur,
            {
              status: i,
              onCloseButtonClick: s,
              onRetryButtonClick: m
            }
          ) })
        ] })
      }
    ),
    /* @__PURE__ */ t(F_, { component: null, children: p && /* @__PURE__ */ t(
      R_,
      {
        timeout: Rl,
        classNames: {
          enter: q[`${Se}__files--enter`],
          enterActive: q[`${Se}__files--enter-active`],
          exit: q[`${Se}__files--exit`],
          exitActive: q[`${Se}__files--exit-active`],
          exitDone: q[`${Se}__files--exit-done`]
        },
        children: /* @__PURE__ */ t("div", { className: q[`${Se}__files`], children: /* @__PURE__ */ t("div", { className: q[`${Se}__files-wrapper`], children: /* @__PURE__ */ t("div", { className: q[`${Se}__files__list`], children: e }) }) })
      }
    ) })
  ] });
}, sd = ({
  children: e,
  id: a,
  root: r,
  preserveTabOrder: _
}) => /* @__PURE__ */ t(ea, { id: a, root: r, preserveTabOrder: _, children: e });
export {
  Tl as ANIMATION_TIME,
  ss as Accordion,
  gs as ActionBar,
  hs as ActionCard,
  G_ as ActionMenu,
  Lr as ActionMenuItem,
  Hs as ActionModalContent,
  fs as Alert,
  bs as AppFrame,
  en as AppFrameProvider,
  xs as AutoComplete,
  Q_ as Avatar,
  rr as Badge,
  j as Button,
  Es as Card,
  $i as Checkbox,
  uc as DatePicker,
  Is as DatePickerRangeCalendarsWrapper,
  Ql as DesignToken,
  Ts as DetailsCard,
  As as DetailsCardInfo,
  ls as Display,
  od as EmailTagInput,
  $s as ExpirationCounter,
  ur as FieldDescription,
  jr as FieldError,
  Ds as FieldGroup,
  Fl as FileUploadProgress,
  Ur as FileUploadProgressActions,
  sd as FloatingPortal,
  Ps as Form,
  Fs as FormField,
  Rs as FormGroup,
  he as Heading,
  P as Icon,
  us as Info,
  di as Input,
  An as Interactive,
  Ms as InviteAgents,
  Os as Link,
  qr as Loader,
  Ns as MobileNavigation,
  Ls as Modal,
  Dc as ModalBase,
  x_ as ModalCloseButton,
  Us as ModalHeader,
  Gs as ModalPortal,
  Cs as Navigation,
  ys as NavigationGroup,
  ws as NavigationItem,
  W_ as NavigationTopBar,
  ii as NavigationTopBarAlert,
  ni as NavigationTopBarTitle,
  zs as NumericInput,
  Vs as OnboardingChecklist,
  Ss as Picker,
  X_ as PickerList,
  Ws as Popover,
  Ks as ProductSwitcher,
  Gc as ProductSwitcherProducts,
  Jc as ProgressBar,
  Qc as ProgressCircle,
  Xs as PromoBanner,
  Zs as PromoBannerV2,
  qs as RadioButton,
  ts as RadiusToken,
  pc as RangeDatePicker,
  ps as Reports,
  Zn as SIDE_NAVIGATION_ACTIVE_ITEM_TEST_ID,
  Xn as SIDE_NAVIGATION_ITEM_TEST_ID,
  qn as SIDE_NAVIGATION_PARENT_ICON_TEST_ID,
  rl as SearchInput,
  Bs as SegmentedControl,
  es as ShadowToken,
  vs as SideNavigation,
  ks as SideNavigationGroup,
  jn as SideNavigationItem,
  ds as Simple,
  Qs as SkeletonAvatar,
  Js as SkeletonText,
  js as SkeletonWrapper,
  Jl as SpacingToken,
  ed as StatusBadge,
  td as Switch,
  ad as Tab,
  _d as TabsList,
  rd as TabsWrapper,
  Z_ as Tag,
  yl as TagInput,
  A as Text,
  id as Textarea,
  Dt as ThemeClassName,
  is as ThemeProvider,
  Il as Toast,
  nd as ToastWrapper,
  Ut as Tooltip,
  _s as TransitionDelayToken,
  as as TransitionDurationToken,
  rs as TransitionTimingToken,
  cd as UpdateBadge,
  ld as UploadBar,
  ms as UserGuide,
  Gi as generateAvatarColor,
  cs as getDesignTokenWithOpacity,
  os as getThemeClassName,
  Xr as useAppFrame,
  Ys as useProductSwitcher,
  ns as useTheme
};
